/* eslint-disable react/no-unknown-property */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Buro2Icon = props => {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <SvgIcon {...props} viewBox="0 0 15 14">
      <defs>
        <clipPath id="clip1">
          <path d="M 0 0 L 14.675781 0 L 14.675781 13.984375 L 0 13.984375 Z M 0 0 " />
        </clipPath>
        <clipPath id="clip2">
          <path d="M 1.375 0 L 13.984375 0 L 13.984375 0.00390625 L 1.375 0.00390625 Z M 1.324219 0.00390625 L 14.015625 0.00390625 L 14.015625 0.0078125 L 1.324219 0.0078125 Z M 1.269531 0.0078125 L 14.039062 0.0078125 L 14.039062 0.0117188 L 1.269531 0.0117188 Z M 1.21875 0.0117188 L 14.0625 0.0117188 L 14.0625 0.015625 L 1.21875 0.015625 Z M 1.191406 0.015625 L 14.085938 0.015625 L 14.085938 0.0195312 L 1.191406 0.0195312 Z M 1.160156 0.0195312 L 14.109375 0.0195312 L 14.109375 0.0273438 L 1.160156 0.0273438 Z M 1.132812 0.0273438 L 14.121094 0.0273438 L 14.121094 0.03125 L 1.132812 0.03125 Z M 1.105469 0.03125 L 14.136719 0.03125 L 14.136719 0.0351562 L 1.105469 0.0351562 Z M 1.078125 0.0351562 L 14.148438 0.0351562 L 14.148438 0.0390625 L 1.078125 0.0390625 Z M 1.058594 0.0390625 L 14.160156 0.0390625 L 14.160156 0.0429688 L 1.058594 0.0429688 Z M 1.035156 0.0429688 L 14.175781 0.0429688 L 14.175781 0.046875 L 1.035156 0.046875 Z M 1.019531 0.046875 L 14.1875 0.046875 L 14.1875 0.0507812 L 1.019531 0.0507812 Z M 1 0.0507812 L 14.203125 0.0507812 L 14.203125 0.0546875 L 1 0.0546875 Z M 0.984375 0.0546875 L 14.210938 0.0546875 L 14.210938 0.0585938 L 0.984375 0.0585938 Z M 0.964844 0.0585938 L 14.222656 0.0585938 L 14.222656 0.0625 L 0.964844 0.0625 Z M 0.945312 0.0625 L 14.234375 0.0625 L 14.234375 0.0703125 L 0.945312 0.0703125 Z M 0.9375 0.0703125 L 14.242188 0.0703125 L 14.242188 0.0742188 L 0.9375 0.0742188 Z M 0.925781 0.0742188 L 14.253906 0.0742188 L 14.253906 0.078125 L 0.925781 0.078125 Z M 0.910156 0.078125 L 14.261719 0.078125 L 14.261719 0.0820312 L 0.910156 0.0820312 Z M 0.898438 0.0820312 L 14.273438 0.0820312 L 14.273438 0.0859375 L 0.898438 0.0859375 Z M 0.882812 0.0859375 L 14.285156 0.0859375 L 14.285156 0.0898438 L 0.882812 0.0898438 Z M 0.871094 0.0898438 L 14.292969 0.0898438 L 14.292969 0.09375 L 0.871094 0.09375 Z M 0.855469 0.09375 L 14.300781 0.09375 L 14.300781 0.0976562 L 0.855469 0.0976562 Z M 0.84375 0.0976562 L 14.3125 0.0976562 L 14.3125 0.101562 L 0.84375 0.101562 Z M 0.832031 0.101562 L 14.316406 0.101562 L 14.316406 0.105469 L 0.832031 0.105469 Z M 0.824219 0.105469 L 14.324219 0.105469 L 14.324219 0.109375 L 0.824219 0.109375 Z M 0.816406 0.109375 L 14.335938 0.109375 L 14.335938 0.117188 L 0.816406 0.117188 Z M 0.804688 0.117188 L 14.34375 0.117188 L 14.34375 0.121094 L 0.804688 0.121094 Z M 0.796875 0.121094 L 14.351562 0.121094 L 14.351562 0.125 L 0.796875 0.125 Z M 0.785156 0.125 L 14.355469 0.125 L 14.355469 0.128906 L 0.785156 0.128906 Z M 0.773438 0.128906 L 14.367188 0.128906 L 14.367188 0.132812 L 0.773438 0.132812 Z M 0.765625 0.132812 L 14.375 0.132812 L 14.375 0.136719 L 0.765625 0.136719 Z M 0.757812 0.136719 L 14.382812 0.136719 L 14.382812 0.140625 L 0.757812 0.140625 Z M 0.746094 0.140625 L 14.386719 0.140625 L 14.386719 0.144531 L 0.746094 0.144531 Z M 0.738281 0.144531 L 14.398438 0.144531 L 14.398438 0.148438 L 0.738281 0.148438 Z M 0.734375 0.148438 L 14.402344 0.148438 L 14.402344 0.152344 L 0.734375 0.152344 Z M 0.726562 0.152344 L 14.410156 0.152344 L 14.410156 0.160156 L 0.726562 0.160156 Z M 0.714844 0.160156 L 14.414062 0.160156 L 14.414062 0.164062 L 0.714844 0.164062 Z M 0.710938 0.164062 L 14.425781 0.164062 L 14.425781 0.167969 L 0.710938 0.167969 Z M 0.703125 0.167969 L 14.429688 0.167969 L 14.429688 0.171875 L 0.703125 0.171875 Z M 0.699219 0.171875 L 14.4375 0.171875 L 14.4375 0.175781 L 0.699219 0.175781 Z M 0.6875 0.175781 L 14.441406 0.175781 L 14.441406 0.179688 L 0.6875 0.179688 Z M 0.679688 0.179688 L 14.453125 0.179688 L 14.453125 0.183594 L 0.679688 0.183594 Z M 0.675781 0.183594 L 14.457031 0.183594 L 14.457031 0.1875 L 0.675781 0.1875 Z M 0.664062 0.1875 L 14.464844 0.1875 L 14.464844 0.191406 L 0.664062 0.191406 Z M 0.660156 0.191406 L 14.46875 0.191406 L 14.46875 0.195312 L 0.660156 0.195312 Z M 0.652344 0.195312 L 14.476562 0.195312 L 14.476562 0.199219 L 0.652344 0.199219 Z M 0.648438 0.199219 L 14.484375 0.199219 L 14.484375 0.207031 L 0.648438 0.207031 Z M 0.644531 0.207031 L 14.488281 0.207031 L 14.488281 0.210938 L 0.644531 0.210938 Z M 0.636719 0.210938 L 14.492188 0.210938 L 14.492188 0.214844 L 0.636719 0.214844 Z M 0.628906 0.214844 L 14.496094 0.214844 L 14.496094 0.21875 L 0.628906 0.21875 Z M 0.625 0.21875 L 14.507812 0.21875 L 14.507812 0.222656 L 0.625 0.222656 Z M 0.621094 0.222656 L 14.511719 0.222656 L 14.511719 0.226562 L 0.621094 0.226562 Z M 0.617188 0.226562 L 14.515625 0.226562 L 14.515625 0.230469 L 0.617188 0.230469 Z M 0.613281 0.230469 L 14.519531 0.230469 L 14.519531 0.234375 L 0.613281 0.234375 Z M 0.601562 0.234375 L 14.527344 0.234375 L 14.527344 0.238281 L 0.601562 0.238281 Z M 0.597656 0.238281 L 14.535156 0.238281 L 14.535156 0.242188 L 0.597656 0.242188 Z M 0.59375 0.242188 L 14.539062 0.242188 L 14.539062 0.25 L 0.59375 0.25 Z M 0.589844 0.25 L 14.542969 0.25 L 14.542969 0.253906 L 0.589844 0.253906 Z M 0.578125 0.253906 L 14.550781 0.253906 L 14.550781 0.257812 L 0.578125 0.257812 Z M 0.574219 0.257812 L 14.554688 0.257812 L 14.554688 0.261719 L 0.574219 0.261719 Z M 0.570312 0.261719 L 14.5625 0.261719 L 14.5625 0.265625 L 0.570312 0.265625 Z M 0.570312 0.265625 L 14.566406 0.265625 L 14.566406 0.269531 L 0.570312 0.269531 Z M 0.566406 0.269531 L 14.570312 0.269531 L 14.570312 0.273438 L 0.566406 0.273438 Z M 0.5625 0.273438 L 14.574219 0.273438 L 14.574219 0.277344 L 0.5625 0.277344 Z M 0.558594 0.277344 L 14.578125 0.277344 L 14.578125 0.28125 L 0.558594 0.28125 Z M 0.550781 0.28125 L 14.589844 0.28125 L 14.589844 0.285156 L 0.550781 0.285156 Z M 0.546875 0.285156 L 14.59375 0.285156 L 14.59375 0.289062 L 0.546875 0.289062 Z M 0.542969 0.289062 L 14.597656 0.289062 L 14.597656 0.296875 L 0.542969 0.296875 Z M 0.539062 0.296875 L 14.601562 0.296875 L 14.601562 0.300781 L 0.539062 0.300781 Z M 0.535156 0.300781 L 14.605469 0.300781 L 14.605469 0.304688 L 0.535156 0.304688 Z M 0.53125 0.304688 L 14.609375 0.304688 L 14.609375 0.308594 L 0.53125 0.308594 Z M 0.527344 0.308594 L 14.613281 0.308594 L 14.613281 0.3125 L 0.527344 0.3125 Z M 0.519531 0.3125 L 14.621094 0.3125 L 14.621094 0.316406 L 0.519531 0.316406 Z M 0.519531 0.316406 L 14.625 0.316406 L 14.625 0.320312 L 0.519531 0.320312 Z M 0.515625 0.320312 L 14.628906 0.320312 L 14.628906 0.324219 L 0.515625 0.324219 Z M 0.511719 0.324219 L 14.632812 0.324219 L 14.632812 0.328125 L 0.511719 0.328125 Z M 0.507812 0.328125 L 14.636719 0.328125 L 14.636719 0.332031 L 0.507812 0.332031 Z M 0.503906 0.332031 L 14.640625 0.332031 L 14.640625 0.339844 L 0.503906 0.339844 Z M 0.503906 0.339844 L 14.648438 0.339844 L 14.648438 0.34375 L 0.503906 0.34375 Z M 0.5 0.34375 L 14.652344 0.34375 L 14.652344 0.347656 L 0.5 0.347656 Z M 0.492188 0.347656 L 14.65625 0.347656 L 14.65625 0.351562 L 0.492188 0.351562 Z M 0.492188 0.351562 L 14.660156 0.351562 L 14.660156 0.355469 L 0.492188 0.355469 Z M 0.488281 0.355469 L 14.664062 0.355469 L 14.664062 0.359375 L 0.488281 0.359375 Z M 0.484375 0.359375 L 14.667969 0.359375 L 14.667969 0.363281 L 0.484375 0.363281 Z M 0.484375 0.363281 L 14.675781 0.363281 L 14.675781 0.367188 L 0.484375 0.367188 Z M 0.480469 0.367188 L 14.679688 0.367188 L 14.679688 0.371094 L 0.480469 0.371094 Z M 0.476562 0.371094 L 14.683594 0.371094 L 14.683594 0.375 L 0.476562 0.375 Z M 0.476562 0.375 L 14.6875 0.375 L 14.6875 0.378906 L 0.476562 0.378906 Z M 0.472656 0.378906 L 14.691406 0.378906 L 14.691406 0.386719 L 0.472656 0.386719 Z M 0.464844 0.386719 L 14.691406 0.386719 L 14.691406 0.390625 L 0.464844 0.390625 Z M 0.460938 0.390625 L 14.695312 0.390625 L 14.695312 0.394531 L 0.460938 0.394531 Z M 0.460938 0.394531 L 14.699219 0.394531 L 14.699219 0.398438 L 0.460938 0.398438 Z M 0.457031 0.398438 L 14.707031 0.398438 L 14.707031 0.402344 L 0.457031 0.402344 Z M 0.453125 0.402344 L 14.710938 0.402344 L 14.710938 0.40625 L 0.453125 0.40625 Z M 0.453125 0.40625 L 14.714844 0.40625 L 14.714844 0.410156 L 0.453125 0.410156 Z M 0.449219 0.410156 L 14.71875 0.410156 L 14.71875 0.414062 L 0.449219 0.414062 Z M 0.449219 0.414062 L 14.722656 0.414062 L 14.722656 0.417969 L 0.449219 0.417969 Z M 0.445312 0.417969 L 14.726562 0.417969 L 14.726562 0.429688 L 0.445312 0.429688 Z M 0.4375 0.429688 L 14.734375 0.429688 L 14.734375 0.433594 L 0.4375 0.433594 Z M 0.4375 0.433594 L 14.738281 0.433594 L 14.738281 0.4375 L 0.4375 0.4375 Z M 0.433594 0.4375 L 14.742188 0.4375 L 14.742188 0.441406 L 0.433594 0.441406 Z M 0.433594 0.441406 L 14.746094 0.441406 L 14.746094 0.445312 L 0.433594 0.445312 Z M 0.429688 0.445312 L 14.746094 0.445312 L 14.746094 0.449219 L 0.429688 0.449219 Z M 0.429688 0.449219 L 14.75 0.449219 L 14.75 0.453125 L 0.429688 0.453125 Z M 0.425781 0.453125 L 14.753906 0.453125 L 14.753906 0.457031 L 0.425781 0.457031 Z M 0.425781 0.457031 L 14.761719 0.457031 L 14.761719 0.460938 L 0.425781 0.460938 Z M 0.421875 0.460938 L 14.761719 0.460938 L 14.761719 0.464844 L 0.421875 0.464844 Z M 0.421875 0.464844 L 14.765625 0.464844 L 14.765625 0.46875 L 0.421875 0.46875 Z M 0.417969 0.46875 L 14.769531 0.46875 L 14.769531 0.476562 L 0.417969 0.476562 Z M 0.417969 0.476562 L 14.773438 0.476562 L 14.773438 0.480469 L 0.417969 0.480469 Z M 0.414062 0.480469 L 14.777344 0.480469 L 14.777344 0.488281 L 0.414062 0.488281 Z M 0.40625 0.488281 L 14.78125 0.488281 L 14.78125 0.492188 L 0.40625 0.492188 Z M 0.40625 0.492188 L 14.789062 0.492188 L 14.789062 0.496094 L 0.40625 0.496094 Z M 0.40625 0.496094 L 14.792969 0.496094 L 14.792969 0.5 L 0.40625 0.5 Z M 0.402344 0.5 L 14.792969 0.5 L 14.792969 0.503906 L 0.402344 0.503906 Z M 0.402344 0.503906 L 14.796875 0.503906 L 14.796875 0.507812 L 0.402344 0.507812 Z M 0.398438 0.507812 L 14.800781 0.507812 L 14.800781 0.519531 L 0.398438 0.519531 Z M 0.398438 0.519531 L 14.804688 0.519531 L 14.804688 0.523438 L 0.398438 0.523438 Z M 0.394531 0.523438 L 14.808594 0.523438 L 14.808594 0.53125 L 0.394531 0.53125 Z M 0.394531 0.53125 L 14.8125 0.53125 L 14.8125 0.535156 L 0.394531 0.535156 Z M 0.390625 0.535156 L 14.820312 0.535156 L 14.820312 0.542969 L 0.390625 0.542969 Z M 0.386719 0.542969 L 14.824219 0.542969 L 14.824219 0.546875 L 0.386719 0.546875 Z M 0.386719 0.546875 L 14.828125 0.546875 L 14.828125 0.554688 L 0.386719 0.554688 Z M 0.378906 0.554688 L 14.832031 0.554688 L 14.832031 0.5625 L 0.378906 0.5625 Z M 0.378906 0.5625 L 14.835938 0.5625 L 14.835938 0.570312 L 0.378906 0.570312 Z M 0.375 0.570312 L 14.839844 0.570312 L 14.839844 0.574219 L 0.375 0.574219 Z M 0.375 0.574219 L 14.847656 0.574219 L 14.847656 0.582031 L 0.375 0.582031 Z M 0.371094 0.582031 L 14.851562 0.582031 L 14.851562 0.589844 L 0.371094 0.589844 Z M 0.371094 0.589844 L 14.855469 0.589844 L 14.855469 0.597656 L 0.371094 0.597656 Z M 0.367188 0.597656 L 14.859375 0.597656 L 14.859375 0.601562 L 0.367188 0.601562 Z M 0.367188 0.601562 L 14.863281 0.601562 L 14.863281 0.613281 L 0.367188 0.613281 Z M 0.367188 0.613281 L 14.867188 0.613281 L 14.867188 0.617188 L 0.367188 0.617188 Z M 0.363281 0.617188 L 14.867188 0.617188 L 14.867188 0.621094 L 0.363281 0.621094 Z M 0.363281 0.621094 L 14.875 0.621094 L 14.875 0.628906 L 0.363281 0.628906 Z M 0.359375 0.628906 L 14.878906 0.628906 L 14.878906 0.632812 L 0.359375 0.632812 Z M 0.359375 0.632812 L 14.882812 0.632812 L 14.882812 0.640625 L 0.359375 0.640625 Z M 0.359375 0.640625 L 14.886719 0.640625 L 14.886719 0.644531 L 0.359375 0.644531 Z M 0.351562 0.644531 L 14.886719 0.644531 L 14.886719 0.648438 L 0.351562 0.648438 Z M 0.351562 0.648438 L 14.890625 0.648438 L 14.890625 0.660156 L 0.351562 0.660156 Z M 0.351562 0.660156 L 14.894531 0.660156 L 14.894531 0.664062 L 0.351562 0.664062 Z M 0.347656 0.664062 L 14.894531 0.664062 L 14.894531 0.667969 L 0.347656 0.667969 Z M 0.347656 0.667969 L 14.898438 0.667969 L 14.898438 0.675781 L 0.347656 0.675781 Z M 0.347656 0.675781 L 14.90625 0.675781 L 14.90625 0.679688 L 0.347656 0.679688 Z M 0.347656 0.679688 L 2.238281 0.679688 L 2.238281 0.683594 L 0.347656 0.683594 Z M 12.867188 0.679688 L 14.90625 0.679688 L 14.90625 0.683594 L 12.867188 0.683594 Z M 0.34375 0.683594 L 2.175781 0.683594 L 2.175781 0.6875 L 0.34375 0.6875 Z M 12.933594 0.683594 L 14.910156 0.683594 L 14.910156 0.6875 L 12.933594 0.6875 Z M 0.34375 0.6875 L 2.121094 0.6875 L 2.121094 0.691406 L 0.34375 0.691406 Z M 12.988281 0.6875 L 14.910156 0.6875 L 14.910156 0.691406 L 12.988281 0.691406 Z M 0.34375 0.691406 L 2.09375 0.691406 L 2.09375 0.699219 L 0.34375 0.699219 Z M 13.015625 0.691406 L 14.910156 0.691406 L 14.910156 0.699219 L 13.015625 0.699219 Z M 13.046875 0.699219 L 14.914062 0.699219 L 14.914062 0.703125 L 13.046875 0.703125 Z M 0.34375 0.699219 L 2.0625 0.699219 L 2.0625 0.703125 L 0.34375 0.703125 Z M 13.074219 0.703125 L 14.914062 0.703125 L 14.914062 0.707031 L 13.074219 0.707031 Z M 0.34375 0.703125 L 2.035156 0.703125 L 2.035156 0.707031 L 0.34375 0.707031 Z M 0.34375 0.707031 L 2.007812 0.707031 L 2.007812 0.710938 L 0.34375 0.710938 Z M 13.105469 0.707031 L 14.917969 0.707031 L 14.917969 0.710938 L 13.105469 0.710938 Z M 13.128906 0.710938 L 14.917969 0.710938 L 14.917969 0.714844 L 13.128906 0.714844 Z M 0.339844 0.710938 L 1.980469 0.710938 L 1.980469 0.714844 L 0.339844 0.714844 Z M 13.148438 0.714844 L 14.921875 0.714844 L 14.921875 0.71875 L 13.148438 0.71875 Z M 0.339844 0.714844 L 1.964844 0.714844 L 1.964844 0.71875 L 0.339844 0.71875 Z M 13.160156 0.71875 L 14.921875 0.71875 L 14.921875 0.722656 L 13.160156 0.722656 Z M 0.339844 0.71875 L 1.949219 0.71875 L 1.949219 0.722656 L 0.339844 0.722656 Z M 13.179688 0.722656 L 14.925781 0.722656 L 14.925781 0.726562 L 13.179688 0.726562 Z M 0.339844 0.722656 L 1.929688 0.722656 L 1.929688 0.726562 L 0.339844 0.726562 Z M 0.339844 0.726562 L 1.910156 0.726562 L 1.910156 0.730469 L 0.339844 0.730469 Z M 13.199219 0.726562 L 14.925781 0.726562 L 14.925781 0.730469 L 13.199219 0.730469 Z M 0.339844 0.730469 L 1.898438 0.730469 L 1.898438 0.734375 L 0.339844 0.734375 Z M 13.214844 0.730469 L 14.925781 0.730469 L 14.925781 0.734375 L 13.214844 0.734375 Z M 13.234375 0.734375 L 14.933594 0.734375 L 14.933594 0.742188 L 13.234375 0.742188 Z M 0.335938 0.734375 L 1.878906 0.734375 L 1.878906 0.742188 L 0.335938 0.742188 Z M 0.335938 0.742188 L 1.863281 0.742188 L 1.863281 0.746094 L 0.335938 0.746094 Z M 13.25 0.742188 L 14.933594 0.742188 L 14.933594 0.746094 L 13.25 0.746094 Z M 13.265625 0.746094 L 14.9375 0.746094 L 14.9375 0.75 L 13.265625 0.75 Z M 0.335938 0.746094 L 1.847656 0.746094 L 1.847656 0.75 L 0.335938 0.75 Z M 13.273438 0.75 L 14.9375 0.75 L 14.9375 0.753906 L 13.273438 0.753906 Z M 0.335938 0.75 L 1.835938 0.75 L 1.835938 0.753906 L 0.335938 0.753906 Z M 13.289062 0.753906 L 14.9375 0.753906 L 14.9375 0.757812 L 13.289062 0.757812 Z M 0.335938 0.753906 L 1.820312 0.753906 L 1.820312 0.757812 L 0.335938 0.757812 Z M 0.335938 0.757812 L 1.8125 0.757812 L 1.8125 0.761719 L 0.335938 0.761719 Z M 13.300781 0.757812 L 14.941406 0.757812 L 14.941406 0.761719 L 13.300781 0.761719 Z M 13.316406 0.761719 L 14.941406 0.761719 L 14.941406 0.765625 L 13.316406 0.765625 Z M 0.332031 0.761719 L 1.796875 0.761719 L 1.796875 0.765625 L 0.332031 0.765625 Z M 13.324219 0.765625 L 14.941406 0.765625 L 14.941406 0.769531 L 13.324219 0.769531 Z M 0.332031 0.765625 L 1.785156 0.765625 L 1.785156 0.769531 L 0.332031 0.769531 Z M 13.335938 0.769531 L 14.945312 0.769531 L 14.945312 0.773438 L 13.335938 0.773438 Z M 0.332031 0.769531 L 1.773438 0.769531 L 1.773438 0.773438 L 0.332031 0.773438 Z M 13.351562 0.773438 L 14.945312 0.773438 L 14.945312 0.777344 L 13.351562 0.777344 Z M 0.332031 0.773438 L 1.761719 0.773438 L 1.761719 0.777344 L 0.332031 0.777344 Z M 13.359375 0.777344 L 14.945312 0.777344 L 14.945312 0.78125 L 13.359375 0.78125 Z M 0.332031 0.777344 L 1.75 0.777344 L 1.75 0.78125 L 0.332031 0.78125 Z M 13.375 0.78125 L 14.949219 0.78125 L 14.949219 0.789062 L 13.375 0.789062 Z M 0.332031 0.78125 L 1.738281 0.78125 L 1.738281 0.789062 L 0.332031 0.789062 Z M 0.332031 0.789062 L 1.726562 0.789062 L 1.726562 0.792969 L 0.332031 0.792969 Z M 13.386719 0.789062 L 14.949219 0.789062 L 14.949219 0.792969 L 13.386719 0.792969 Z M 13.398438 0.792969 L 14.949219 0.792969 L 14.949219 0.796875 L 13.398438 0.796875 Z M 0.324219 0.792969 L 1.710938 0.792969 L 1.710938 0.796875 L 0.324219 0.796875 Z M 13.40625 0.796875 L 14.953125 0.796875 L 14.953125 0.800781 L 13.40625 0.800781 Z M 0.324219 0.796875 L 1.703125 0.796875 L 1.703125 0.800781 L 0.324219 0.800781 Z M 13.414062 0.800781 L 14.953125 0.800781 L 14.953125 0.804688 L 13.414062 0.804688 Z M 0.324219 0.800781 L 1.695312 0.800781 L 1.695312 0.804688 L 0.324219 0.804688 Z M 13.425781 0.804688 L 14.953125 0.804688 L 14.953125 0.808594 L 13.425781 0.808594 Z M 0.324219 0.804688 L 1.683594 0.804688 L 1.683594 0.808594 L 0.324219 0.808594 Z M 13.433594 0.808594 L 14.960938 0.808594 L 14.960938 0.8125 L 13.433594 0.8125 Z M 0.324219 0.808594 L 1.675781 0.808594 L 1.675781 0.8125 L 0.324219 0.8125 Z M 13.441406 0.8125 L 14.960938 0.8125 L 14.960938 0.816406 L 13.441406 0.816406 Z M 0.324219 0.8125 L 1.667969 0.8125 L 1.667969 0.816406 L 0.324219 0.816406 Z M 13.449219 0.816406 L 14.960938 0.816406 L 14.960938 0.820312 L 13.449219 0.820312 Z M 0.324219 0.816406 L 1.65625 0.816406 L 1.65625 0.820312 L 0.324219 0.820312 Z M 13.460938 0.820312 L 14.964844 0.820312 L 14.964844 0.824219 L 13.460938 0.824219 Z M 0.324219 0.820312 L 1.648438 0.820312 L 1.648438 0.824219 L 0.324219 0.824219 Z M 13.46875 0.824219 L 14.964844 0.824219 L 14.964844 0.828125 L 13.46875 0.828125 Z M 0.324219 0.824219 L 1.640625 0.824219 L 1.640625 0.828125 L 0.324219 0.828125 Z M 13.476562 0.828125 L 14.964844 0.828125 L 14.964844 0.835938 L 13.476562 0.835938 Z M 0.324219 0.828125 L 1.628906 0.828125 L 1.628906 0.835938 L 0.324219 0.835938 Z M 13.488281 0.835938 L 14.96875 0.835938 L 14.96875 0.839844 L 13.488281 0.839844 Z M 0.324219 0.835938 L 1.621094 0.835938 L 1.621094 0.839844 L 0.324219 0.839844 Z M 13.496094 0.839844 L 14.96875 0.839844 L 14.96875 0.84375 L 13.496094 0.84375 Z M 0.324219 0.839844 L 1.613281 0.839844 L 1.613281 0.84375 L 0.324219 0.84375 Z M 13.503906 0.84375 L 14.96875 0.84375 L 14.96875 0.847656 L 13.503906 0.847656 Z M 0.320312 0.84375 L 1.601562 0.84375 L 1.601562 0.847656 L 0.320312 0.847656 Z M 13.515625 0.847656 L 14.96875 0.847656 L 14.96875 0.851562 L 13.515625 0.851562 Z M 0.320312 0.847656 L 1.59375 0.847656 L 1.59375 0.851562 L 0.320312 0.851562 Z M 13.523438 0.851562 L 14.972656 0.851562 L 14.972656 0.855469 L 13.523438 0.855469 Z M 0.320312 0.851562 L 1.585938 0.851562 L 1.585938 0.855469 L 0.320312 0.855469 Z M 0.320312 0.855469 L 1.574219 0.855469 L 1.574219 0.859375 L 0.320312 0.859375 Z M 13.527344 0.855469 L 14.972656 0.855469 L 14.972656 0.859375 L 13.527344 0.859375 Z M 13.535156 0.859375 L 14.972656 0.859375 L 14.972656 0.863281 L 13.535156 0.863281 Z M 0.320312 0.859375 L 1.570312 0.859375 L 1.570312 0.863281 L 0.320312 0.863281 Z M 13.546875 0.863281 L 14.972656 0.863281 L 14.972656 0.867188 L 13.546875 0.867188 Z M 0.320312 0.863281 L 1.5625 0.863281 L 1.5625 0.867188 L 0.320312 0.867188 Z M 0.320312 0.867188 L 1.558594 0.867188 L 1.558594 0.871094 L 0.320312 0.871094 Z M 13.550781 0.867188 L 14.972656 0.867188 L 14.972656 0.871094 L 13.550781 0.871094 Z M 0.320312 0.871094 L 1.550781 0.871094 L 1.550781 0.878906 L 0.320312 0.878906 Z M 13.558594 0.871094 L 14.976562 0.871094 L 14.976562 0.878906 L 13.558594 0.878906 Z M 0.320312 0.878906 L 1.539062 0.878906 L 1.539062 0.882812 L 0.320312 0.882812 Z M 13.570312 0.878906 L 14.976562 0.878906 L 14.976562 0.882812 L 13.570312 0.882812 Z M 0.320312 0.882812 L 1.535156 0.882812 L 1.535156 0.886719 L 0.320312 0.886719 Z M 13.574219 0.882812 L 14.976562 0.882812 L 14.976562 0.886719 L 13.574219 0.886719 Z M 0.320312 0.886719 L 1.527344 0.886719 L 1.527344 0.890625 L 0.320312 0.890625 Z M 13.582031 0.886719 L 14.976562 0.886719 L 14.976562 0.890625 L 13.582031 0.890625 Z M 13.585938 0.890625 L 14.976562 0.890625 L 14.976562 0.894531 L 13.585938 0.894531 Z M 0.316406 0.890625 L 1.515625 0.890625 L 1.515625 0.894531 L 0.316406 0.894531 Z M 13.597656 0.894531 L 14.980469 0.894531 L 14.980469 0.898438 L 13.597656 0.898438 Z M 0.316406 0.894531 L 1.511719 0.894531 L 1.511719 0.898438 L 0.316406 0.898438 Z M 0.316406 0.898438 L 1.503906 0.898438 L 1.503906 0.902344 L 0.316406 0.902344 Z M 13.605469 0.898438 L 14.980469 0.898438 L 14.980469 0.902344 L 13.605469 0.902344 Z M 13.609375 0.902344 L 14.980469 0.902344 L 14.980469 0.90625 L 13.609375 0.90625 Z M 0.316406 0.902344 L 1.496094 0.902344 L 1.496094 0.90625 L 0.316406 0.90625 Z M 13.617188 0.90625 L 14.980469 0.90625 L 14.980469 0.910156 L 13.617188 0.910156 Z M 0.316406 0.90625 L 1.488281 0.90625 L 1.488281 0.910156 L 0.316406 0.910156 Z M 13.625 0.910156 L 14.980469 0.910156 L 14.980469 0.914062 L 13.625 0.914062 Z M 0.316406 0.910156 L 1.480469 0.910156 L 1.480469 0.914062 L 0.316406 0.914062 Z M 13.632812 0.914062 L 14.988281 0.914062 L 14.988281 0.921875 L 13.632812 0.921875 Z M 0.316406 0.914062 L 1.476562 0.914062 L 1.476562 0.921875 L 0.316406 0.921875 Z M 13.636719 0.921875 L 14.988281 0.921875 L 14.988281 0.925781 L 13.636719 0.925781 Z M 0.316406 0.921875 L 1.46875 0.921875 L 1.46875 0.925781 L 0.316406 0.925781 Z M 13.640625 0.925781 L 14.988281 0.925781 L 14.988281 0.929688 L 13.640625 0.929688 Z M 0.316406 0.925781 L 1.464844 0.925781 L 1.464844 0.929688 L 0.316406 0.929688 Z M 13.648438 0.929688 L 14.988281 0.929688 L 14.988281 0.933594 L 13.648438 0.933594 Z M 0.316406 0.929688 L 1.453125 0.929688 L 1.453125 0.933594 L 0.316406 0.933594 Z M 13.65625 0.933594 L 14.988281 0.933594 L 14.988281 0.9375 L 13.65625 0.9375 Z M 0.316406 0.933594 L 1.449219 0.933594 L 1.449219 0.9375 L 0.316406 0.9375 Z M 13.664062 0.9375 L 14.988281 0.9375 L 14.988281 0.941406 L 13.664062 0.941406 Z M 0.316406 0.9375 L 1.445312 0.9375 L 1.445312 0.941406 L 0.316406 0.941406 Z M 13.667969 0.941406 L 14.992188 0.941406 L 14.992188 0.945312 L 13.667969 0.945312 Z M 0.316406 0.941406 L 1.4375 0.941406 L 1.4375 0.945312 L 0.316406 0.945312 Z M 13.671875 0.945312 L 14.992188 0.945312 L 14.992188 0.949219 L 13.671875 0.949219 Z M 0.316406 0.945312 L 1.429688 0.945312 L 1.429688 0.949219 L 0.316406 0.949219 Z M 13.683594 0.949219 L 14.992188 0.949219 L 14.992188 0.953125 L 13.683594 0.953125 Z M 0.316406 0.949219 L 1.425781 0.949219 L 1.425781 0.953125 L 0.316406 0.953125 Z M 0.316406 0.953125 L 1.417969 0.953125 L 1.417969 0.957031 L 0.316406 0.957031 Z M 13.6875 0.953125 L 14.992188 0.953125 L 14.992188 0.957031 L 13.6875 0.957031 Z M 13.691406 0.957031 L 14.992188 0.957031 L 14.992188 0.960938 L 13.691406 0.960938 Z M 0.316406 0.957031 L 1.414062 0.957031 L 1.414062 0.960938 L 0.316406 0.960938 Z M 13.699219 0.960938 L 14.992188 0.960938 L 14.992188 0.96875 L 13.699219 0.96875 Z M 0.316406 0.960938 L 1.410156 0.960938 L 1.410156 0.96875 L 0.316406 0.96875 Z M 13.703125 0.96875 L 14.992188 0.96875 L 14.992188 0.972656 L 13.703125 0.972656 Z M 0.316406 0.96875 L 1.398438 0.96875 L 1.398438 0.972656 L 0.316406 0.972656 Z M 0.316406 0.972656 L 1.394531 0.972656 L 1.394531 0.976562 L 0.316406 0.976562 Z M 13.710938 0.972656 L 14.992188 0.972656 L 14.992188 0.976562 L 13.710938 0.976562 Z M 0.316406 0.976562 L 1.390625 0.976562 L 1.390625 0.980469 L 0.316406 0.980469 Z M 13.71875 0.976562 L 14.992188 0.976562 L 14.992188 0.980469 L 13.71875 0.980469 Z M 0.316406 0.980469 L 1.382812 0.980469 L 1.382812 0.984375 L 0.316406 0.984375 Z M 13.722656 0.980469 L 14.992188 0.980469 L 14.992188 0.984375 L 13.722656 0.984375 Z M 0.316406 0.984375 L 1.375 0.984375 L 1.375 0.988281 L 0.316406 0.988281 Z M 13.726562 0.984375 L 14.992188 0.984375 L 14.992188 0.988281 L 13.726562 0.988281 Z M 13.730469 0.988281 L 14.992188 0.988281 L 14.992188 0.992188 L 13.730469 0.992188 Z M 0.316406 0.988281 L 1.371094 0.988281 L 1.371094 0.992188 L 0.316406 0.992188 Z M 13.738281 0.992188 L 14.992188 0.992188 L 14.992188 0.996094 L 13.738281 0.996094 Z M 0.316406 0.992188 L 1.363281 0.992188 L 1.363281 0.996094 L 0.316406 0.996094 Z M 0.316406 0.996094 L 1.359375 0.996094 L 1.359375 1 L 0.316406 1 Z M 13.746094 0.996094 L 14.992188 0.996094 L 14.992188 1 L 13.746094 1 Z M 13.75 1 L 14.992188 1 L 14.992188 1.003906 L 13.75 1.003906 Z M 0.316406 1 L 1.355469 1 L 1.355469 1.003906 L 0.316406 1.003906 Z M 13.753906 1.003906 L 14.992188 1.003906 L 14.992188 1.011719 L 13.753906 1.011719 Z M 0.316406 1.003906 L 1.34375 1.003906 L 1.34375 1.011719 L 0.316406 1.011719 Z M 13.757812 1.011719 L 14.992188 1.011719 L 14.992188 1.015625 L 13.757812 1.015625 Z M 0.316406 1.011719 L 1.339844 1.011719 L 1.339844 1.015625 L 0.316406 1.015625 Z M 13.761719 1.015625 L 14.992188 1.015625 L 14.992188 1.019531 L 13.761719 1.019531 Z M 0.316406 1.015625 L 1.335938 1.015625 L 1.335938 1.019531 L 0.316406 1.019531 Z M 0.316406 1.019531 L 1.332031 1.019531 L 1.332031 1.023438 L 0.316406 1.023438 Z M 13.769531 1.019531 L 14.992188 1.019531 L 14.992188 1.023438 L 13.769531 1.023438 Z M 13.773438 1.023438 L 14.992188 1.023438 L 14.992188 1.027344 L 13.773438 1.027344 Z M 0.316406 1.023438 L 1.328125 1.023438 L 1.328125 1.027344 L 0.316406 1.027344 Z M 13.777344 1.027344 L 14.992188 1.027344 L 14.992188 1.03125 L 13.777344 1.03125 Z M 0.316406 1.027344 L 1.324219 1.027344 L 1.324219 1.03125 L 0.316406 1.03125 Z M 13.78125 1.03125 L 14.992188 1.03125 L 14.992188 1.035156 L 13.78125 1.035156 Z M 0.316406 1.03125 L 1.316406 1.03125 L 1.316406 1.035156 L 0.316406 1.035156 Z M 13.785156 1.035156 L 14.992188 1.035156 L 14.992188 1.039062 L 13.785156 1.039062 Z M 0.316406 1.035156 L 1.3125 1.035156 L 1.3125 1.039062 L 0.316406 1.039062 Z M 0.316406 1.039062 L 1.308594 1.039062 L 1.308594 1.042969 L 0.316406 1.042969 Z M 13.796875 1.039062 L 14.992188 1.039062 L 14.992188 1.042969 L 13.796875 1.042969 Z M 13.800781 1.042969 L 14.992188 1.042969 L 14.992188 1.046875 L 13.800781 1.046875 Z M 0.316406 1.042969 L 1.300781 1.042969 L 1.300781 1.046875 L 0.316406 1.046875 Z M 13.804688 1.046875 L 14.992188 1.046875 L 14.992188 1.050781 L 13.804688 1.050781 Z M 0.316406 1.046875 L 1.296875 1.046875 L 1.296875 1.050781 L 0.316406 1.050781 Z M 13.808594 1.050781 L 14.992188 1.050781 L 14.992188 1.058594 L 13.808594 1.058594 Z M 0.316406 1.050781 L 1.289062 1.050781 L 1.289062 1.058594 L 0.316406 1.058594 Z M 13.8125 1.058594 L 14.992188 1.058594 L 14.992188 1.0625 L 13.8125 1.0625 Z M 0.316406 1.058594 L 1.285156 1.058594 L 1.285156 1.0625 L 0.316406 1.0625 Z M 13.816406 1.0625 L 14.992188 1.0625 L 14.992188 1.066406 L 13.816406 1.066406 Z M 0.316406 1.0625 L 1.28125 1.0625 L 1.28125 1.066406 L 0.316406 1.066406 Z M 13.824219 1.066406 L 14.992188 1.066406 L 14.992188 1.070312 L 13.824219 1.070312 Z M 0.316406 1.066406 L 1.277344 1.066406 L 1.277344 1.070312 L 0.316406 1.070312 Z M 13.828125 1.070312 L 14.992188 1.070312 L 14.992188 1.074219 L 13.828125 1.074219 Z M 0.316406 1.070312 L 1.273438 1.070312 L 1.273438 1.074219 L 0.316406 1.074219 Z M 13.832031 1.074219 L 14.992188 1.074219 L 14.992188 1.078125 L 13.832031 1.078125 Z M 0.316406 1.074219 L 1.269531 1.074219 L 1.269531 1.078125 L 0.316406 1.078125 Z M 13.835938 1.078125 L 14.992188 1.078125 L 14.992188 1.082031 L 13.835938 1.082031 Z M 0.316406 1.078125 L 1.261719 1.078125 L 1.261719 1.082031 L 0.316406 1.082031 Z M 13.839844 1.082031 L 14.992188 1.082031 L 14.992188 1.085938 L 13.839844 1.085938 Z M 0.316406 1.082031 L 1.253906 1.082031 L 1.253906 1.085938 L 0.316406 1.085938 Z M 13.84375 1.085938 L 14.992188 1.085938 L 14.992188 1.089844 L 13.84375 1.089844 Z M 0.316406 1.085938 L 1.25 1.085938 L 1.25 1.089844 L 0.316406 1.089844 Z M 13.851562 1.089844 L 14.992188 1.089844 L 14.992188 1.09375 L 13.851562 1.09375 Z M 0.316406 1.089844 L 1.246094 1.089844 L 1.246094 1.09375 L 0.316406 1.09375 Z M 13.855469 1.09375 L 14.992188 1.09375 L 14.992188 1.097656 L 13.855469 1.097656 Z M 0.316406 1.09375 L 1.242188 1.09375 L 1.242188 1.097656 L 0.316406 1.097656 Z M 13.859375 1.097656 L 14.992188 1.097656 L 14.992188 1.105469 L 13.859375 1.105469 Z M 0.316406 1.097656 L 1.238281 1.097656 L 1.238281 1.105469 L 0.316406 1.105469 Z M 13.863281 1.105469 L 14.992188 1.105469 L 14.992188 1.109375 L 13.863281 1.109375 Z M 0.316406 1.105469 L 1.230469 1.105469 L 1.230469 1.113281 L 0.316406 1.113281 Z M 0.316406 1.113281 L 1.226562 1.113281 L 1.226562 1.117188 L 0.316406 1.117188 Z M 13.867188 1.109375 L 14.992188 1.109375 L 14.992188 1.117188 L 13.867188 1.117188 Z M 13.871094 1.117188 L 14.992188 1.117188 L 14.992188 1.121094 L 13.871094 1.121094 Z M 0.316406 1.117188 L 1.222656 1.117188 L 1.222656 1.121094 L 0.316406 1.121094 Z M 0.316406 1.121094 L 1.21875 1.121094 L 1.21875 1.125 L 0.316406 1.125 Z M 13.875 1.121094 L 14.992188 1.121094 L 14.992188 1.125 L 13.875 1.125 Z M 13.882812 1.125 L 14.992188 1.125 L 14.992188 1.128906 L 13.882812 1.128906 Z M 0.316406 1.125 L 1.214844 1.125 L 1.214844 1.128906 L 0.316406 1.128906 Z M 13.886719 1.128906 L 14.992188 1.128906 L 14.992188 1.132812 L 13.886719 1.132812 Z M 0.316406 1.128906 L 1.210938 1.128906 L 1.210938 1.132812 L 0.316406 1.132812 Z M 13.890625 1.132812 L 14.992188 1.132812 L 14.992188 1.136719 L 13.890625 1.136719 Z M 0.316406 1.132812 L 1.203125 1.132812 L 1.203125 1.136719 L 0.316406 1.136719 Z M 13.894531 1.136719 L 14.992188 1.136719 L 14.992188 1.140625 L 13.894531 1.140625 Z M 0.316406 1.136719 L 1.199219 1.136719 L 1.199219 1.140625 L 0.316406 1.140625 Z M 13.898438 1.140625 L 14.992188 1.140625 L 14.992188 1.148438 L 13.898438 1.148438 Z M 0.316406 1.140625 L 1.195312 1.140625 L 1.195312 1.148438 L 0.316406 1.148438 Z M 13.902344 1.148438 L 14.992188 1.148438 L 14.992188 1.152344 L 13.902344 1.152344 Z M 0.316406 1.148438 L 1.191406 1.148438 L 1.191406 1.152344 L 0.316406 1.152344 Z M 13.910156 1.152344 L 14.992188 1.152344 L 14.992188 1.15625 L 13.910156 1.15625 Z M 0.316406 1.152344 L 1.1875 1.152344 L 1.1875 1.15625 L 0.316406 1.15625 Z M 0.316406 1.15625 L 1.183594 1.15625 L 1.183594 1.160156 L 0.316406 1.160156 Z M 0.316406 1.160156 L 1.175781 1.160156 L 1.175781 1.164062 L 0.316406 1.164062 Z M 13.914062 1.15625 L 14.992188 1.15625 L 14.992188 1.164062 L 13.914062 1.164062 Z M 13.917969 1.164062 L 14.992188 1.164062 L 14.992188 1.167969 L 13.917969 1.167969 Z M 13.921875 1.167969 L 14.992188 1.167969 L 14.992188 1.171875 L 13.921875 1.171875 Z M 0.316406 1.164062 L 1.171875 1.164062 L 1.171875 1.171875 L 0.316406 1.171875 Z M 13.925781 1.171875 L 14.992188 1.171875 L 14.992188 1.175781 L 13.925781 1.175781 Z M 0.316406 1.171875 L 1.167969 1.171875 L 1.167969 1.175781 L 0.316406 1.175781 Z M 0.316406 1.175781 L 1.164062 1.175781 L 1.164062 1.179688 L 0.316406 1.179688 Z M 0.316406 1.179688 L 1.160156 1.179688 L 1.160156 1.183594 L 0.316406 1.183594 Z M 13.929688 1.175781 L 14.992188 1.175781 L 14.992188 1.183594 L 13.929688 1.183594 Z M 13.9375 1.183594 L 14.992188 1.183594 L 14.992188 1.191406 L 13.9375 1.191406 Z M 0.316406 1.183594 L 1.15625 1.183594 L 1.15625 1.191406 L 0.316406 1.191406 Z M 0.316406 1.191406 L 1.148438 1.191406 L 1.148438 1.195312 L 0.316406 1.195312 Z M 13.941406 1.191406 L 14.992188 1.191406 L 14.992188 1.195312 L 13.941406 1.195312 Z M 0.316406 1.195312 L 1.144531 1.195312 L 1.144531 1.199219 L 0.316406 1.199219 Z M 13.945312 1.195312 L 14.992188 1.195312 L 14.992188 1.203125 L 13.945312 1.203125 Z M 13.949219 1.203125 L 14.992188 1.203125 L 14.992188 1.207031 L 13.949219 1.207031 Z M 0.316406 1.199219 L 1.140625 1.199219 L 1.140625 1.207031 L 0.316406 1.207031 Z M 13.953125 1.207031 L 14.992188 1.207031 L 14.992188 1.210938 L 13.953125 1.210938 Z M 0.316406 1.207031 L 1.136719 1.207031 L 1.136719 1.210938 L 0.316406 1.210938 Z M 0.316406 1.210938 L 1.132812 1.210938 L 1.132812 1.214844 L 0.316406 1.214844 Z M 13.957031 1.210938 L 14.992188 1.210938 L 14.992188 1.21875 L 13.957031 1.21875 Z M 13.964844 1.21875 L 14.992188 1.21875 L 14.992188 1.222656 L 13.964844 1.222656 Z M 0.316406 1.214844 L 1.128906 1.214844 L 1.128906 1.222656 L 0.316406 1.222656 Z M 13.96875 1.222656 L 14.992188 1.222656 L 14.992188 1.226562 L 13.96875 1.226562 Z M 0.316406 1.222656 L 1.125 1.222656 L 1.125 1.226562 L 0.316406 1.226562 Z M 0.316406 1.226562 L 1.117188 1.226562 L 1.117188 1.230469 L 0.316406 1.230469 Z M 13.972656 1.226562 L 14.992188 1.226562 L 14.992188 1.238281 L 13.972656 1.238281 Z M 13.976562 1.238281 L 14.992188 1.238281 L 14.992188 1.242188 L 13.976562 1.242188 Z M 0.316406 1.230469 L 1.113281 1.230469 L 1.113281 1.242188 L 0.316406 1.242188 Z M 13.980469 1.242188 L 14.992188 1.242188 L 14.992188 1.246094 L 13.980469 1.246094 Z M 0.316406 1.242188 L 1.109375 1.242188 L 1.109375 1.246094 L 0.316406 1.246094 Z M 0.316406 1.246094 L 1.105469 1.246094 L 1.105469 1.25 L 0.316406 1.25 Z M 0.316406 1.25 L 1.101562 1.25 L 1.101562 1.253906 L 0.316406 1.253906 Z M 13.984375 1.246094 L 14.992188 1.246094 L 14.992188 1.253906 L 13.984375 1.253906 Z M 13.988281 1.253906 L 14.992188 1.253906 L 14.992188 1.257812 L 13.988281 1.257812 Z M 13.996094 1.257812 L 14.992188 1.257812 L 14.992188 1.261719 L 13.996094 1.261719 Z M 0.316406 1.253906 L 1.097656 1.253906 L 1.097656 1.261719 L 0.316406 1.261719 Z M 0.316406 1.261719 L 1.089844 1.261719 L 1.089844 1.265625 L 0.316406 1.265625 Z M 0.316406 1.265625 L 1.085938 1.265625 L 1.085938 1.269531 L 0.316406 1.269531 Z M 14 1.261719 L 14.992188 1.261719 L 14.992188 1.269531 L 14 1.269531 Z M 14.003906 1.269531 L 14.992188 1.269531 L 14.992188 1.273438 L 14.003906 1.273438 Z M 0.316406 1.269531 L 1.082031 1.269531 L 1.082031 1.277344 L 0.316406 1.277344 Z M 0.316406 1.277344 L 1.078125 1.277344 L 1.078125 1.285156 L 0.316406 1.285156 Z M 14.007812 1.273438 L 14.992188 1.273438 L 14.992188 1.285156 L 14.007812 1.285156 Z M 0.316406 1.285156 L 1.074219 1.285156 L 1.074219 1.289062 L 0.316406 1.289062 Z M 14.011719 1.285156 L 14.992188 1.285156 L 14.992188 1.292969 L 14.011719 1.292969 Z M 14.015625 1.292969 L 14.992188 1.292969 L 14.992188 1.296875 L 14.015625 1.296875 Z M 0.316406 1.289062 L 1.070312 1.289062 L 1.070312 1.296875 L 0.316406 1.296875 Z M 0.316406 1.296875 L 1.0625 1.296875 L 1.0625 1.300781 L 0.316406 1.300781 Z M 14.023438 1.296875 L 14.992188 1.296875 L 14.992188 1.304688 L 14.023438 1.304688 Z M 0.316406 1.300781 L 1.058594 1.300781 L 1.058594 1.308594 L 0.316406 1.308594 Z M 0.316406 1.308594 L 1.054688 1.308594 L 1.054688 1.3125 L 0.316406 1.3125 Z M 14.027344 1.304688 L 14.992188 1.304688 L 14.992188 1.3125 L 14.027344 1.3125 Z M 14.03125 1.3125 L 14.992188 1.3125 L 14.992188 1.316406 L 14.03125 1.316406 Z M 0.316406 1.3125 L 1.050781 1.3125 L 1.050781 1.320312 L 0.316406 1.320312 Z M 0.316406 1.320312 L 1.046875 1.320312 L 1.046875 1.328125 L 0.316406 1.328125 Z M 14.035156 1.316406 L 14.992188 1.316406 L 14.992188 1.328125 L 14.035156 1.328125 Z M 14.039062 1.328125 L 14.992188 1.328125 L 14.992188 1.332031 L 14.039062 1.332031 Z M 0.316406 1.328125 L 1.042969 1.328125 L 1.042969 1.335938 L 0.316406 1.335938 Z M 0.316406 1.335938 L 1.035156 1.335938 L 1.035156 1.339844 L 0.316406 1.339844 Z M 14.042969 1.332031 L 14.992188 1.332031 L 14.992188 1.339844 L 14.042969 1.339844 Z M 14.050781 1.339844 L 14.992188 1.339844 L 14.992188 1.347656 L 14.050781 1.347656 Z M 0.316406 1.339844 L 1.03125 1.339844 L 1.03125 1.347656 L 0.316406 1.347656 Z M 14.054688 1.347656 L 14.992188 1.347656 L 14.992188 1.351562 L 14.054688 1.351562 Z M 0.316406 1.347656 L 1.027344 1.347656 L 1.027344 1.355469 L 0.316406 1.355469 Z M 0.316406 1.355469 L 1.023438 1.355469 L 1.023438 1.359375 L 0.316406 1.359375 Z M 14.058594 1.351562 L 14.992188 1.351562 L 14.992188 1.359375 L 14.058594 1.359375 Z M 14.0625 1.359375 L 14.992188 1.359375 L 14.992188 1.371094 L 14.0625 1.371094 Z M 0.316406 1.359375 L 1.019531 1.359375 L 1.019531 1.371094 L 0.316406 1.371094 Z M 14.066406 1.371094 L 14.992188 1.371094 L 14.992188 1.375 L 14.066406 1.375 Z M 0.316406 1.371094 L 1.015625 1.371094 L 1.015625 1.375 L 0.316406 1.375 Z M 0.316406 1.375 L 1.011719 1.375 L 1.011719 1.382812 L 0.316406 1.382812 Z M 14.070312 1.375 L 14.992188 1.375 L 14.992188 1.382812 L 14.070312 1.382812 Z M 14.074219 1.382812 L 14.992188 1.382812 L 14.992188 1.390625 L 14.074219 1.390625 Z M 0.316406 1.382812 L 1.003906 1.382812 L 1.003906 1.390625 L 0.316406 1.390625 Z M 0.316406 1.390625 L 1 1.390625 L 1 1.394531 L 0.316406 1.394531 Z M 14.082031 1.390625 L 14.992188 1.390625 L 14.992188 1.398438 L 14.082031 1.398438 Z M 0.316406 1.394531 L 0.996094 1.394531 L 0.996094 1.402344 L 0.316406 1.402344 Z M 0.316406 1.402344 L 0.992188 1.402344 L 0.992188 1.40625 L 0.316406 1.40625 Z M 14.085938 1.398438 L 14.992188 1.398438 L 14.992188 1.40625 L 14.085938 1.40625 Z M 14.089844 1.40625 L 14.992188 1.40625 L 14.992188 1.417969 L 14.089844 1.417969 Z M 0.316406 1.40625 L 0.988281 1.40625 L 0.988281 1.417969 L 0.316406 1.417969 Z M 14.09375 1.417969 L 14.992188 1.417969 L 14.992188 1.425781 L 14.09375 1.425781 Z M 0.316406 1.417969 L 0.984375 1.417969 L 0.984375 1.425781 L 0.316406 1.425781 Z M 0.316406 1.425781 L 0.976562 1.425781 L 0.976562 1.433594 L 0.316406 1.433594 Z M 14.097656 1.425781 L 14.992188 1.425781 L 14.992188 1.4375 L 14.097656 1.4375 Z M 0.316406 1.433594 L 0.972656 1.433594 L 0.972656 1.441406 L 0.316406 1.441406 Z M 14.101562 1.4375 L 14.992188 1.4375 L 14.992188 1.445312 L 14.101562 1.445312 Z M 0.316406 1.441406 L 0.96875 1.441406 L 0.96875 1.449219 L 0.316406 1.449219 Z M 14.109375 1.445312 L 14.992188 1.445312 L 14.992188 1.453125 L 14.109375 1.453125 Z M 0.316406 1.449219 L 0.964844 1.449219 L 0.964844 1.460938 L 0.316406 1.460938 Z M 14.113281 1.453125 L 14.992188 1.453125 L 14.992188 1.464844 L 14.113281 1.464844 Z M 0.316406 1.460938 L 0.960938 1.460938 L 0.960938 1.46875 L 0.316406 1.46875 Z M 14.117188 1.464844 L 14.992188 1.464844 L 14.992188 1.472656 L 14.117188 1.472656 Z M 0.316406 1.46875 L 0.957031 1.46875 L 0.957031 1.476562 L 0.316406 1.476562 Z M 14.121094 1.472656 L 14.992188 1.472656 L 14.992188 1.480469 L 14.121094 1.480469 Z M 0.316406 1.476562 L 0.949219 1.476562 L 0.949219 1.484375 L 0.316406 1.484375 Z M 14.125 1.480469 L 14.992188 1.480469 L 14.992188 1.488281 L 14.125 1.488281 Z M 0.316406 1.484375 L 0.945312 1.484375 L 0.945312 1.492188 L 0.316406 1.492188 Z M 14.128906 1.488281 L 14.992188 1.488281 L 14.992188 1.496094 L 14.128906 1.496094 Z M 0.316406 1.492188 L 0.941406 1.492188 L 0.941406 1.5 L 0.316406 1.5 Z M 0.316406 1.5 L 0.9375 1.5 L 0.9375 1.511719 L 0.316406 1.511719 Z M 14.136719 1.496094 L 14.992188 1.496094 L 14.992188 1.511719 L 14.136719 1.511719 Z M 0.316406 1.511719 L 0.933594 1.511719 L 0.933594 1.519531 L 0.316406 1.519531 Z M 14.140625 1.511719 L 14.992188 1.511719 L 14.992188 1.523438 L 14.140625 1.523438 Z M 0.316406 1.519531 L 0.929688 1.519531 L 0.929688 1.527344 L 0.316406 1.527344 Z M 14.144531 1.523438 L 14.992188 1.523438 L 14.992188 1.53125 L 14.144531 1.53125 Z M 0.316406 1.527344 L 0.925781 1.527344 L 0.925781 1.539062 L 0.316406 1.539062 Z M 14.148438 1.53125 L 14.992188 1.53125 L 14.992188 1.542969 L 14.148438 1.542969 Z M 0.316406 1.539062 L 0.917969 1.539062 L 0.917969 1.550781 L 0.316406 1.550781 Z M 14.152344 1.542969 L 14.992188 1.542969 L 14.992188 1.558594 L 14.152344 1.558594 Z M 0.316406 1.550781 L 0.914062 1.550781 L 0.914062 1.5625 L 0.316406 1.5625 Z M 0.316406 1.5625 L 0.910156 1.5625 L 0.910156 1.570312 L 0.316406 1.570312 Z M 14.15625 1.558594 L 14.992188 1.558594 L 14.992188 1.570312 L 14.15625 1.570312 Z M 14.160156 1.570312 L 14.992188 1.570312 L 14.992188 1.578125 L 14.160156 1.578125 Z M 0.316406 1.570312 L 0.90625 1.570312 L 0.90625 1.582031 L 0.316406 1.582031 Z M 0.316406 1.582031 L 0.902344 1.582031 L 0.902344 1.589844 L 0.316406 1.589844 Z M 14.167969 1.578125 L 14.992188 1.578125 L 14.992188 1.589844 L 14.167969 1.589844 Z M 14.171875 1.589844 L 14.992188 1.589844 L 14.992188 1.605469 L 14.171875 1.605469 Z M 0.316406 1.589844 L 0.898438 1.589844 L 0.898438 1.605469 L 0.316406 1.605469 Z M 14.175781 1.605469 L 14.992188 1.605469 L 14.992188 1.613281 L 14.175781 1.613281 Z M 0.316406 1.605469 L 0.890625 1.605469 L 0.890625 1.617188 L 0.316406 1.617188 Z M 0.316406 1.617188 L 0.886719 1.617188 L 0.886719 1.625 L 0.316406 1.625 Z M 14.179688 1.613281 L 14.992188 1.613281 L 14.992188 1.628906 L 14.179688 1.628906 Z M 0.316406 1.625 L 0.882812 1.625 L 0.882812 1.640625 L 0.316406 1.640625 Z M 0.316406 1.640625 L 0.878906 1.640625 L 0.878906 1.648438 L 0.316406 1.648438 Z M 14.183594 1.628906 L 14.992188 1.628906 L 14.992188 1.648438 L 14.183594 1.648438 Z M 0.316406 1.648438 L 0.875 1.648438 L 0.875 1.660156 L 0.316406 1.660156 Z M 14.1875 1.648438 L 14.992188 1.648438 L 14.992188 1.664062 L 14.1875 1.664062 Z M 0.316406 1.660156 L 0.871094 1.660156 L 0.871094 1.675781 L 0.316406 1.675781 Z M 14.195312 1.664062 L 14.992188 1.664062 L 14.992188 1.679688 L 14.195312 1.679688 Z M 14.199219 1.679688 L 14.992188 1.679688 L 14.992188 1.695312 L 14.199219 1.695312 Z M 0.316406 1.675781 L 0.863281 1.675781 L 0.863281 1.695312 L 0.316406 1.695312 Z M 0.316406 1.695312 L 0.859375 1.695312 L 0.859375 1.707031 L 0.316406 1.707031 Z M 14.203125 1.695312 L 14.992188 1.695312 L 14.992188 1.710938 L 14.203125 1.710938 Z M 0.316406 1.707031 L 0.855469 1.707031 L 0.855469 1.722656 L 0.316406 1.722656 Z M 14.207031 1.710938 L 14.992188 1.710938 L 14.992188 1.730469 L 14.207031 1.730469 Z M 0.316406 1.722656 L 0.851562 1.722656 L 0.851562 1.742188 L 0.316406 1.742188 Z M 14.210938 1.730469 L 14.992188 1.730469 L 14.992188 1.746094 L 14.210938 1.746094 Z M 0.316406 1.742188 L 0.847656 1.742188 L 0.847656 1.753906 L 0.316406 1.753906 Z M 0.316406 1.753906 L 0.84375 1.753906 L 0.84375 1.769531 L 0.316406 1.769531 Z M 14.214844 1.746094 L 14.992188 1.746094 L 14.992188 1.769531 L 14.214844 1.769531 Z M 0.316406 1.769531 L 0.835938 1.769531 L 0.835938 1.789062 L 0.316406 1.789062 Z M 14.222656 1.769531 L 14.992188 1.769531 L 14.992188 1.800781 L 14.222656 1.800781 Z M 0.316406 1.789062 L 0.832031 1.789062 L 0.832031 1.8125 L 0.316406 1.8125 Z M 14.226562 1.800781 L 14.992188 1.800781 L 14.992188 1.832031 L 14.226562 1.832031 Z M 0.316406 1.8125 L 0.828125 1.8125 L 0.828125 1.839844 L 0.316406 1.839844 Z M 14.230469 1.832031 L 14.992188 1.832031 L 14.992188 1.855469 L 14.230469 1.855469 Z M 0.316406 1.839844 L 0.824219 1.839844 L 0.824219 1.867188 L 0.316406 1.867188 Z M 0.316406 1.867188 L 0.820312 1.867188 L 0.820312 1.890625 L 0.316406 1.890625 Z M 14.234375 1.855469 L 14.992188 1.855469 L 14.992188 1.890625 L 14.234375 1.890625 Z M 0.316406 1.890625 L 0.816406 1.890625 L 0.816406 1.921875 L 0.316406 1.921875 Z M 14.238281 1.890625 L 14.992188 1.890625 L 14.992188 1.957031 L 14.238281 1.957031 Z M 0.316406 1.921875 L 0.8125 1.921875 L 0.8125 1.976562 L 0.316406 1.976562 Z M 14.242188 1.957031 L 14.992188 1.957031 L 14.992188 11.96875 L 14.242188 11.96875 Z M 0.316406 1.976562 L 0.804688 1.976562 L 0.804688 11.992188 L 0.316406 11.992188 Z M 14.238281 11.96875 L 14.992188 11.96875 L 14.992188 12.03125 L 14.238281 12.03125 Z M 0.316406 11.992188 L 0.8125 11.992188 L 0.8125 12.050781 L 0.316406 12.050781 Z M 14.234375 12.03125 L 14.992188 12.03125 L 14.992188 12.066406 L 14.234375 12.066406 Z M 0.316406 12.050781 L 0.816406 12.050781 L 0.816406 12.078125 L 0.316406 12.078125 Z M 14.230469 12.066406 L 14.992188 12.066406 L 14.992188 12.097656 L 14.230469 12.097656 Z M 0.316406 12.078125 L 0.820312 12.078125 L 0.820312 12.105469 L 0.316406 12.105469 Z M 14.226562 12.097656 L 14.992188 12.097656 L 14.992188 12.125 L 14.226562 12.125 Z M 0.316406 12.105469 L 0.824219 12.105469 L 0.824219 12.132812 L 0.316406 12.132812 Z M 14.222656 12.125 L 14.992188 12.125 L 14.992188 12.152344 L 14.222656 12.152344 Z M 0.316406 12.132812 L 0.828125 12.132812 L 0.828125 12.160156 L 0.316406 12.160156 Z M 14.214844 12.152344 L 14.992188 12.152344 L 14.992188 12.175781 L 14.214844 12.175781 Z M 0.316406 12.160156 L 0.832031 12.160156 L 0.832031 12.1875 L 0.316406 12.1875 Z M 14.210938 12.175781 L 14.992188 12.175781 L 14.992188 12.195312 L 14.210938 12.195312 Z M 0.316406 12.1875 L 0.835938 12.1875 L 0.835938 12.203125 L 0.316406 12.203125 Z M 14.207031 12.195312 L 14.992188 12.195312 L 14.992188 12.210938 L 14.207031 12.210938 Z M 0.316406 12.203125 L 0.84375 12.203125 L 0.84375 12.21875 L 0.316406 12.21875 Z M 14.203125 12.210938 L 14.992188 12.210938 L 14.992188 12.230469 L 14.203125 12.230469 Z M 0.316406 12.21875 L 0.847656 12.21875 L 0.847656 12.234375 L 0.316406 12.234375 Z M 14.199219 12.230469 L 14.992188 12.230469 L 14.992188 12.246094 L 14.199219 12.246094 Z M 0.316406 12.234375 L 0.851562 12.234375 L 0.851562 12.25 L 0.316406 12.25 Z M 14.195312 12.246094 L 14.992188 12.246094 L 14.992188 12.261719 L 14.195312 12.261719 Z M 0.316406 12.25 L 0.855469 12.25 L 0.855469 12.265625 L 0.316406 12.265625 Z M 14.1875 12.261719 L 14.992188 12.261719 L 14.992188 12.28125 L 14.1875 12.28125 Z M 0.316406 12.265625 L 0.859375 12.265625 L 0.859375 12.285156 L 0.316406 12.285156 Z M 14.183594 12.28125 L 14.992188 12.28125 L 14.992188 12.296875 L 14.183594 12.296875 Z M 0.316406 12.285156 L 0.863281 12.285156 L 0.863281 12.300781 L 0.316406 12.300781 Z M 14.179688 12.296875 L 14.992188 12.296875 L 14.992188 12.308594 L 14.179688 12.308594 Z M 0.316406 12.300781 L 0.871094 12.300781 L 0.871094 12.3125 L 0.316406 12.3125 Z M 14.175781 12.308594 L 14.992188 12.308594 L 14.992188 12.324219 L 14.175781 12.324219 Z M 0.316406 12.3125 L 0.875 12.3125 L 0.875 12.328125 L 0.316406 12.328125 Z M 14.171875 12.324219 L 14.992188 12.324219 L 14.992188 12.332031 L 14.171875 12.332031 Z M 0.316406 12.328125 L 0.878906 12.328125 L 0.878906 12.335938 L 0.316406 12.335938 Z M 14.167969 12.332031 L 14.992188 12.332031 L 14.992188 12.34375 L 14.167969 12.34375 Z M 0.316406 12.335938 L 0.882812 12.335938 L 0.882812 12.347656 L 0.316406 12.347656 Z M 14.160156 12.34375 L 14.992188 12.34375 L 14.992188 12.355469 L 14.160156 12.355469 Z M 0.316406 12.347656 L 0.886719 12.347656 L 0.886719 12.359375 L 0.316406 12.359375 Z M 14.15625 12.355469 L 14.992188 12.355469 L 14.992188 12.371094 L 14.15625 12.371094 Z M 0.316406 12.359375 L 0.890625 12.359375 L 0.890625 12.375 L 0.316406 12.375 Z M 14.152344 12.371094 L 14.992188 12.371094 L 14.992188 12.378906 L 14.152344 12.378906 Z M 0.316406 12.375 L 0.898438 12.375 L 0.898438 12.382812 L 0.316406 12.382812 Z M 14.148438 12.378906 L 14.992188 12.378906 L 14.992188 12.390625 L 14.148438 12.390625 Z M 0.316406 12.382812 L 0.902344 12.382812 L 0.902344 12.394531 L 0.316406 12.394531 Z M 14.144531 12.390625 L 14.992188 12.390625 L 14.992188 12.402344 L 14.144531 12.402344 Z M 0.316406 12.394531 L 0.90625 12.394531 L 0.90625 12.410156 L 0.316406 12.410156 Z M 14.140625 12.402344 L 14.992188 12.402344 L 14.992188 12.417969 L 14.140625 12.417969 Z M 0.316406 12.410156 L 0.910156 12.410156 L 0.910156 12.421875 L 0.316406 12.421875 Z M 14.136719 12.417969 L 14.992188 12.417969 L 14.992188 12.425781 L 14.136719 12.425781 Z M 0.316406 12.421875 L 0.914062 12.421875 L 0.914062 12.429688 L 0.316406 12.429688 Z M 14.128906 12.425781 L 14.992188 12.425781 L 14.992188 12.433594 L 14.128906 12.433594 Z M 0.316406 12.429688 L 0.917969 12.429688 L 0.917969 12.4375 L 0.316406 12.4375 Z M 0.316406 12.4375 L 0.925781 12.4375 L 0.925781 12.445312 L 0.316406 12.445312 Z M 14.125 12.433594 L 14.992188 12.433594 L 14.992188 12.445312 L 14.125 12.445312 Z M 0.316406 12.445312 L 0.929688 12.445312 L 0.929688 12.457031 L 0.316406 12.457031 Z M 14.121094 12.445312 L 14.992188 12.445312 L 14.992188 12.457031 L 14.121094 12.457031 Z M 14.117188 12.457031 L 14.992188 12.457031 L 14.992188 12.464844 L 14.117188 12.464844 Z M 0.316406 12.457031 L 0.933594 12.457031 L 0.933594 12.464844 L 0.316406 12.464844 Z M 14.113281 12.464844 L 14.992188 12.464844 L 14.992188 12.472656 L 14.113281 12.472656 Z M 0.316406 12.464844 L 0.9375 12.464844 L 0.9375 12.472656 L 0.316406 12.472656 Z M 14.109375 12.472656 L 14.992188 12.472656 L 14.992188 12.480469 L 14.109375 12.480469 Z M 0.316406 12.472656 L 0.941406 12.472656 L 0.941406 12.484375 L 0.316406 12.484375 Z M 14.101562 12.480469 L 14.992188 12.480469 L 14.992188 12.488281 L 14.101562 12.488281 Z M 0.316406 12.484375 L 0.945312 12.484375 L 0.945312 12.492188 L 0.316406 12.492188 Z M 14.097656 12.488281 L 14.992188 12.488281 L 14.992188 12.5 L 14.097656 12.5 Z M 0.316406 12.492188 L 0.949219 12.492188 L 0.949219 12.503906 L 0.316406 12.503906 Z M 14.09375 12.5 L 14.992188 12.5 L 14.992188 12.507812 L 14.09375 12.507812 Z M 0.316406 12.503906 L 0.957031 12.503906 L 0.957031 12.511719 L 0.316406 12.511719 Z M 14.089844 12.507812 L 14.992188 12.507812 L 14.992188 12.515625 L 14.089844 12.515625 Z M 0.316406 12.511719 L 0.960938 12.511719 L 0.960938 12.519531 L 0.316406 12.519531 Z M 14.085938 12.515625 L 14.992188 12.515625 L 14.992188 12.523438 L 14.085938 12.523438 Z M 0.316406 12.519531 L 0.964844 12.519531 L 0.964844 12.527344 L 0.316406 12.527344 Z M 14.082031 12.523438 L 14.992188 12.523438 L 14.992188 12.53125 L 14.082031 12.53125 Z M 0.316406 12.527344 L 0.96875 12.527344 L 0.96875 12.535156 L 0.316406 12.535156 Z M 14.074219 12.53125 L 14.992188 12.53125 L 14.992188 12.542969 L 14.074219 12.542969 Z M 0.316406 12.535156 L 0.972656 12.535156 L 0.972656 12.546875 L 0.316406 12.546875 Z M 14.070312 12.542969 L 14.992188 12.542969 L 14.992188 12.550781 L 14.070312 12.550781 Z M 0.316406 12.546875 L 0.976562 12.546875 L 0.976562 12.554688 L 0.316406 12.554688 Z M 0.316406 12.554688 L 0.984375 12.554688 L 0.984375 12.558594 L 0.316406 12.558594 Z M 14.066406 12.550781 L 14.992188 12.550781 L 14.992188 12.558594 L 14.066406 12.558594 Z M 14.0625 12.558594 L 14.992188 12.558594 L 14.992188 12.5625 L 14.0625 12.5625 Z M 0.316406 12.558594 L 0.988281 12.558594 L 0.988281 12.566406 L 0.316406 12.566406 Z M 14.058594 12.5625 L 14.992188 12.5625 L 14.992188 12.570312 L 14.058594 12.570312 Z M 0.316406 12.566406 L 0.992188 12.566406 L 0.992188 12.574219 L 0.316406 12.574219 Z M 0.316406 12.574219 L 0.996094 12.574219 L 0.996094 12.578125 L 0.316406 12.578125 Z M 14.054688 12.570312 L 14.992188 12.570312 L 14.992188 12.578125 L 14.054688 12.578125 Z M 14.050781 12.578125 L 14.992188 12.578125 L 14.992188 12.582031 L 14.050781 12.582031 Z M 0.316406 12.578125 L 1 12.578125 L 1 12.589844 L 0.316406 12.589844 Z M 14.042969 12.582031 L 14.992188 12.582031 L 14.992188 12.59375 L 14.042969 12.59375 Z M 0.316406 12.589844 L 1.003906 12.589844 L 1.003906 12.597656 L 0.316406 12.597656 Z M 0.316406 12.597656 L 1.011719 12.597656 L 1.011719 12.601562 L 0.316406 12.601562 Z M 14.039062 12.59375 L 14.992188 12.59375 L 14.992188 12.601562 L 14.039062 12.601562 Z M 14.035156 12.601562 L 14.992188 12.601562 L 14.992188 12.605469 L 14.035156 12.605469 Z M 0.316406 12.601562 L 1.015625 12.601562 L 1.015625 12.609375 L 0.316406 12.609375 Z M 14.03125 12.605469 L 14.992188 12.605469 L 14.992188 12.613281 L 14.03125 12.613281 Z M 0.316406 12.609375 L 1.019531 12.609375 L 1.019531 12.617188 L 0.316406 12.617188 Z M 0.316406 12.617188 L 1.023438 12.617188 L 1.023438 12.621094 L 0.316406 12.621094 Z M 14.027344 12.613281 L 14.992188 12.613281 L 14.992188 12.621094 L 14.027344 12.621094 Z M 14.023438 12.621094 L 14.992188 12.621094 L 14.992188 12.625 L 14.023438 12.625 Z M 0.316406 12.621094 L 1.027344 12.621094 L 1.027344 12.628906 L 0.316406 12.628906 Z M 0.316406 12.628906 L 1.03125 12.628906 L 1.03125 12.636719 L 0.316406 12.636719 Z M 14.015625 12.625 L 14.992188 12.625 L 14.992188 12.636719 L 14.015625 12.636719 Z M 0.316406 12.636719 L 1.035156 12.636719 L 1.035156 12.644531 L 0.316406 12.644531 Z M 14.011719 12.636719 L 14.992188 12.636719 L 14.992188 12.644531 L 14.011719 12.644531 Z M 14.007812 12.644531 L 14.992188 12.644531 L 14.992188 12.648438 L 14.007812 12.648438 Z M 0.316406 12.644531 L 1.042969 12.644531 L 1.042969 12.652344 L 0.316406 12.652344 Z M 0.316406 12.652344 L 1.046875 12.652344 L 1.046875 12.65625 L 0.316406 12.65625 Z M 14.003906 12.648438 L 14.992188 12.648438 L 14.992188 12.65625 L 14.003906 12.65625 Z M 14 12.65625 L 14.992188 12.65625 L 14.992188 12.660156 L 14 12.660156 Z M 13.996094 12.660156 L 14.992188 12.660156 L 14.992188 12.664062 L 13.996094 12.664062 Z M 0.316406 12.65625 L 1.050781 12.65625 L 1.050781 12.664062 L 0.316406 12.664062 Z M 0.316406 12.664062 L 1.054688 12.664062 L 1.054688 12.667969 L 0.316406 12.667969 Z M 0.316406 12.667969 L 1.058594 12.667969 L 1.058594 12.671875 L 0.316406 12.671875 Z M 13.988281 12.664062 L 14.992188 12.664062 L 14.992188 12.671875 L 13.988281 12.671875 Z M 13.984375 12.671875 L 14.992188 12.671875 L 14.992188 12.679688 L 13.984375 12.679688 Z M 13.980469 12.679688 L 14.992188 12.679688 L 14.992188 12.683594 L 13.980469 12.683594 Z M 0.316406 12.671875 L 1.0625 12.671875 L 1.0625 12.683594 L 0.316406 12.683594 Z M 0.316406 12.683594 L 1.070312 12.683594 L 1.070312 12.6875 L 0.316406 12.6875 Z M 0.316406 12.6875 L 1.074219 12.6875 L 1.074219 12.691406 L 0.316406 12.691406 Z M 13.976562 12.683594 L 14.992188 12.683594 L 14.992188 12.691406 L 13.976562 12.691406 Z M 13.972656 12.691406 L 14.992188 12.691406 L 14.992188 12.695312 L 13.972656 12.695312 Z M 13.96875 12.695312 L 14.992188 12.695312 L 14.992188 12.699219 L 13.96875 12.699219 Z M 0.316406 12.691406 L 1.078125 12.691406 L 1.078125 12.699219 L 0.316406 12.699219 Z M 0.316406 12.699219 L 1.082031 12.699219 L 1.082031 12.703125 L 0.316406 12.703125 Z M 0.316406 12.703125 L 1.085938 12.703125 L 1.085938 12.707031 L 0.316406 12.707031 Z M 13.964844 12.699219 L 14.992188 12.699219 L 14.992188 12.707031 L 13.964844 12.707031 Z M 13.957031 12.707031 L 14.992188 12.707031 L 14.992188 12.710938 L 13.957031 12.710938 Z M 13.953125 12.710938 L 14.992188 12.710938 L 14.992188 12.714844 L 13.953125 12.714844 Z M 0.316406 12.707031 L 1.089844 12.707031 L 1.089844 12.714844 L 0.316406 12.714844 Z M 0.316406 12.714844 L 1.097656 12.714844 L 1.097656 12.71875 L 0.316406 12.71875 Z M 0.316406 12.71875 L 1.101562 12.71875 L 1.101562 12.726562 L 0.316406 12.726562 Z M 13.949219 12.714844 L 14.992188 12.714844 L 14.992188 12.726562 L 13.949219 12.726562 Z M 13.945312 12.726562 L 14.992188 12.726562 L 14.992188 12.730469 L 13.945312 12.730469 Z M 13.941406 12.730469 L 14.992188 12.730469 L 14.992188 12.734375 L 13.941406 12.734375 Z M 0.316406 12.726562 L 1.105469 12.726562 L 1.105469 12.734375 L 0.316406 12.734375 Z M 0.316406 12.734375 L 1.109375 12.734375 L 1.109375 12.738281 L 0.316406 12.738281 Z M 0.316406 12.738281 L 1.113281 12.738281 L 1.113281 12.742188 L 0.316406 12.742188 Z M 13.9375 12.734375 L 14.992188 12.734375 L 14.992188 12.742188 L 13.9375 12.742188 Z M 13.929688 12.742188 L 14.992188 12.742188 L 14.992188 12.746094 L 13.929688 12.746094 Z M 13.925781 12.746094 L 14.992188 12.746094 L 14.992188 12.75 L 13.925781 12.75 Z M 0.316406 12.742188 L 1.117188 12.742188 L 1.117188 12.75 L 0.316406 12.75 Z M 0.316406 12.75 L 1.125 12.75 L 1.125 12.753906 L 0.316406 12.753906 Z M 0.316406 12.753906 L 1.128906 12.753906 L 1.128906 12.757812 L 0.316406 12.757812 Z M 13.921875 12.75 L 14.992188 12.75 L 14.992188 12.757812 L 13.921875 12.757812 Z M 0.316406 12.757812 L 1.132812 12.757812 L 1.132812 12.761719 L 0.316406 12.761719 Z M 13.917969 12.757812 L 14.992188 12.757812 L 14.992188 12.761719 L 13.917969 12.761719 Z M 0.316406 12.761719 L 1.136719 12.761719 L 1.136719 12.769531 L 0.316406 12.769531 Z M 13.914062 12.761719 L 14.992188 12.761719 L 14.992188 12.769531 L 13.914062 12.769531 Z M 0.316406 12.769531 L 1.140625 12.769531 L 1.140625 12.773438 L 0.316406 12.773438 Z M 13.910156 12.769531 L 14.992188 12.769531 L 14.992188 12.773438 L 13.910156 12.773438 Z M 13.902344 12.773438 L 14.992188 12.773438 L 14.992188 12.777344 L 13.902344 12.777344 Z M 13.898438 12.777344 L 14.992188 12.777344 L 14.992188 12.78125 L 13.898438 12.78125 Z M 0.316406 12.773438 L 1.144531 12.773438 L 1.144531 12.78125 L 0.316406 12.78125 Z M 13.894531 12.78125 L 14.992188 12.78125 L 14.992188 12.785156 L 13.894531 12.785156 Z M 0.316406 12.78125 L 1.148438 12.78125 L 1.148438 12.785156 L 0.316406 12.785156 Z M 13.890625 12.785156 L 14.992188 12.785156 L 14.992188 12.789062 L 13.890625 12.789062 Z M 0.316406 12.785156 L 1.15625 12.785156 L 1.15625 12.789062 L 0.316406 12.789062 Z M 0.316406 12.789062 L 1.160156 12.789062 L 1.160156 12.792969 L 0.316406 12.792969 Z M 0.316406 12.792969 L 1.164062 12.792969 L 1.164062 12.796875 L 0.316406 12.796875 Z M 13.886719 12.789062 L 14.992188 12.789062 L 14.992188 12.796875 L 13.886719 12.796875 Z M 0.316406 12.796875 L 1.167969 12.796875 L 1.167969 12.800781 L 0.316406 12.800781 Z M 13.882812 12.796875 L 14.992188 12.796875 L 14.992188 12.800781 L 13.882812 12.800781 Z M 0.316406 12.800781 L 1.171875 12.800781 L 1.171875 12.804688 L 0.316406 12.804688 Z M 13.875 12.800781 L 14.992188 12.800781 L 14.992188 12.804688 L 13.875 12.804688 Z M 0.316406 12.804688 L 1.175781 12.804688 L 1.175781 12.808594 L 0.316406 12.808594 Z M 13.871094 12.804688 L 14.992188 12.804688 L 14.992188 12.808594 L 13.871094 12.808594 Z M 0.316406 12.808594 L 1.183594 12.808594 L 1.183594 12.816406 L 0.316406 12.816406 Z M 13.867188 12.808594 L 14.992188 12.808594 L 14.992188 12.816406 L 13.867188 12.816406 Z M 0.316406 12.816406 L 1.1875 12.816406 L 1.1875 12.820312 L 0.316406 12.820312 Z M 13.863281 12.816406 L 14.992188 12.816406 L 14.992188 12.820312 L 13.863281 12.820312 Z M 13.859375 12.820312 L 14.992188 12.820312 L 14.992188 12.824219 L 13.859375 12.824219 Z M 13.855469 12.824219 L 14.992188 12.824219 L 14.992188 12.828125 L 13.855469 12.828125 Z M 0.316406 12.820312 L 1.191406 12.820312 L 1.191406 12.828125 L 0.316406 12.828125 Z M 13.851562 12.828125 L 14.992188 12.828125 L 14.992188 12.832031 L 13.851562 12.832031 Z M 0.316406 12.828125 L 1.195312 12.828125 L 1.195312 12.832031 L 0.316406 12.832031 Z M 0.316406 12.832031 L 1.199219 12.832031 L 1.199219 12.835938 L 0.316406 12.835938 Z M 13.84375 12.832031 L 14.992188 12.832031 L 14.992188 12.835938 L 13.84375 12.835938 Z M 0.316406 12.835938 L 1.203125 12.835938 L 1.203125 12.839844 L 0.316406 12.839844 Z M 0.316406 12.839844 L 1.210938 12.839844 L 1.210938 12.84375 L 0.316406 12.84375 Z M 13.839844 12.835938 L 14.992188 12.835938 L 14.992188 12.84375 L 13.839844 12.84375 Z M 13.835938 12.84375 L 14.992188 12.84375 L 14.992188 12.847656 L 13.835938 12.847656 Z M 0.316406 12.84375 L 1.214844 12.84375 L 1.214844 12.847656 L 0.316406 12.847656 Z M 13.832031 12.847656 L 14.992188 12.847656 L 14.992188 12.851562 L 13.832031 12.851562 Z M 0.316406 12.847656 L 1.21875 12.847656 L 1.21875 12.851562 L 0.316406 12.851562 Z M 13.828125 12.851562 L 14.992188 12.851562 L 14.992188 12.859375 L 13.828125 12.859375 Z M 0.316406 12.851562 L 1.222656 12.851562 L 1.222656 12.859375 L 0.316406 12.859375 Z M 13.824219 12.859375 L 14.992188 12.859375 L 14.992188 12.863281 L 13.824219 12.863281 Z M 0.316406 12.859375 L 1.226562 12.859375 L 1.226562 12.863281 L 0.316406 12.863281 Z M 13.8125 12.863281 L 14.992188 12.863281 L 14.992188 12.867188 L 13.8125 12.867188 Z M 0.316406 12.863281 L 1.230469 12.863281 L 1.230469 12.867188 L 0.316406 12.867188 Z M 13.808594 12.867188 L 14.992188 12.867188 L 14.992188 12.871094 L 13.808594 12.871094 Z M 0.316406 12.867188 L 1.238281 12.867188 L 1.238281 12.871094 L 0.316406 12.871094 Z M 13.804688 12.871094 L 14.992188 12.871094 L 14.992188 12.875 L 13.804688 12.875 Z M 0.316406 12.871094 L 1.242188 12.871094 L 1.242188 12.875 L 0.316406 12.875 Z M 0.316406 12.875 L 1.246094 12.875 L 1.246094 12.878906 L 0.316406 12.878906 Z M 13.800781 12.875 L 14.992188 12.875 L 14.992188 12.878906 L 13.800781 12.878906 Z M 13.796875 12.878906 L 14.992188 12.878906 L 14.992188 12.882812 L 13.796875 12.882812 Z M 0.316406 12.878906 L 1.253906 12.878906 L 1.253906 12.882812 L 0.316406 12.882812 Z M 13.789062 12.882812 L 14.992188 12.882812 L 14.992188 12.886719 L 13.789062 12.886719 Z M 0.316406 12.882812 L 1.257812 12.882812 L 1.257812 12.886719 L 0.316406 12.886719 Z M 0.316406 12.886719 L 1.261719 12.886719 L 1.261719 12.890625 L 0.316406 12.890625 Z M 13.785156 12.886719 L 14.992188 12.886719 L 14.992188 12.890625 L 13.785156 12.890625 Z M 13.78125 12.890625 L 14.992188 12.890625 L 14.992188 12.894531 L 13.78125 12.894531 Z M 0.316406 12.890625 L 1.269531 12.890625 L 1.269531 12.894531 L 0.316406 12.894531 Z M 13.777344 12.894531 L 14.992188 12.894531 L 14.992188 12.898438 L 13.777344 12.898438 Z M 0.316406 12.894531 L 1.273438 12.894531 L 1.273438 12.898438 L 0.316406 12.898438 Z M 13.773438 12.898438 L 14.992188 12.898438 L 14.992188 12.90625 L 13.773438 12.90625 Z M 0.316406 12.898438 L 1.277344 12.898438 L 1.277344 12.90625 L 0.316406 12.90625 Z M 13.761719 12.90625 L 14.992188 12.90625 L 14.992188 12.910156 L 13.761719 12.910156 Z M 0.316406 12.90625 L 1.28125 12.90625 L 1.28125 12.910156 L 0.316406 12.910156 Z M 13.757812 12.910156 L 14.992188 12.910156 L 14.992188 12.914062 L 13.757812 12.914062 Z M 0.316406 12.910156 L 1.285156 12.910156 L 1.285156 12.914062 L 0.316406 12.914062 Z M 13.753906 12.914062 L 14.992188 12.914062 L 14.992188 12.917969 L 13.753906 12.917969 Z M 0.316406 12.914062 L 1.289062 12.914062 L 1.289062 12.917969 L 0.316406 12.917969 Z M 0.316406 12.917969 L 1.296875 12.917969 L 1.296875 12.921875 L 0.316406 12.921875 Z M 13.75 12.917969 L 14.992188 12.917969 L 14.992188 12.921875 L 13.75 12.921875 Z M 13.746094 12.921875 L 14.992188 12.921875 L 14.992188 12.925781 L 13.746094 12.925781 Z M 0.316406 12.921875 L 1.304688 12.921875 L 1.304688 12.925781 L 0.316406 12.925781 Z M 0.316406 12.925781 L 1.308594 12.925781 L 1.308594 12.929688 L 0.316406 12.929688 Z M 13.742188 12.925781 L 14.992188 12.925781 L 14.992188 12.929688 L 13.742188 12.929688 Z M 0.316406 12.929688 L 1.3125 12.929688 L 1.3125 12.933594 L 0.316406 12.933594 Z M 13.738281 12.929688 L 14.992188 12.929688 L 14.992188 12.933594 L 13.738281 12.933594 Z M 0.316406 12.933594 L 1.316406 12.933594 L 1.316406 12.9375 L 0.316406 12.9375 Z M 13.730469 12.933594 L 14.992188 12.933594 L 14.992188 12.9375 L 13.730469 12.9375 Z M 0.316406 12.9375 L 1.324219 12.9375 L 1.324219 12.941406 L 0.316406 12.941406 Z M 13.726562 12.9375 L 14.992188 12.9375 L 14.992188 12.941406 L 13.726562 12.941406 Z M 0.316406 12.941406 L 1.328125 12.941406 L 1.328125 12.949219 L 0.316406 12.949219 Z M 13.71875 12.941406 L 14.992188 12.941406 L 14.992188 12.949219 L 13.71875 12.949219 Z M 13.714844 12.949219 L 14.992188 12.949219 L 14.992188 12.953125 L 13.714844 12.953125 Z M 0.316406 12.949219 L 1.335938 12.949219 L 1.335938 12.953125 L 0.316406 12.953125 Z M 0.316406 12.953125 L 1.339844 12.953125 L 1.339844 12.957031 L 0.316406 12.957031 Z M 13.710938 12.953125 L 14.992188 12.953125 L 14.992188 12.957031 L 13.710938 12.957031 Z M 13.699219 12.957031 L 14.992188 12.957031 L 14.992188 12.960938 L 13.699219 12.960938 Z M 0.316406 12.957031 L 1.34375 12.957031 L 1.34375 12.960938 L 0.316406 12.960938 Z M 13.695312 12.960938 L 14.992188 12.960938 L 14.992188 12.964844 L 13.695312 12.964844 Z M 0.316406 12.960938 L 1.355469 12.960938 L 1.355469 12.964844 L 0.316406 12.964844 Z M 13.691406 12.964844 L 14.992188 12.964844 L 14.992188 12.96875 L 13.691406 12.96875 Z M 0.316406 12.964844 L 1.359375 12.964844 L 1.359375 12.96875 L 0.316406 12.96875 Z M 13.683594 12.96875 L 14.992188 12.96875 L 14.992188 12.972656 L 13.683594 12.972656 Z M 0.316406 12.96875 L 1.363281 12.96875 L 1.363281 12.972656 L 0.316406 12.972656 Z M 13.675781 12.972656 L 14.992188 12.972656 L 14.992188 12.976562 L 13.675781 12.976562 Z M 0.316406 12.972656 L 1.371094 12.972656 L 1.371094 12.976562 L 0.316406 12.976562 Z M 13.667969 12.976562 L 14.992188 12.976562 L 14.992188 12.980469 L 13.667969 12.980469 Z M 0.316406 12.976562 L 1.375 12.976562 L 1.375 12.980469 L 0.316406 12.980469 Z M 0.316406 12.980469 L 1.386719 12.980469 L 1.386719 12.984375 L 0.316406 12.984375 Z M 13.664062 12.980469 L 14.992188 12.980469 L 14.992188 12.984375 L 13.664062 12.984375 Z M 13.660156 12.984375 L 14.992188 12.984375 L 14.992188 12.992188 L 13.660156 12.992188 Z M 0.316406 12.984375 L 1.390625 12.984375 L 1.390625 12.992188 L 0.316406 12.992188 Z M 13.648438 12.992188 L 14.992188 12.992188 L 14.992188 12.996094 L 13.648438 12.996094 Z M 0.316406 12.992188 L 1.394531 12.992188 L 1.394531 12.996094 L 0.316406 12.996094 Z M 0.316406 12.996094 L 1.402344 12.996094 L 1.402344 13 L 0.316406 13 Z M 13.644531 12.996094 L 14.992188 12.996094 L 14.992188 13 L 13.644531 13 Z M 13.640625 13 L 14.992188 13 L 14.992188 13.003906 L 13.640625 13.003906 Z M 0.316406 13 L 1.410156 13 L 1.410156 13.003906 L 0.316406 13.003906 Z M 13.632812 13.003906 L 14.992188 13.003906 L 14.992188 13.007812 L 13.632812 13.007812 Z M 0.316406 13.003906 L 1.414062 13.003906 L 1.414062 13.007812 L 0.316406 13.007812 Z M 13.628906 13.007812 L 14.992188 13.007812 L 14.992188 13.011719 L 13.628906 13.011719 Z M 0.316406 13.007812 L 1.421875 13.007812 L 1.421875 13.011719 L 0.316406 13.011719 Z M 13.625 13.011719 L 14.992188 13.011719 L 14.992188 13.015625 L 13.625 13.015625 Z M 0.316406 13.011719 L 1.425781 13.011719 L 1.425781 13.015625 L 0.316406 13.015625 Z M 13.613281 13.015625 L 14.992188 13.015625 L 14.992188 13.019531 L 13.613281 13.019531 Z M 0.316406 13.015625 L 1.429688 13.015625 L 1.429688 13.019531 L 0.316406 13.019531 Z M 0.316406 13.019531 L 1.441406 13.019531 L 1.441406 13.023438 L 0.316406 13.023438 Z M 13.609375 13.019531 L 14.992188 13.019531 L 14.992188 13.023438 L 13.609375 13.023438 Z M 13.601562 13.023438 L 14.992188 13.023438 L 14.992188 13.027344 L 13.601562 13.027344 Z M 0.316406 13.023438 L 1.449219 13.023438 L 1.449219 13.027344 L 0.316406 13.027344 Z M 13.589844 13.027344 L 14.992188 13.027344 L 14.992188 13.03125 L 13.589844 13.03125 Z M 0.316406 13.027344 L 1.453125 13.027344 L 1.453125 13.03125 L 0.316406 13.03125 Z M 13.585938 13.03125 L 14.992188 13.03125 L 14.992188 13.039062 L 13.585938 13.039062 Z M 0.316406 13.03125 L 1.464844 13.03125 L 1.464844 13.039062 L 0.316406 13.039062 Z M 13.578125 13.039062 L 14.992188 13.039062 L 14.992188 13.042969 L 13.578125 13.042969 Z M 0.316406 13.039062 L 1.472656 13.039062 L 1.472656 13.042969 L 0.316406 13.042969 Z M 13.570312 13.042969 L 14.988281 13.042969 L 14.988281 13.046875 L 13.570312 13.046875 Z M 0.316406 13.042969 L 1.476562 13.042969 L 1.476562 13.046875 L 0.316406 13.046875 Z M 0.316406 13.046875 L 1.484375 13.046875 L 1.484375 13.050781 L 0.316406 13.050781 Z M 13.5625 13.046875 L 14.988281 13.046875 L 14.988281 13.050781 L 13.5625 13.050781 Z M 13.554688 13.050781 L 14.988281 13.050781 L 14.988281 13.054688 L 13.554688 13.054688 Z M 0.316406 13.050781 L 1.496094 13.050781 L 1.496094 13.054688 L 0.316406 13.054688 Z M 13.546875 13.054688 L 14.988281 13.054688 L 14.988281 13.058594 L 13.546875 13.058594 Z M 0.316406 13.054688 L 1.5 13.054688 L 1.5 13.058594 L 0.316406 13.058594 Z M 13.542969 13.058594 L 14.988281 13.058594 L 14.988281 13.0625 L 13.542969 13.0625 Z M 0.316406 13.058594 L 1.507812 13.058594 L 1.507812 13.0625 L 0.316406 13.0625 Z M 13.53125 13.0625 L 14.988281 13.0625 L 14.988281 13.066406 L 13.53125 13.066406 Z M 0.316406 13.0625 L 1.515625 13.0625 L 1.515625 13.066406 L 0.316406 13.066406 Z M 0.316406 13.066406 L 1.523438 13.066406 L 1.523438 13.070312 L 0.316406 13.070312 Z M 13.523438 13.066406 L 14.980469 13.066406 L 14.980469 13.070312 L 13.523438 13.070312 Z M 13.519531 13.070312 L 14.980469 13.070312 L 14.980469 13.074219 L 13.519531 13.074219 Z M 0.320312 13.070312 L 1.53125 13.070312 L 1.53125 13.074219 L 0.320312 13.074219 Z M 0.320312 13.074219 L 1.535156 13.074219 L 1.535156 13.078125 L 0.320312 13.078125 Z M 13.511719 13.074219 L 14.980469 13.074219 L 14.980469 13.078125 L 13.511719 13.078125 Z M 13.5 13.078125 L 14.980469 13.078125 L 14.980469 13.085938 L 13.5 13.085938 Z M 0.320312 13.078125 L 1.542969 13.078125 L 1.542969 13.085938 L 0.320312 13.085938 Z M 13.492188 13.085938 L 14.980469 13.085938 L 14.980469 13.089844 L 13.492188 13.089844 Z M 0.320312 13.085938 L 1.554688 13.085938 L 1.554688 13.089844 L 0.320312 13.089844 Z M 0.320312 13.089844 L 1.5625 13.089844 L 1.5625 13.09375 L 0.320312 13.09375 Z M 13.484375 13.089844 L 14.976562 13.089844 L 14.976562 13.09375 L 13.484375 13.09375 Z M 0.320312 13.09375 L 1.570312 13.09375 L 1.570312 13.097656 L 0.320312 13.097656 Z M 13.472656 13.09375 L 14.976562 13.09375 L 14.976562 13.097656 L 13.472656 13.097656 Z M 0.320312 13.097656 L 1.582031 13.097656 L 1.582031 13.101562 L 0.320312 13.101562 Z M 13.464844 13.097656 L 14.976562 13.097656 L 14.976562 13.101562 L 13.464844 13.101562 Z M 13.457031 13.101562 L 14.976562 13.101562 L 14.976562 13.105469 L 13.457031 13.105469 Z M 0.320312 13.101562 L 1.59375 13.101562 L 1.59375 13.105469 L 0.320312 13.105469 Z M 13.445312 13.105469 L 14.976562 13.105469 L 14.976562 13.109375 L 13.445312 13.109375 Z M 0.324219 13.105469 L 1.601562 13.105469 L 1.601562 13.109375 L 0.324219 13.109375 Z M 13.4375 13.109375 L 14.972656 13.109375 L 14.972656 13.113281 L 13.4375 13.113281 Z M 0.324219 13.109375 L 1.613281 13.109375 L 1.613281 13.113281 L 0.324219 13.113281 Z M 13.429688 13.113281 L 14.972656 13.113281 L 14.972656 13.117188 L 13.429688 13.117188 Z M 0.324219 13.113281 L 1.621094 13.113281 L 1.621094 13.117188 L 0.324219 13.117188 Z M 13.417969 13.117188 L 14.972656 13.117188 L 14.972656 13.121094 L 13.417969 13.121094 Z M 0.324219 13.117188 L 1.628906 13.117188 L 1.628906 13.121094 L 0.324219 13.121094 Z M 0.324219 13.121094 L 1.640625 13.121094 L 1.640625 13.128906 L 0.324219 13.128906 Z M 13.410156 13.121094 L 14.972656 13.121094 L 14.972656 13.128906 L 13.410156 13.128906 Z M 13.402344 13.128906 L 14.972656 13.128906 L 14.972656 13.132812 L 13.402344 13.132812 Z M 0.332031 13.128906 L 1.648438 13.128906 L 1.648438 13.132812 L 0.332031 13.132812 Z M 13.390625 13.132812 L 14.96875 13.132812 L 14.96875 13.136719 L 13.390625 13.136719 Z M 0.332031 13.132812 L 1.65625 13.132812 L 1.65625 13.136719 L 0.332031 13.136719 Z M 13.378906 13.136719 L 14.96875 13.136719 L 14.96875 13.140625 L 13.378906 13.140625 Z M 0.332031 13.136719 L 1.667969 13.136719 L 1.667969 13.140625 L 0.332031 13.140625 Z M 13.371094 13.140625 L 14.96875 13.140625 L 14.96875 13.144531 L 13.371094 13.144531 Z M 0.332031 13.140625 L 1.679688 13.140625 L 1.679688 13.144531 L 0.332031 13.144531 Z M 13.355469 13.144531 L 14.96875 13.144531 L 14.96875 13.148438 L 13.355469 13.148438 Z M 0.332031 13.144531 L 1.695312 13.144531 L 1.695312 13.148438 L 0.332031 13.148438 Z M 0.332031 13.148438 L 1.703125 13.148438 L 1.703125 13.152344 L 0.332031 13.152344 Z M 13.34375 13.148438 L 14.964844 13.148438 L 14.964844 13.152344 L 13.34375 13.152344 Z M 13.332031 13.152344 L 14.964844 13.152344 L 14.964844 13.15625 L 13.332031 13.15625 Z M 0.335938 13.152344 L 1.714844 13.152344 L 1.714844 13.15625 L 0.335938 13.15625 Z M 13.320312 13.15625 L 14.964844 13.15625 L 14.964844 13.160156 L 13.320312 13.160156 Z M 0.335938 13.15625 L 1.730469 13.15625 L 1.730469 13.160156 L 0.335938 13.160156 Z M 13.304688 13.160156 L 14.960938 13.160156 L 14.960938 13.164062 L 13.304688 13.164062 Z M 0.335938 13.160156 L 1.742188 13.160156 L 1.742188 13.164062 L 0.335938 13.164062 Z M 13.292969 13.164062 L 14.960938 13.164062 L 14.960938 13.171875 L 13.292969 13.171875 Z M 0.335938 13.164062 L 1.753906 13.164062 L 1.753906 13.171875 L 0.335938 13.171875 Z M 0.335938 13.171875 L 1.765625 13.171875 L 1.765625 13.175781 L 0.335938 13.175781 Z M 13.285156 13.171875 L 14.960938 13.171875 L 14.960938 13.175781 L 13.285156 13.175781 Z M 13.269531 13.175781 L 14.953125 13.175781 L 14.953125 13.179688 L 13.269531 13.179688 Z M 0.339844 13.175781 L 1.78125 13.175781 L 1.78125 13.179688 L 0.339844 13.179688 Z M 13.257812 13.179688 L 14.953125 13.179688 L 14.953125 13.183594 L 13.257812 13.183594 Z M 0.339844 13.179688 L 1.789062 13.179688 L 1.789062 13.183594 L 0.339844 13.183594 Z M 13.242188 13.183594 L 14.953125 13.183594 L 14.953125 13.1875 L 13.242188 13.1875 Z M 0.339844 13.183594 L 1.808594 13.183594 L 1.808594 13.1875 L 0.339844 13.1875 Z M 0.339844 13.1875 L 1.824219 13.1875 L 1.824219 13.191406 L 0.339844 13.191406 Z M 13.226562 13.1875 L 14.949219 13.1875 L 14.949219 13.191406 L 13.226562 13.191406 Z M 13.207031 13.191406 L 14.949219 13.191406 L 14.949219 13.195312 L 13.207031 13.195312 Z M 0.34375 13.191406 L 1.84375 13.191406 L 1.84375 13.195312 L 0.34375 13.195312 Z M 0.34375 13.195312 L 1.855469 13.195312 L 1.855469 13.199219 L 0.34375 13.199219 Z M 13.1875 13.195312 L 14.949219 13.195312 L 14.949219 13.199219 L 13.1875 13.199219 Z M 0.34375 13.199219 L 1.875 13.199219 L 1.875 13.203125 L 0.34375 13.203125 Z M 13.171875 13.199219 L 14.945312 13.199219 L 14.945312 13.203125 L 13.171875 13.203125 Z M 13.152344 13.203125 L 14.945312 13.203125 L 14.945312 13.207031 L 13.152344 13.207031 Z M 0.347656 13.203125 L 1.894531 13.203125 L 1.894531 13.207031 L 0.347656 13.207031 Z M 13.136719 13.207031 L 14.945312 13.207031 L 14.945312 13.210938 L 13.136719 13.210938 Z M 0.347656 13.207031 L 1.910156 13.207031 L 1.910156 13.210938 L 0.347656 13.210938 Z M 0.347656 13.210938 L 1.929688 13.210938 L 1.929688 13.21875 L 0.347656 13.21875 Z M 13.121094 13.210938 L 14.941406 13.210938 L 14.941406 13.21875 L 13.121094 13.21875 Z M 13.09375 13.21875 L 14.941406 13.21875 L 14.941406 13.222656 L 13.09375 13.222656 Z M 0.351562 13.21875 L 1.957031 13.21875 L 1.957031 13.222656 L 0.351562 13.222656 Z M 13.0625 13.222656 L 14.941406 13.222656 L 14.941406 13.226562 L 13.0625 13.226562 Z M 0.351562 13.222656 L 1.988281 13.222656 L 1.988281 13.226562 L 0.351562 13.226562 Z M 13.03125 13.226562 L 14.9375 13.226562 L 14.9375 13.230469 L 13.03125 13.230469 Z M 0.351562 13.226562 L 2.015625 13.226562 L 2.015625 13.230469 L 0.351562 13.230469 Z M 0.351562 13.230469 L 2.046875 13.230469 L 2.046875 13.234375 L 0.351562 13.234375 Z M 13.003906 13.230469 L 14.9375 13.230469 L 14.9375 13.234375 L 13.003906 13.234375 Z M 12.964844 13.234375 L 14.9375 13.234375 L 14.9375 13.238281 L 12.964844 13.238281 Z M 0.359375 13.234375 L 2.078125 13.234375 L 2.078125 13.238281 L 0.359375 13.238281 Z M 12.902344 13.238281 L 14.933594 13.238281 L 14.933594 13.242188 L 12.902344 13.242188 Z M 0.359375 13.238281 L 2.148438 13.238281 L 2.148438 13.242188 L 0.359375 13.242188 Z M 0.359375 13.242188 L 14.933594 13.242188 L 14.933594 13.246094 L 0.359375 13.246094 Z M 0.363281 13.246094 L 14.925781 13.246094 L 14.925781 13.257812 L 0.363281 13.257812 Z M 0.367188 13.257812 L 14.921875 13.257812 L 14.921875 13.269531 L 0.367188 13.269531 Z M 0.367188 13.269531 L 14.917969 13.269531 L 14.917969 13.273438 L 0.367188 13.273438 Z M 0.371094 13.273438 L 14.917969 13.273438 L 14.917969 13.277344 L 0.371094 13.277344 Z M 0.371094 13.277344 L 14.914062 13.277344 L 14.914062 13.28125 L 0.371094 13.28125 Z M 0.375 13.28125 L 14.914062 13.28125 L 14.914062 13.285156 L 0.375 13.285156 Z M 0.375 13.285156 L 14.910156 13.285156 L 14.910156 13.292969 L 0.375 13.292969 Z M 0.378906 13.292969 L 14.910156 13.292969 L 14.910156 13.296875 L 0.378906 13.296875 Z M 0.378906 13.296875 L 14.90625 13.296875 L 14.90625 13.300781 L 0.378906 13.300781 Z M 0.386719 13.300781 L 14.90625 13.300781 L 14.90625 13.308594 L 0.386719 13.308594 Z M 0.386719 13.308594 L 14.898438 13.308594 L 14.898438 13.316406 L 0.386719 13.316406 Z M 0.390625 13.316406 L 14.894531 13.316406 L 14.894531 13.324219 L 0.390625 13.324219 Z M 0.394531 13.324219 L 14.890625 13.324219 L 14.890625 13.332031 L 0.394531 13.332031 Z M 0.398438 13.332031 L 14.886719 13.332031 L 14.886719 13.339844 L 0.398438 13.339844 Z M 0.398438 13.339844 L 14.882812 13.339844 L 14.882812 13.34375 L 0.398438 13.34375 Z M 0.402344 13.34375 L 14.882812 13.34375 L 14.882812 13.351562 L 0.402344 13.351562 Z M 0.402344 13.351562 L 14.878906 13.351562 L 14.878906 13.355469 L 0.402344 13.355469 Z M 0.40625 13.355469 L 14.875 13.355469 L 14.875 13.363281 L 0.40625 13.363281 Z M 0.414062 13.363281 L 14.867188 13.363281 L 14.867188 13.371094 L 0.414062 13.371094 Z M 0.417969 13.371094 L 14.863281 13.371094 L 14.863281 13.378906 L 0.417969 13.378906 Z M 0.421875 13.378906 L 14.859375 13.378906 L 14.859375 13.382812 L 0.421875 13.382812 Z M 0.421875 13.382812 L 14.855469 13.382812 L 14.855469 13.386719 L 0.421875 13.386719 Z M 0.425781 13.386719 L 14.855469 13.386719 L 14.855469 13.390625 L 0.425781 13.390625 Z M 0.429688 13.390625 L 14.851562 13.390625 L 14.851562 13.402344 L 0.429688 13.402344 Z M 0.433594 13.402344 L 14.847656 13.402344 L 14.847656 13.410156 L 0.433594 13.410156 Z M 0.4375 13.410156 L 14.839844 13.410156 L 14.839844 13.414062 L 0.4375 13.414062 Z M 0.4375 13.414062 L 14.835938 13.414062 L 14.835938 13.417969 L 0.4375 13.417969 Z M 0.445312 13.417969 L 14.835938 13.417969 L 14.835938 13.421875 L 0.445312 13.421875 Z M 0.445312 13.421875 L 14.832031 13.421875 L 14.832031 13.425781 L 0.445312 13.425781 Z M 0.449219 13.425781 L 14.828125 13.425781 L 14.828125 13.433594 L 0.449219 13.433594 Z M 0.453125 13.433594 L 14.824219 13.433594 L 14.824219 13.441406 L 0.453125 13.441406 Z M 0.457031 13.441406 L 14.820312 13.441406 L 14.820312 13.449219 L 0.457031 13.449219 Z M 0.460938 13.449219 L 14.8125 13.449219 L 14.8125 13.453125 L 0.460938 13.453125 Z M 0.464844 13.453125 L 14.808594 13.453125 L 14.808594 13.460938 L 0.464844 13.460938 Z M 0.472656 13.460938 L 14.804688 13.460938 L 14.804688 13.464844 L 0.472656 13.464844 Z M 0.472656 13.464844 L 14.800781 13.464844 L 14.800781 13.46875 L 0.472656 13.46875 Z M 0.476562 13.46875 L 14.800781 13.46875 L 14.800781 13.472656 L 0.476562 13.472656 Z M 0.480469 13.472656 L 14.796875 13.472656 L 14.796875 13.476562 L 0.480469 13.476562 Z M 0.480469 13.476562 L 14.792969 13.476562 L 14.792969 13.480469 L 0.480469 13.480469 Z M 0.484375 13.480469 L 14.792969 13.480469 L 14.792969 13.488281 L 0.484375 13.488281 Z M 0.488281 13.488281 L 14.789062 13.488281 L 14.789062 13.492188 L 0.488281 13.492188 Z M 0.488281 13.492188 L 14.78125 13.492188 L 14.78125 13.496094 L 0.488281 13.496094 Z M 0.492188 13.496094 L 14.777344 13.496094 L 14.777344 13.5 L 0.492188 13.5 Z M 0.5 13.5 L 14.777344 13.5 L 14.777344 13.503906 L 0.5 13.503906 Z M 0.5 13.503906 L 14.773438 13.503906 L 14.773438 13.507812 L 0.5 13.507812 Z M 0.503906 13.507812 L 14.769531 13.507812 L 14.769531 13.511719 L 0.503906 13.511719 Z M 0.507812 13.511719 L 14.765625 13.511719 L 14.765625 13.515625 L 0.507812 13.515625 Z M 0.507812 13.515625 L 14.761719 13.515625 L 14.761719 13.519531 L 0.507812 13.519531 Z M 0.511719 13.519531 L 14.761719 13.519531 L 14.761719 13.523438 L 0.511719 13.523438 Z M 0.515625 13.523438 L 14.753906 13.523438 L 14.753906 13.53125 L 0.515625 13.53125 Z M 0.519531 13.53125 L 14.75 13.53125 L 14.75 13.535156 L 0.519531 13.535156 Z M 0.519531 13.535156 L 14.746094 13.535156 L 14.746094 13.539062 L 0.519531 13.539062 Z M 0.527344 13.539062 L 14.746094 13.539062 L 14.746094 13.542969 L 0.527344 13.542969 Z M 0.53125 13.542969 L 14.742188 13.542969 L 14.742188 13.546875 L 0.53125 13.546875 Z M 0.535156 13.546875 L 14.738281 13.546875 L 14.738281 13.550781 L 0.535156 13.550781 Z M 0.539062 13.550781 L 14.734375 13.550781 L 14.734375 13.554688 L 0.539062 13.554688 Z M 0.539062 13.554688 L 14.726562 13.554688 L 14.726562 13.558594 L 0.539062 13.558594 Z M 0.542969 13.558594 L 14.726562 13.558594 L 14.726562 13.5625 L 0.542969 13.5625 Z M 0.546875 13.5625 L 14.722656 13.5625 L 14.722656 13.566406 L 0.546875 13.566406 Z M 0.550781 13.566406 L 14.71875 13.566406 L 14.71875 13.570312 L 0.550781 13.570312 Z M 0.550781 13.570312 L 14.714844 13.570312 L 14.714844 13.578125 L 0.550781 13.578125 Z M 0.558594 13.578125 L 14.710938 13.578125 L 14.710938 13.582031 L 0.558594 13.582031 Z M 0.5625 13.582031 L 14.707031 13.582031 L 14.707031 13.585938 L 0.5625 13.585938 Z M 0.566406 13.585938 L 14.699219 13.585938 L 14.699219 13.589844 L 0.566406 13.589844 Z M 0.570312 13.589844 L 14.695312 13.589844 L 14.695312 13.597656 L 0.570312 13.597656 Z M 0.574219 13.597656 L 14.691406 13.597656 L 14.691406 13.601562 L 0.574219 13.601562 Z M 0.578125 13.601562 L 14.6875 13.601562 L 14.6875 13.605469 L 0.578125 13.605469 Z M 0.585938 13.605469 L 14.683594 13.605469 L 14.683594 13.609375 L 0.585938 13.609375 Z M 0.589844 13.609375 L 14.679688 13.609375 L 14.679688 13.613281 L 0.589844 13.613281 Z M 0.59375 13.613281 L 14.675781 13.613281 L 14.675781 13.621094 L 0.59375 13.621094 Z M 0.597656 13.621094 L 14.667969 13.621094 L 14.667969 13.625 L 0.597656 13.625 Z M 0.601562 13.625 L 14.664062 13.625 L 14.664062 13.628906 L 0.601562 13.628906 Z M 0.605469 13.628906 L 14.660156 13.628906 L 14.660156 13.632812 L 0.605469 13.632812 Z M 0.613281 13.632812 L 14.65625 13.632812 L 14.65625 13.636719 L 0.613281 13.636719 Z M 0.617188 13.636719 L 14.652344 13.636719 L 14.652344 13.640625 L 0.617188 13.640625 Z M 0.617188 13.640625 L 14.648438 13.640625 L 14.648438 13.644531 L 0.617188 13.644531 Z M 0.621094 13.644531 L 14.640625 13.644531 L 14.640625 13.648438 L 0.621094 13.648438 Z M 0.625 13.648438 L 14.636719 13.648438 L 14.636719 13.652344 L 0.625 13.652344 Z M 0.628906 13.652344 L 14.632812 13.652344 L 14.632812 13.65625 L 0.628906 13.65625 Z M 0.632812 13.65625 L 14.628906 13.65625 L 14.628906 13.660156 L 0.632812 13.660156 Z M 0.636719 13.660156 L 14.625 13.660156 L 14.625 13.667969 L 0.636719 13.667969 Z M 0.644531 13.667969 L 14.621094 13.667969 L 14.621094 13.671875 L 0.644531 13.671875 Z M 0.648438 13.671875 L 14.613281 13.671875 L 14.613281 13.675781 L 0.648438 13.675781 Z M 0.652344 13.675781 L 14.609375 13.675781 L 14.609375 13.679688 L 0.652344 13.679688 Z M 0.65625 13.679688 L 14.605469 13.679688 L 14.605469 13.683594 L 0.65625 13.683594 Z M 0.660156 13.683594 L 14.601562 13.683594 L 14.601562 13.6875 L 0.660156 13.6875 Z M 0.664062 13.6875 L 14.597656 13.6875 L 14.597656 13.691406 L 0.664062 13.691406 Z M 0.671875 13.691406 L 14.59375 13.691406 L 14.59375 13.695312 L 0.671875 13.695312 Z M 0.675781 13.695312 L 14.589844 13.695312 L 14.589844 13.699219 L 0.675781 13.699219 Z M 0.683594 13.699219 L 14.578125 13.699219 L 14.578125 13.703125 L 0.683594 13.703125 Z M 0.6875 13.703125 L 14.574219 13.703125 L 14.574219 13.707031 L 0.6875 13.707031 Z M 0.691406 13.707031 L 14.570312 13.707031 L 14.570312 13.714844 L 0.691406 13.714844 Z M 0.699219 13.714844 L 14.566406 13.714844 L 14.566406 13.71875 L 0.699219 13.71875 Z M 0.703125 13.71875 L 14.5625 13.71875 L 14.5625 13.722656 L 0.703125 13.722656 Z M 0.707031 13.722656 L 14.554688 13.722656 L 14.554688 13.726562 L 0.707031 13.726562 Z M 0.710938 13.726562 L 14.550781 13.726562 L 14.550781 13.730469 L 0.710938 13.730469 Z M 0.714844 13.730469 L 14.542969 13.730469 L 14.542969 13.734375 L 0.714844 13.734375 Z M 0.71875 13.734375 L 14.539062 13.734375 L 14.539062 13.738281 L 0.71875 13.738281 Z M 0.726562 13.738281 L 14.535156 13.738281 L 14.535156 13.742188 L 0.726562 13.742188 Z M 0.734375 13.742188 L 14.527344 13.742188 L 14.527344 13.746094 L 0.734375 13.746094 Z M 0.738281 13.746094 L 14.519531 13.746094 L 14.519531 13.75 L 0.738281 13.75 Z M 0.742188 13.75 L 14.515625 13.75 L 14.515625 13.757812 L 0.742188 13.757812 Z M 0.746094 13.757812 L 14.511719 13.757812 L 14.511719 13.761719 L 0.746094 13.761719 Z M 0.757812 13.761719 L 14.507812 13.761719 L 14.507812 13.765625 L 0.757812 13.765625 Z M 0.761719 13.765625 L 14.496094 13.765625 L 14.496094 13.769531 L 0.761719 13.769531 Z M 0.765625 13.769531 L 14.492188 13.769531 L 14.492188 13.773438 L 0.765625 13.773438 Z M 0.773438 13.773438 L 14.488281 13.773438 L 14.488281 13.777344 L 0.773438 13.777344 Z M 0.777344 13.777344 L 14.484375 13.777344 L 14.484375 13.78125 L 0.777344 13.78125 Z M 0.785156 13.78125 L 14.476562 13.78125 L 14.476562 13.785156 L 0.785156 13.785156 Z M 0.789062 13.785156 L 14.46875 13.785156 L 14.46875 13.789062 L 0.789062 13.789062 Z M 0.796875 13.789062 L 14.464844 13.789062 L 14.464844 13.792969 L 0.796875 13.792969 Z M 0.800781 13.792969 L 14.457031 13.792969 L 14.457031 13.800781 L 0.800781 13.800781 Z M 0.804688 13.800781 L 14.453125 13.800781 L 14.453125 13.804688 L 0.804688 13.804688 Z M 0.816406 13.804688 L 14.441406 13.804688 L 14.441406 13.808594 L 0.816406 13.808594 Z M 0.820312 13.808594 L 14.4375 13.808594 L 14.4375 13.8125 L 0.820312 13.8125 Z M 0.828125 13.8125 L 14.429688 13.8125 L 14.429688 13.816406 L 0.828125 13.816406 Z M 0.832031 13.816406 L 14.425781 13.816406 L 14.425781 13.820312 L 0.832031 13.820312 Z M 0.84375 13.820312 L 14.414062 13.820312 L 14.414062 13.824219 L 0.84375 13.824219 Z M 0.847656 13.824219 L 14.410156 13.824219 L 14.410156 13.828125 L 0.847656 13.828125 Z M 0.855469 13.828125 L 14.402344 13.828125 L 14.402344 13.832031 L 0.855469 13.832031 Z M 0.859375 13.832031 L 14.398438 13.832031 L 14.398438 13.835938 L 0.859375 13.835938 Z M 0.871094 13.835938 L 14.386719 13.835938 L 14.386719 13.839844 L 0.871094 13.839844 Z M 0.875 13.839844 L 14.382812 13.839844 L 14.382812 13.847656 L 0.875 13.847656 Z M 0.882812 13.847656 L 14.375 13.847656 L 14.375 13.851562 L 0.882812 13.851562 Z M 0.886719 13.851562 L 14.367188 13.851562 L 14.367188 13.855469 L 0.886719 13.855469 Z M 0.898438 13.855469 L 14.355469 13.855469 L 14.355469 13.859375 L 0.898438 13.859375 Z M 0.90625 13.859375 L 14.351562 13.859375 L 14.351562 13.863281 L 0.90625 13.863281 Z M 0.914062 13.863281 L 14.34375 13.863281 L 14.34375 13.867188 L 0.914062 13.867188 Z M 0.925781 13.867188 L 14.335938 13.867188 L 14.335938 13.871094 L 0.925781 13.871094 Z M 0.933594 13.871094 L 14.324219 13.871094 L 14.324219 13.875 L 0.933594 13.875 Z M 0.9375 13.875 L 14.316406 13.875 L 14.316406 13.878906 L 0.9375 13.878906 Z M 0.945312 13.878906 L 14.3125 13.878906 L 14.3125 13.882812 L 0.945312 13.882812 Z M 0.957031 13.882812 L 14.300781 13.882812 L 14.300781 13.890625 L 0.957031 13.890625 Z M 0.964844 13.890625 L 14.292969 13.890625 L 14.292969 13.894531 L 0.964844 13.894531 Z M 0.972656 13.894531 L 14.285156 13.894531 L 14.285156 13.898438 L 0.972656 13.898438 Z M 0.984375 13.898438 L 14.273438 13.898438 L 14.273438 13.902344 L 0.984375 13.902344 Z M 0.992188 13.902344 L 14.261719 13.902344 L 14.261719 13.90625 L 0.992188 13.90625 Z M 1.003906 13.90625 L 14.253906 13.90625 L 14.253906 13.910156 L 1.003906 13.910156 Z M 1.015625 13.910156 L 14.242188 13.910156 L 14.242188 13.914062 L 1.015625 13.914062 Z M 1.023438 13.914062 L 14.234375 13.914062 L 14.234375 13.917969 L 1.023438 13.917969 Z M 1.035156 13.917969 L 14.222656 13.917969 L 14.222656 13.921875 L 1.035156 13.921875 Z M 1.046875 13.921875 L 14.210938 13.921875 L 14.210938 13.925781 L 1.046875 13.925781 Z M 1.054688 13.925781 L 14.203125 13.925781 L 14.203125 13.929688 L 1.054688 13.929688 Z M 1.070312 13.929688 L 14.1875 13.929688 L 14.1875 13.9375 L 1.070312 13.9375 Z M 1.082031 13.9375 L 14.175781 13.9375 L 14.175781 13.941406 L 1.082031 13.941406 Z M 1.097656 13.941406 L 14.160156 13.941406 L 14.160156 13.945312 L 1.097656 13.945312 Z M 1.109375 13.945312 L 14.148438 13.945312 L 14.148438 13.949219 L 1.109375 13.949219 Z M 1.125 13.949219 L 14.136719 13.949219 L 14.136719 13.953125 L 1.125 13.953125 Z M 1.136719 13.953125 L 14.121094 13.953125 L 14.121094 13.957031 L 1.136719 13.957031 Z M 1.15625 13.957031 L 14.109375 13.957031 L 14.109375 13.960938 L 1.15625 13.960938 Z M 1.171875 13.960938 L 14.085938 13.960938 L 14.085938 13.964844 L 1.171875 13.964844 Z M 1.195312 13.964844 L 14.0625 13.964844 L 14.0625 13.96875 L 1.195312 13.96875 Z M 1.21875 13.96875 L 14.039062 13.96875 L 14.039062 13.972656 L 1.21875 13.972656 Z M 1.242188 13.972656 L 14.023438 13.972656 L 14.023438 13.980469 L 1.242188 13.980469 Z M 1.277344 13.980469 L 13.984375 13.980469 L 13.984375 13.984375 L 1.277344 13.984375 Z M 1.277344 13.980469 " />
        </clipPath>
        <clipPath id="clip3">
          <path d="M 1.546875 0 C 0.605469 0 0.316406 0.355469 0.316406 1.011719 L 0.316406 13.003906 C 0.316406 13.472656 0.855469 13.984375 1.351562 13.984375 L 13.910156 13.984375 C 14.40625 13.984375 14.992188 13.429688 14.992188 12.960938 L 14.992188 1.019531 C 14.992188 0.550781 14.40625 0 13.910156 0 Z M 0.800781 11.910156 L 0.800781 2.054688 C 0.800781 1.316406 1.492188 0.679688 2.269531 0.679688 L 12.832031 0.679688 C 13.613281 0.679688 14.246094 1.277344 14.246094 2.015625 L 14.246094 11.910156 C 14.246094 12.648438 13.613281 13.246094 12.832031 13.246094 L 2.214844 13.246094 C 1.433594 13.246094 0.800781 12.648438 0.800781 11.910156 " />
        </clipPath>
        <linearGradient
          id="linear0"
          gradientUnits="userSpaceOnUse"
          x1="-0.000000245803"
          y1="0"
          x2="1.000003"
          y2="0"
          gradientTransform="matrix(-0.000000647645,-13.9828,14.800634,-0.000000611858,7.654846,13.982882)"
        >
          <stop
            offset="0"
            style={{
              stopColor: 'rgb(36.078431%,35.686275%,35.294118%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.00390625"
            style={{
              stopColor: 'rgb(38.823529%,38.431373%,38.039216%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0078125"
            style={{
              stopColor: 'rgb(41.176471%,40.784314%,40.392157%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0117188"
            style={{
              stopColor: 'rgb(43.921569%,43.529412%,43.137255%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.015625"
            style={{
              stopColor: 'rgb(46.27451%,45.882353%,45.490196%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0195313"
            style={{
              stopColor: 'rgb(49.019608%,48.627451%,48.235294%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0234375"
            style={{
              stopColor: 'rgb(51.764706%,50.980392%,50.980392%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0273438"
            style={{
              stopColor: 'rgb(54.117647%,53.72549%,53.333333%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.03125"
            style={{
              stopColor: 'rgb(56.862745%,56.078431%,56.078431%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0351563"
            style={{
              stopColor: 'rgb(59.607843%,58.823529%,58.823529%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0390625"
            style={{
              stopColor: 'rgb(61.960784%,61.176471%,61.176471%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0429688"
            style={{
              stopColor: 'rgb(64.705882%,63.921569%,63.921569%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.046875"
            style={{
              stopColor: 'rgb(67.058824%,66.27451%,66.27451%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0507813"
            style={{
              stopColor: 'rgb(69.803922%,69.019608%,69.019608%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0546875"
            style={{
              stopColor: 'rgb(72.54902%,71.372549%,71.764706%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0585938"
            style={{
              stopColor: 'rgb(74.901961%,74.117647%,74.117647%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0625"
            style={{
              stopColor: 'rgb(77.647059%,76.470588%,76.862745%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0664063"
            style={{
              stopColor: 'rgb(80.392157%,79.215686%,79.607843%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0703125"
            style={{
              stopColor: 'rgb(82.745098%,81.568627%,81.960784%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0742188"
            style={{
              stopColor: 'rgb(83.529412%,82.352941%,82.745098%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.078125"
            style={{
              stopColor: 'rgb(84.313725%,83.137255%,83.529412%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0820313"
            style={{
              stopColor: 'rgb(85.098039%,83.921569%,84.313725%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0859375"
            style={{
              stopColor: 'rgb(85.882353%,85.098039%,85.098039%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0898438"
            style={{
              stopColor: 'rgb(86.666667%,85.882353%,85.882353%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.09375"
            style={{
              stopColor: 'rgb(87.45098%,86.666667%,86.666667%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0976563"
            style={{
              stopColor: 'rgb(88.235294%,87.45098%,87.843137%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.101563"
            style={{
              stopColor: 'rgb(89.019608%,88.235294%,88.627451%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.105469"
            style={{
              stopColor: 'rgb(89.803922%,89.019608%,89.411765%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.109375"
            style={{
              stopColor: 'rgb(90.588235%,89.803922%,90.196078%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.113281"
            style={{
              stopColor: 'rgb(91.372549%,90.588235%,90.980392%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.117188"
            style={{
              stopColor: 'rgb(92.156863%,91.372549%,91.764706%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.121094"
            style={{
              stopColor: 'rgb(92.941176%,92.54902%,92.54902%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.125"
            style={{
              stopColor: 'rgb(93.72549%,93.333333%,93.333333%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.128906"
            style={{
              stopColor: 'rgb(94.509804%,94.117647%,94.117647%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.132813"
            style={{
              stopColor: 'rgb(95.294118%,94.901961%,94.901961%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.136719"
            style={{
              stopColor: 'rgb(96.078431%,95.686275%,95.686275%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.140625"
            style={{
              stopColor: 'rgb(96.862745%,96.470588%,96.470588%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.144531"
            style={{
              stopColor: 'rgb(97.647059%,97.254902%,97.254902%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.148438"
            style={{
              stopColor: 'rgb(98.431373%,98.039216%,98.039216%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.152344"
            style={{
              stopColor: 'rgb(99.215686%,99.215686%,99.215686%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.15625"
            style={{ stopColor: 'rgb(100%,100%,100%)', stopOpacity: 1 }}
          />
          <stop
            offset="0.1875"
            style={{ stopColor: 'rgb(100%,100%,100%)', stopOpacity: 1 }}
          />
          <stop
            offset="0.25"
            style={{ stopColor: 'rgb(100%,100%,100%)', stopOpacity: 1 }}
          />
          <stop
            offset="0.3125"
            style={{ stopColor: 'rgb(100%,100%,100%)', stopOpacity: 1 }}
          />
          <stop
            offset="0.328125"
            style={{ stopColor: 'rgb(100%,100%,100%)', stopOpacity: 1 }}
          />
          <stop
            offset="0.332031"
            style={{
              stopColor: 'rgb(99.215686%,99.215686%,99.215686%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.335938"
            style={{
              stopColor: 'rgb(98.431373%,98.039216%,98.039216%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.339844"
            style={{
              stopColor: 'rgb(97.254902%,97.254902%,97.254902%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.34375"
            style={{
              stopColor: 'rgb(96.078431%,96.078431%,96.078431%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.347656"
            style={{
              stopColor: 'rgb(95.294118%,94.901961%,94.901961%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.351563"
            style={{
              stopColor: 'rgb(94.117647%,94.117647%,94.117647%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.355469"
            style={{
              stopColor: 'rgb(93.333333%,92.941176%,92.941176%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.359375"
            style={{
              stopColor: 'rgb(92.156863%,91.764706%,92.156863%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.363281"
            style={{
              stopColor: 'rgb(91.372549%,90.980392%,90.980392%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.367188"
            style={{
              stopColor: 'rgb(90.196078%,89.803922%,89.803922%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.371094"
            style={{
              stopColor: 'rgb(89.411765%,88.627451%,89.019608%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.375"
            style={{
              stopColor: 'rgb(88.235294%,87.45098%,87.843137%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.378906"
            style={{
              stopColor: 'rgb(87.45098%,86.666667%,86.666667%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.382813"
            style={{
              stopColor: 'rgb(86.27451%,85.490196%,85.882353%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.386719"
            style={{
              stopColor: 'rgb(85.490196%,84.313725%,84.705882%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.390625"
            style={{
              stopColor: 'rgb(84.313725%,83.529412%,83.921569%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.394531"
            style={{
              stopColor: 'rgb(83.529412%,82.352941%,82.745098%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.398438"
            style={{
              stopColor: 'rgb(82.352941%,81.176471%,81.568627%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.402344"
            style={{
              stopColor: 'rgb(81.568627%,80.392157%,80.784314%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.40625"
            style={{
              stopColor: 'rgb(80.392157%,79.215686%,79.607843%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.410156"
            style={{
              stopColor: 'rgb(79.607843%,78.431373%,78.823529%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.414063"
            style={{
              stopColor: 'rgb(78.823529%,77.647059%,78.039216%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.417969"
            style={{
              stopColor: 'rgb(78.039216%,76.862745%,77.254902%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.421875"
            style={{
              stopColor: 'rgb(77.254902%,76.078431%,76.470588%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.425781"
            style={{
              stopColor: 'rgb(76.470588%,75.294118%,75.686275%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.429688"
            style={{
              stopColor: 'rgb(75.294118%,74.509804%,74.901961%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.433594"
            style={{
              stopColor: 'rgb(74.509804%,74.117647%,74.509804%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.4375"
            style={{
              stopColor: 'rgb(73.72549%,73.333333%,73.72549%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.441406"
            style={{
              stopColor: 'rgb(72.941176%,72.54902%,72.941176%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.445313"
            style={{
              stopColor: 'rgb(72.156863%,71.764706%,72.156863%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.449219"
            style={{
              stopColor: 'rgb(71.372549%,70.980392%,71.372549%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.453125"
            style={{
              stopColor: 'rgb(70.588235%,70.196078%,70.588235%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.457031"
            style={{
              stopColor: 'rgb(69.803922%,69.411765%,69.803922%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.460938"
            style={{
              stopColor: 'rgb(68.627451%,68.627451%,69.019608%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.464844"
            style={{
              stopColor: 'rgb(67.843137%,67.843137%,68.235294%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.46875"
            style={{
              stopColor: 'rgb(67.058824%,67.058824%,67.45098%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.472656"
            style={{
              stopColor: 'rgb(66.27451%,66.27451%,66.666667%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.476563"
            style={{
              stopColor: 'rgb(65.490196%,65.490196%,65.882353%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.480469"
            style={{
              stopColor: 'rgb(64.705882%,64.705882%,65.098039%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.484375"
            style={{
              stopColor: 'rgb(63.921569%,63.921569%,64.313725%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.488281"
            style={{
              stopColor: 'rgb(63.137255%,63.137255%,63.529412%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.492188"
            style={{
              stopColor: 'rgb(61.960784%,62.352941%,62.745098%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.496094"
            style={{
              stopColor: 'rgb(61.176471%,61.568627%,61.960784%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.5"
            style={{
              stopColor: 'rgb(60.392157%,60.784314%,61.176471%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.503906"
            style={{
              stopColor: 'rgb(60.784314%,61.176471%,61.568627%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.507813"
            style={{
              stopColor: 'rgb(61.568627%,61.960784%,62.352941%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.511719"
            style={{
              stopColor: 'rgb(62.352941%,62.745098%,63.137255%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.515625"
            style={{
              stopColor: 'rgb(63.529412%,63.921569%,64.313725%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.519531"
            style={{
              stopColor: 'rgb(64.313725%,64.705882%,65.098039%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.523438"
            style={{
              stopColor: 'rgb(65.490196%,65.882353%,66.27451%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.527344"
            style={{
              stopColor: 'rgb(66.666667%,66.666667%,67.058824%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.53125"
            style={{
              stopColor: 'rgb(67.45098%,67.843137%,68.235294%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.535156"
            style={{
              stopColor: 'rgb(68.627451%,69.019608%,69.019608%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.539062"
            style={{
              stopColor: 'rgb(69.411765%,69.803922%,70.196078%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.542969"
            style={{
              stopColor: 'rgb(70.588235%,70.980392%,70.980392%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.546875"
            style={{
              stopColor: 'rgb(71.764706%,71.764706%,72.156863%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.550781"
            style={{
              stopColor: 'rgb(72.54902%,72.941176%,72.941176%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.554688"
            style={{
              stopColor: 'rgb(73.72549%,73.72549%,74.117647%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.558594"
            style={{
              stopColor: 'rgb(74.509804%,74.901961%,75.294118%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.5625"
            style={{
              stopColor: 'rgb(75.686275%,75.686275%,76.078431%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.566406"
            style={{
              stopColor: 'rgb(76.470588%,76.862745%,77.254902%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.570313"
            style={{
              stopColor: 'rgb(77.647059%,78.039216%,78.039216%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.574219"
            style={{
              stopColor: 'rgb(78.823529%,78.823529%,79.215686%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.578125"
            style={{ stopColor: 'rgb(79.607843%,80%,80%)', stopOpacity: 1 }}
          />
          <stop
            offset="0.582031"
            style={{
              stopColor: 'rgb(80.784314%,80.784314%,81.176471%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.585938"
            style={{
              stopColor: 'rgb(81.568627%,81.960784%,81.960784%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.589844"
            style={{
              stopColor: 'rgb(82.745098%,82.745098%,83.137255%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.59375"
            style={{
              stopColor: 'rgb(83.529412%,83.921569%,83.921569%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.597656"
            style={{
              stopColor: 'rgb(84.705882%,84.705882%,85.098039%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.601563"
            style={{
              stopColor: 'rgb(85.882353%,85.882353%,85.882353%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.605469"
            style={{
              stopColor: 'rgb(86.666667%,86.666667%,87.058824%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.609375"
            style={{
              stopColor: 'rgb(87.843137%,87.843137%,87.843137%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.613281"
            style={{
              stopColor: 'rgb(88.627451%,89.019608%,89.019608%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.617188"
            style={{
              stopColor: 'rgb(89.803922%,89.803922%,89.803922%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.621094"
            style={{
              stopColor: 'rgb(90.588235%,90.980392%,90.980392%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.625"
            style={{
              stopColor: 'rgb(91.764706%,91.764706%,91.764706%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.6875"
            style={{
              stopColor: 'rgb(91.764706%,91.764706%,92.156863%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.691406"
            style={{
              stopColor: 'rgb(90.980392%,90.980392%,90.980392%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.695313"
            style={{
              stopColor: 'rgb(89.803922%,90.196078%,90.196078%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.699219"
            style={{
              stopColor: 'rgb(89.019608%,89.019608%,89.019608%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.703125"
            style={{
              stopColor: 'rgb(87.843137%,87.843137%,88.235294%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.707031"
            style={{
              stopColor: 'rgb(87.058824%,87.058824%,87.058824%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.710938"
            style={{
              stopColor: 'rgb(85.882353%,85.882353%,86.27451%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.714844"
            style={{
              stopColor: 'rgb(84.705882%,85.098039%,85.098039%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.71875"
            style={{
              stopColor: 'rgb(83.921569%,83.921569%,84.313725%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.722656"
            style={{
              stopColor: 'rgb(82.745098%,83.137255%,83.137255%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.726563"
            style={{
              stopColor: 'rgb(81.960784%,81.960784%,81.960784%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.730469"
            style={{
              stopColor: 'rgb(80.784314%,80.784314%,81.176471%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.734375"
            style={{ stopColor: 'rgb(79.607843%,80%,80%)', stopOpacity: 1 }}
          />
          <stop
            offset="0.738281"
            style={{
              stopColor: 'rgb(78.823529%,78.823529%,79.215686%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.742188"
            style={{
              stopColor: 'rgb(77.647059%,78.039216%,78.039216%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.746094"
            style={{
              stopColor: 'rgb(76.862745%,76.862745%,77.254902%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.75"
            style={{
              stopColor: 'rgb(75.686275%,76.078431%,76.078431%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.753906"
            style={{
              stopColor: 'rgb(74.509804%,74.901961%,75.294118%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.757813"
            style={{
              stopColor: 'rgb(73.72549%,73.72549%,74.117647%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.761719"
            style={{
              stopColor: 'rgb(72.54902%,72.941176%,73.333333%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.765625"
            style={{
              stopColor: 'rgb(71.764706%,71.764706%,72.156863%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.769531"
            style={{
              stopColor: 'rgb(70.588235%,70.980392%,70.980392%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.773438"
            style={{
              stopColor: 'rgb(69.411765%,69.803922%,70.196078%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.777344"
            style={{
              stopColor: 'rgb(68.627451%,69.019608%,69.019608%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.78125"
            style={{
              stopColor: 'rgb(67.45098%,67.843137%,68.235294%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.785156"
            style={{
              stopColor: 'rgb(66.666667%,66.666667%,67.058824%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.789063"
            style={{
              stopColor: 'rgb(65.490196%,65.882353%,66.27451%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.792969"
            style={{
              stopColor: 'rgb(64.313725%,64.705882%,65.098039%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.796875"
            style={{
              stopColor: 'rgb(63.529412%,63.921569%,64.313725%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.800781"
            style={{
              stopColor: 'rgb(62.352941%,62.745098%,63.137255%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.804688"
            style={{
              stopColor: 'rgb(61.568627%,61.568627%,61.960784%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.808594"
            style={{
              stopColor: 'rgb(60.784314%,61.176471%,61.568627%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.8125"
            style={{
              stopColor: 'rgb(60.392157%,60.784314%,61.176471%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.816406"
            style={{
              stopColor: 'rgb(60.784314%,61.176471%,61.568627%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.820313"
            style={{
              stopColor: 'rgb(61.176471%,61.568627%,61.960784%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.824219"
            style={{
              stopColor: 'rgb(61.568627%,61.960784%,62.352941%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.828125"
            style={{
              stopColor: 'rgb(61.960784%,62.352941%,62.745098%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.832031"
            style={{
              stopColor: 'rgb(62.352941%,62.745098%,63.137255%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.835938"
            style={{
              stopColor: 'rgb(62.745098%,63.137255%,63.529412%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.839844"
            style={{
              stopColor: 'rgb(63.137255%,63.529412%,63.921569%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.84375"
            style={{
              stopColor: 'rgb(63.529412%,63.921569%,64.313725%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.847656"
            style={{
              stopColor: 'rgb(64.313725%,64.313725%,64.705882%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.851562"
            style={{
              stopColor: 'rgb(64.705882%,64.705882%,65.098039%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.855469"
            style={{
              stopColor: 'rgb(65.098039%,65.098039%,65.490196%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.859375"
            style={{
              stopColor: 'rgb(65.490196%,65.490196%,65.882353%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.863281"
            style={{
              stopColor: 'rgb(65.882353%,65.882353%,66.27451%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.867188"
            style={{
              stopColor: 'rgb(66.27451%,66.27451%,66.666667%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.871094"
            style={{
              stopColor: 'rgb(66.666667%,66.666667%,67.058824%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.875"
            style={{
              stopColor: 'rgb(67.058824%,67.058824%,67.45098%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.878906"
            style={{
              stopColor: 'rgb(67.45098%,67.45098%,67.843137%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.882813"
            style={{
              stopColor: 'rgb(67.843137%,67.843137%,68.235294%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.886719"
            style={{
              stopColor: 'rgb(68.235294%,68.235294%,68.627451%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.890625"
            style={{
              stopColor: 'rgb(68.627451%,68.627451%,69.019608%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.894531"
            style={{
              stopColor: 'rgb(69.411765%,69.019608%,69.411765%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.898438"
            style={{
              stopColor: 'rgb(69.803922%,69.411765%,69.803922%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.902344"
            style={{
              stopColor: 'rgb(70.196078%,69.803922%,70.196078%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.90625"
            style={{
              stopColor: 'rgb(70.588235%,70.196078%,70.588235%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.910156"
            style={{
              stopColor: 'rgb(70.980392%,70.588235%,70.980392%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.914063"
            style={{
              stopColor: 'rgb(71.372549%,70.980392%,71.372549%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.917969"
            style={{
              stopColor: 'rgb(71.764706%,71.372549%,71.764706%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.921875"
            style={{
              stopColor: 'rgb(72.156863%,71.764706%,72.156863%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.925781"
            style={{
              stopColor: 'rgb(72.54902%,72.156863%,72.54902%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.929688"
            style={{
              stopColor: 'rgb(72.941176%,72.54902%,72.941176%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.933594"
            style={{
              stopColor: 'rgb(73.333333%,72.941176%,73.333333%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.9375"
            style={{
              stopColor: 'rgb(74.117647%,73.333333%,73.72549%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.941406"
            style={{
              stopColor: 'rgb(74.509804%,73.72549%,74.117647%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.945313"
            style={{
              stopColor: 'rgb(74.901961%,74.117647%,74.509804%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.949219"
            style={{
              stopColor: 'rgb(75.294118%,74.509804%,74.901961%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.953125"
            style={{
              stopColor: 'rgb(75.686275%,74.901961%,75.294118%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.957031"
            style={{
              stopColor: 'rgb(76.078431%,75.294118%,75.686275%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.960938"
            style={{
              stopColor: 'rgb(76.470588%,75.686275%,76.078431%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.964844"
            style={{
              stopColor: 'rgb(76.862745%,76.078431%,76.470588%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.96875"
            style={{
              stopColor: 'rgb(77.254902%,76.470588%,76.862745%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.972656"
            style={{
              stopColor: 'rgb(77.647059%,76.862745%,77.254902%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.976562"
            style={{
              stopColor: 'rgb(78.039216%,77.254902%,77.647059%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.980469"
            style={{
              stopColor: 'rgb(78.823529%,77.647059%,78.039216%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.984375"
            style={{
              stopColor: 'rgb(79.215686%,78.039216%,78.431373%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.988281"
            style={{
              stopColor: 'rgb(79.607843%,78.431373%,78.823529%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.992188"
            style={{
              stopColor: 'rgb(80%,78.823529%,79.215686%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.996094"
            style={{
              stopColor: 'rgb(80.392157%,79.215686%,79.607843%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="1"
            style={{
              stopColor: 'rgb(80.784314%,79.607843%,80%)',
              stopOpacity: 1,
            }}
          />
        </linearGradient>
        <clipPath id="clip4">
          <path d="M 0.769531 0.640625 L 14.265625 0.640625 L 14.265625 13.265625 L 0.769531 13.265625 Z M 0.769531 0.640625 " />
        </clipPath>
        <clipPath id="clip5">
          <path d="M 2.269531 0.679688 C 1.492188 0.679688 0.800781 1.316406 0.800781 2.054688 L 0.800781 11.910156 C 0.800781 12.648438 1.433594 13.246094 2.214844 13.246094 L 12.832031 13.246094 C 13.613281 13.246094 14.246094 12.648438 14.246094 11.910156 L 14.246094 2.015625 C 14.246094 1.277344 13.613281 0.679688 12.832031 0.679688 Z M 1.042969 11.675781 L 1.042969 2.253906 C 1.042969 1.515625 1.675781 0.917969 2.457031 0.917969 L 12.570312 0.917969 C 13.347656 0.917969 13.980469 1.515625 13.980469 2.253906 L 13.980469 11.675781 C 13.980469 12.410156 13.347656 13.007812 12.570312 13.007812 L 2.457031 13.007812 C 1.675781 13.007812 1.042969 12.410156 1.042969 11.675781 " />
        </clipPath>
        <clipPath id="clip6">
          <path d="M 2.269531 0.679688 C 1.492188 0.679688 0.800781 1.316406 0.800781 2.054688 L 0.800781 11.910156 C 0.800781 12.648438 1.433594 13.246094 2.214844 13.246094 L 12.832031 13.246094 C 13.613281 13.246094 14.246094 12.648438 14.246094 11.910156 L 14.246094 2.015625 C 14.246094 1.277344 13.613281 0.679688 12.832031 0.679688 Z M 1.042969 11.675781 L 1.042969 2.253906 C 1.042969 1.515625 1.675781 0.917969 2.457031 0.917969 L 12.570312 0.917969 C 13.347656 0.917969 13.980469 1.515625 13.980469 2.253906 L 13.980469 11.675781 C 13.980469 12.410156 13.347656 13.007812 12.570312 13.007812 L 2.457031 13.007812 C 1.675781 13.007812 1.042969 12.410156 1.042969 11.675781 " />
        </clipPath>
        <linearGradient
          id="linear1"
          gradientUnits="userSpaceOnUse"
          x1="-0.0000000220296"
          y1="0"
          x2="0.999997"
          y2="0"
          gradientTransform="matrix(-0.00000057971,12.564615,-13.299502,-0.000000547677,7.523732,0.680232)"
        >
          <stop
            offset="0"
            style={{
              stopColor: 'rgb(36.078431%,35.686275%,35.294118%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.00390625"
            style={{
              stopColor: 'rgb(37.647059%,37.254902%,36.862745%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0078125"
            style={{
              stopColor: 'rgb(38.823529%,38.823529%,38.431373%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0117188"
            style={{
              stopColor: 'rgb(40.392157%,40%,39.607843%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.015625"
            style={{
              stopColor: 'rgb(41.960784%,41.568627%,41.176471%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0195313"
            style={{
              stopColor: 'rgb(43.529412%,43.137255%,42.745098%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0234375"
            style={{
              stopColor: 'rgb(44.705882%,44.705882%,44.313725%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0273438"
            style={{
              stopColor: 'rgb(46.27451%,45.882353%,45.882353%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.03125"
            style={{
              stopColor: 'rgb(47.843137%,47.45098%,47.058824%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0351563"
            style={{
              stopColor: 'rgb(49.411765%,49.019608%,48.627451%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0390625"
            style={{
              stopColor: 'rgb(50.588235%,50.588235%,50.196078%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0429688"
            style={{
              stopColor: 'rgb(52.156863%,51.764706%,51.764706%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.046875"
            style={{
              stopColor: 'rgb(53.72549%,53.333333%,53.333333%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0507812"
            style={{
              stopColor: 'rgb(55.294118%,54.901961%,54.509804%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0546875"
            style={{
              stopColor: 'rgb(56.470588%,56.470588%,56.078431%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0585938"
            style={{
              stopColor: 'rgb(58.039216%,58.039216%,57.647059%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0625"
            style={{
              stopColor: 'rgb(59.607843%,59.215686%,59.215686%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0664063"
            style={{
              stopColor: 'rgb(61.176471%,60.784314%,60.784314%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0703125"
            style={{
              stopColor: 'rgb(62.352941%,62.352941%,61.960784%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0742188"
            style={{
              stopColor: 'rgb(63.921569%,63.921569%,63.529412%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.078125"
            style={{
              stopColor: 'rgb(65.490196%,65.098039%,65.098039%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0820313"
            style={{
              stopColor: 'rgb(67.058824%,66.666667%,66.666667%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0859375"
            style={{
              stopColor: 'rgb(68.235294%,68.235294%,68.235294%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0898437"
            style={{
              stopColor: 'rgb(69.803922%,69.803922%,69.411765%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.09375"
            style={{
              stopColor: 'rgb(71.372549%,71.372549%,70.980392%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.0976563"
            style={{
              stopColor: 'rgb(72.941176%,72.54902%,72.54902%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.101563"
            style={{
              stopColor: 'rgb(74.117647%,74.117647%,74.117647%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.105469"
            style={{
              stopColor: 'rgb(75.686275%,75.686275%,75.294118%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.109375"
            style={{
              stopColor: 'rgb(77.254902%,77.254902%,76.862745%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.113281"
            style={{
              stopColor: 'rgb(78.823529%,78.431373%,78.431373%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.117188"
            style={{ stopColor: 'rgb(80%,80%,80%)', stopOpacity: 1 }}
          />
          <stop
            offset="0.121094"
            style={{
              stopColor: 'rgb(81.568627%,81.568627%,81.568627%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.125"
            style={{
              stopColor: 'rgb(83.137255%,83.137255%,82.745098%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.128906"
            style={{
              stopColor: 'rgb(84.705882%,84.313725%,84.313725%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.132813"
            style={{
              stopColor: 'rgb(85.882353%,85.882353%,85.882353%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.136719"
            style={{
              stopColor: 'rgb(87.45098%,87.45098%,87.45098%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.140625"
            style={{
              stopColor: 'rgb(89.019608%,89.019608%,89.019608%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.144531"
            style={{
              stopColor: 'rgb(90.588235%,90.588235%,90.196078%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.148438"
            style={{
              stopColor: 'rgb(91.764706%,91.764706%,91.764706%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.152344"
            style={{
              stopColor: 'rgb(93.333333%,93.333333%,93.333333%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.15625"
            style={{
              stopColor: 'rgb(94.901961%,94.901961%,94.901961%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.160156"
            style={{
              stopColor: 'rgb(96.470588%,96.470588%,96.470588%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.164063"
            style={{
              stopColor: 'rgb(97.647059%,97.647059%,97.647059%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.167969"
            style={{
              stopColor: 'rgb(98.823529%,98.823529%,98.823529%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.171875"
            style={{ stopColor: 'rgb(100%,100%,100%)', stopOpacity: 1 }}
          />
          <stop
            offset="0.175781"
            style={{
              stopColor: 'rgb(99.607843%,99.607843%,99.607843%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.179688"
            style={{
              stopColor: 'rgb(99.215686%,99.215686%,99.215686%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.183594"
            style={{
              stopColor: 'rgb(98.823529%,98.823529%,98.823529%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.1875"
            style={{
              stopColor: 'rgb(98.823529%,98.431373%,98.431373%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.191406"
            style={{
              stopColor: 'rgb(98.431373%,98.431373%,98.431373%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.195313"
            style={{
              stopColor: 'rgb(98.039216%,98.039216%,98.039216%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.199219"
            style={{
              stopColor: 'rgb(97.647059%,97.647059%,97.647059%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.203125"
            style={{
              stopColor: 'rgb(97.647059%,97.254902%,97.254902%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.207031"
            style={{
              stopColor: 'rgb(97.254902%,96.862745%,96.862745%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.210938"
            style={{
              stopColor: 'rgb(96.862745%,96.470588%,96.862745%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.214844"
            style={{
              stopColor: 'rgb(96.470588%,96.470588%,96.470588%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.21875"
            style={{
              stopColor: 'rgb(96.078431%,96.078431%,96.078431%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.222656"
            style={{
              stopColor: 'rgb(96.078431%,95.686275%,95.686275%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.226563"
            style={{
              stopColor: 'rgb(95.686275%,95.294118%,95.294118%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.230469"
            style={{
              stopColor: 'rgb(95.294118%,94.901961%,95.294118%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.234375"
            style={{
              stopColor: 'rgb(94.901961%,94.901961%,94.901961%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.238281"
            style={{
              stopColor: 'rgb(94.901961%,94.509804%,94.509804%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.242188"
            style={{
              stopColor: 'rgb(94.509804%,94.117647%,94.117647%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.246094"
            style={{
              stopColor: 'rgb(94.117647%,93.72549%,93.72549%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.25"
            style={{
              stopColor: 'rgb(93.72549%,93.333333%,93.72549%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.253906"
            style={{
              stopColor: 'rgb(93.72549%,93.333333%,93.333333%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.257813"
            style={{
              stopColor: 'rgb(93.333333%,92.941176%,92.941176%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.261719"
            style={{
              stopColor: 'rgb(92.941176%,92.54902%,92.54902%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.265625"
            style={{
              stopColor: 'rgb(92.54902%,92.156863%,92.54902%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.269531"
            style={{
              stopColor: 'rgb(92.54902%,91.764706%,92.156863%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.273438"
            style={{
              stopColor: 'rgb(92.156863%,91.372549%,91.764706%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.277344"
            style={{
              stopColor: 'rgb(91.764706%,91.372549%,91.372549%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.28125"
            style={{
              stopColor: 'rgb(91.372549%,90.980392%,90.980392%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.285156"
            style={{
              stopColor: 'rgb(91.372549%,90.588235%,90.980392%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.289063"
            style={{
              stopColor: 'rgb(90.980392%,90.196078%,90.588235%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.292969"
            style={{
              stopColor: 'rgb(90.588235%,89.803922%,90.196078%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.296875"
            style={{
              stopColor: 'rgb(90.196078%,89.803922%,89.803922%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.300781"
            style={{
              stopColor: 'rgb(90.196078%,89.411765%,89.411765%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.304688"
            style={{
              stopColor: 'rgb(89.803922%,89.019608%,89.411765%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.308594"
            style={{
              stopColor: 'rgb(89.411765%,88.627451%,89.019608%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.3125"
            style={{
              stopColor: 'rgb(89.019608%,88.235294%,88.627451%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.316406"
            style={{
              stopColor: 'rgb(88.627451%,88.235294%,88.235294%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.320313"
            style={{
              stopColor: 'rgb(88.627451%,87.843137%,87.843137%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.324219"
            style={{
              stopColor: 'rgb(88.235294%,87.45098%,87.843137%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.328125"
            style={{
              stopColor: 'rgb(87.843137%,87.058824%,87.45098%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.332031"
            style={{
              stopColor: 'rgb(87.45098%,86.666667%,87.058824%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.335938"
            style={{
              stopColor: 'rgb(87.45098%,86.27451%,86.666667%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.339844"
            style={{
              stopColor: 'rgb(87.058824%,86.27451%,86.27451%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.34375"
            style={{
              stopColor: 'rgb(86.666667%,85.882353%,86.27451%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.347656"
            style={{
              stopColor: 'rgb(86.27451%,85.490196%,85.882353%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.351563"
            style={{
              stopColor: 'rgb(86.27451%,85.098039%,85.490196%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.355469"
            style={{
              stopColor: 'rgb(85.882353%,84.705882%,85.098039%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.359375"
            style={{
              stopColor: 'rgb(85.490196%,84.705882%,84.705882%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.363281"
            style={{
              stopColor: 'rgb(85.098039%,84.313725%,84.705882%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.367187"
            style={{
              stopColor: 'rgb(85.098039%,83.921569%,84.313725%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.371094"
            style={{
              stopColor: 'rgb(84.705882%,83.529412%,83.921569%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.375"
            style={{
              stopColor: 'rgb(84.313725%,83.137255%,83.529412%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.378906"
            style={{
              stopColor: 'rgb(83.921569%,83.137255%,83.137255%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.382813"
            style={{
              stopColor: 'rgb(83.921569%,82.745098%,83.137255%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.386719"
            style={{
              stopColor: 'rgb(83.529412%,82.352941%,82.745098%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.390625"
            style={{
              stopColor: 'rgb(83.137255%,81.960784%,82.352941%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.398438"
            style={{
              stopColor: 'rgb(83.137255%,81.960784%,82.352941%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.402344"
            style={{
              stopColor: 'rgb(83.529412%,82.352941%,82.745098%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.40625"
            style={{
              stopColor: 'rgb(83.921569%,82.745098%,83.137255%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.410156"
            style={{
              stopColor: 'rgb(84.313725%,83.137255%,83.529412%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.414062"
            style={{
              stopColor: 'rgb(84.705882%,83.921569%,84.313725%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.417969"
            style={{
              stopColor: 'rgb(85.490196%,84.313725%,84.705882%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.421875"
            style={{
              stopColor: 'rgb(85.882353%,84.705882%,85.098039%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.425781"
            style={{
              stopColor: 'rgb(86.27451%,85.098039%,85.490196%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.429688"
            style={{
              stopColor: 'rgb(86.666667%,85.882353%,85.882353%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.433594"
            style={{
              stopColor: 'rgb(87.058824%,86.27451%,86.666667%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.4375"
            style={{
              stopColor: 'rgb(87.45098%,86.666667%,87.058824%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.441406"
            style={{
              stopColor: 'rgb(87.843137%,87.058824%,87.45098%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.445312"
            style={{
              stopColor: 'rgb(88.627451%,87.843137%,87.843137%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.449219"
            style={{
              stopColor: 'rgb(89.019608%,88.235294%,88.627451%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.453125"
            style={{
              stopColor: 'rgb(89.411765%,88.627451%,89.019608%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.457031"
            style={{
              stopColor: 'rgb(89.803922%,89.019608%,89.411765%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.460938"
            style={{
              stopColor: 'rgb(90.196078%,89.803922%,89.803922%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.464844"
            style={{
              stopColor: 'rgb(90.588235%,90.196078%,90.196078%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.46875"
            style={{
              stopColor: 'rgb(91.372549%,90.588235%,90.980392%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.472656"
            style={{
              stopColor: 'rgb(91.764706%,90.980392%,91.372549%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.476563"
            style={{
              stopColor: 'rgb(92.156863%,91.764706%,91.764706%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.480469"
            style={{
              stopColor: 'rgb(92.54902%,92.156863%,92.156863%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.484375"
            style={{
              stopColor: 'rgb(92.941176%,92.54902%,92.54902%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.488281"
            style={{
              stopColor: 'rgb(93.333333%,92.941176%,93.333333%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.492188"
            style={{
              stopColor: 'rgb(94.117647%,93.333333%,93.72549%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.496094"
            style={{
              stopColor: 'rgb(94.509804%,94.117647%,94.117647%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.5"
            style={{
              stopColor: 'rgb(94.901961%,94.509804%,94.509804%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.503906"
            style={{
              stopColor: 'rgb(95.294118%,94.901961%,94.901961%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.507813"
            style={{
              stopColor: 'rgb(95.686275%,95.294118%,95.686275%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.511719"
            style={{
              stopColor: 'rgb(96.078431%,96.078431%,96.078431%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.515625"
            style={{
              stopColor: 'rgb(96.470588%,96.470588%,96.470588%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.519531"
            style={{
              stopColor: 'rgb(97.254902%,96.862745%,96.862745%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.523438"
            style={{
              stopColor: 'rgb(97.647059%,97.254902%,97.647059%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.527344"
            style={{
              stopColor: 'rgb(98.039216%,98.039216%,98.039216%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.53125"
            style={{
              stopColor: 'rgb(98.431373%,98.431373%,98.431373%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.535156"
            style={{
              stopColor: 'rgb(98.823529%,98.823529%,98.823529%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.539063"
            style={{
              stopColor: 'rgb(99.215686%,99.215686%,99.215686%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.546875"
            style={{
              stopColor: 'rgb(99.607843%,99.607843%,99.607843%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.550781"
            style={{
              stopColor: 'rgb(99.215686%,99.215686%,99.215686%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.554688"
            style={{
              stopColor: 'rgb(98.431373%,98.431373%,98.431373%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.558594"
            style={{
              stopColor: 'rgb(98.039216%,98.039216%,98.039216%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.5625"
            style={{
              stopColor: 'rgb(97.647059%,97.254902%,97.254902%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.566406"
            style={{
              stopColor: 'rgb(96.862745%,96.862745%,96.862745%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.570312"
            style={{
              stopColor: 'rgb(96.470588%,96.078431%,96.078431%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.574219"
            style={{
              stopColor: 'rgb(95.686275%,95.686275%,95.686275%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.578125"
            style={{
              stopColor: 'rgb(95.294118%,94.901961%,95.294118%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.582031"
            style={{
              stopColor: 'rgb(94.901961%,94.509804%,94.509804%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.585937"
            style={{
              stopColor: 'rgb(94.117647%,93.72549%,94.117647%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.589844"
            style={{
              stopColor: 'rgb(93.72549%,93.333333%,93.333333%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.59375"
            style={{
              stopColor: 'rgb(92.941176%,92.54902%,92.941176%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.597656"
            style={{
              stopColor: 'rgb(92.54902%,92.156863%,92.156863%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.601563"
            style={{
              stopColor: 'rgb(92.156863%,91.372549%,91.764706%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.605469"
            style={{
              stopColor: 'rgb(91.372549%,90.980392%,90.980392%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.609375"
            style={{
              stopColor: 'rgb(90.980392%,90.196078%,90.588235%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.613281"
            style={{
              stopColor: 'rgb(90.588235%,89.803922%,90.196078%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.617188"
            style={{
              stopColor: 'rgb(89.803922%,89.411765%,89.411765%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.621094"
            style={{
              stopColor: 'rgb(89.411765%,88.627451%,89.019608%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.625"
            style={{
              stopColor: 'rgb(88.627451%,88.235294%,88.235294%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.628906"
            style={{
              stopColor: 'rgb(88.235294%,87.45098%,87.843137%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.632813"
            style={{
              stopColor: 'rgb(87.843137%,87.058824%,87.058824%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.636719"
            style={{
              stopColor: 'rgb(87.058824%,86.27451%,86.666667%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.640625"
            style={{
              stopColor: 'rgb(86.666667%,85.882353%,85.882353%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.644531"
            style={{
              stopColor: 'rgb(85.882353%,85.098039%,85.490196%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.648437"
            style={{
              stopColor: 'rgb(85.490196%,84.705882%,85.098039%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.652344"
            style={{
              stopColor: 'rgb(85.098039%,83.921569%,84.313725%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.65625"
            style={{
              stopColor: 'rgb(84.313725%,83.529412%,83.921569%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.660156"
            style={{
              stopColor: 'rgb(83.921569%,82.745098%,83.137255%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.664063"
            style={{
              stopColor: 'rgb(83.529412%,82.352941%,82.745098%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.667969"
            style={{
              stopColor: 'rgb(82.745098%,81.568627%,81.960784%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.671875"
            style={{
              stopColor: 'rgb(82.352941%,81.176471%,81.568627%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.675781"
            style={{
              stopColor: 'rgb(81.568627%,80.784314%,80.784314%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.679688"
            style={{
              stopColor: 'rgb(81.176471%,80%,80.392157%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.683594"
            style={{
              stopColor: 'rgb(80.392157%,79.215686%,79.607843%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.6875"
            style={{
              stopColor: 'rgb(79.215686%,78.039216%,78.431373%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.691406"
            style={{
              stopColor: 'rgb(78.039216%,76.862745%,77.254902%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.695313"
            style={{
              stopColor: 'rgb(76.862745%,76.078431%,76.078431%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.699219"
            style={{
              stopColor: 'rgb(76.078431%,74.901961%,75.294118%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.703125"
            style={{
              stopColor: 'rgb(74.901961%,73.72549%,74.117647%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.707031"
            style={{
              stopColor: 'rgb(73.72549%,72.54902%,72.941176%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.710938"
            style={{
              stopColor: 'rgb(72.54902%,71.372549%,71.764706%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.714844"
            style={{
              stopColor: 'rgb(71.372549%,70.196078%,70.588235%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.71875"
            style={{
              stopColor: 'rgb(70.196078%,69.411765%,69.411765%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.722656"
            style={{
              stopColor: 'rgb(69.019608%,68.235294%,68.235294%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.726563"
            style={{
              stopColor: 'rgb(67.843137%,67.058824%,67.058824%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.730469"
            style={{
              stopColor: 'rgb(66.666667%,65.882353%,65.882353%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.734375"
            style={{
              stopColor: 'rgb(65.882353%,64.705882%,65.098039%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.738281"
            style={{
              stopColor: 'rgb(64.705882%,63.529412%,63.921569%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.742188"
            style={{
              stopColor: 'rgb(63.529412%,62.745098%,62.745098%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.746094"
            style={{
              stopColor: 'rgb(62.352941%,61.568627%,61.568627%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.75"
            style={{
              stopColor: 'rgb(61.176471%,60.392157%,60.392157%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.753906"
            style={{
              stopColor: 'rgb(60%,59.215686%,59.215686%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.757813"
            style={{
              stopColor: 'rgb(58.823529%,58.039216%,58.039216%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.761719"
            style={{
              stopColor: 'rgb(57.647059%,56.862745%,56.862745%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.765625"
            style={{
              stopColor: 'rgb(56.470588%,55.686275%,55.686275%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.769531"
            style={{
              stopColor: 'rgb(55.294118%,54.901961%,54.509804%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.773438"
            style={{
              stopColor: 'rgb(54.509804%,53.72549%,53.72549%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.777344"
            style={{
              stopColor: 'rgb(53.333333%,52.54902%,52.54902%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.78125"
            style={{
              stopColor: 'rgb(52.156863%,51.372549%,51.372549%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.785156"
            style={{
              stopColor: 'rgb(50.980392%,50.196078%,50.196078%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.789063"
            style={{
              stopColor: 'rgb(49.803922%,49.019608%,49.019608%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.792969"
            style={{
              stopColor: 'rgb(48.627451%,48.235294%,47.843137%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.796875"
            style={{
              stopColor: 'rgb(47.45098%,47.058824%,46.666667%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.800781"
            style={{
              stopColor: 'rgb(46.27451%,45.882353%,45.490196%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.804688"
            style={{
              stopColor: 'rgb(45.098039%,44.705882%,44.313725%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.808594"
            style={{
              stopColor: 'rgb(44.313725%,43.529412%,43.529412%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.8125"
            style={{
              stopColor: 'rgb(43.137255%,42.352941%,42.352941%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.816406"
            style={{
              stopColor: 'rgb(41.960784%,41.176471%,41.176471%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.820313"
            style={{
              stopColor: 'rgb(40.784314%,40.392157%,40%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.824219"
            style={{
              stopColor: 'rgb(39.607843%,39.215686%,38.823529%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.828125"
            style={{
              stopColor: 'rgb(38.431373%,38.039216%,37.647059%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.832031"
            style={{
              stopColor: 'rgb(37.254902%,36.862745%,36.470588%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.835938"
            style={{
              stopColor: 'rgb(36.078431%,35.686275%,35.294118%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.839844"
            style={{
              stopColor: 'rgb(36.470588%,36.078431%,35.686275%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.84375"
            style={{
              stopColor: 'rgb(36.862745%,36.470588%,36.078431%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.847656"
            style={{
              stopColor: 'rgb(37.254902%,36.862745%,36.470588%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.851563"
            style={{
              stopColor: 'rgb(37.647059%,37.647059%,37.254902%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.855469"
            style={{
              stopColor: 'rgb(38.431373%,38.039216%,37.647059%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.859375"
            style={{
              stopColor: 'rgb(38.823529%,38.431373%,38.039216%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.863281"
            style={{
              stopColor: 'rgb(39.215686%,38.823529%,38.431373%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.867188"
            style={{
              stopColor: 'rgb(39.607843%,39.215686%,38.823529%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.871094"
            style={{
              stopColor: 'rgb(40%,39.607843%,39.607843%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.875"
            style={{
              stopColor: 'rgb(40.392157%,40.392157%,40%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.878906"
            style={{
              stopColor: 'rgb(40.784314%,40.784314%,40.392157%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.882813"
            style={{
              stopColor: 'rgb(41.568627%,41.176471%,40.784314%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.886719"
            style={{
              stopColor: 'rgb(41.960784%,41.568627%,41.176471%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.890625"
            style={{
              stopColor: 'rgb(42.352941%,41.960784%,41.960784%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.894531"
            style={{
              stopColor: 'rgb(42.745098%,42.352941%,42.352941%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.898438"
            style={{
              stopColor: 'rgb(43.137255%,43.137255%,42.745098%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.902344"
            style={{
              stopColor: 'rgb(43.529412%,43.529412%,43.137255%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.90625"
            style={{
              stopColor: 'rgb(44.313725%,43.921569%,43.529412%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.910156"
            style={{
              stopColor: 'rgb(44.705882%,44.313725%,44.313725%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.914063"
            style={{
              stopColor: 'rgb(45.098039%,44.705882%,44.705882%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.917969"
            style={{
              stopColor: 'rgb(45.490196%,45.098039%,45.098039%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.921875"
            style={{
              stopColor: 'rgb(45.882353%,45.882353%,45.490196%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.925781"
            style={{
              stopColor: 'rgb(46.27451%,46.27451%,45.882353%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.929688"
            style={{
              stopColor: 'rgb(46.666667%,46.666667%,46.666667%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.933594"
            style={{
              stopColor: 'rgb(47.45098%,47.058824%,47.058824%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.9375"
            style={{
              stopColor: 'rgb(47.843137%,47.45098%,47.45098%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.941406"
            style={{
              stopColor: 'rgb(48.235294%,47.843137%,47.843137%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.945312"
            style={{
              stopColor: 'rgb(48.627451%,48.627451%,48.235294%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.949219"
            style={{
              stopColor: 'rgb(49.019608%,49.019608%,48.627451%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.953125"
            style={{
              stopColor: 'rgb(49.411765%,49.411765%,49.411765%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.957031"
            style={{
              stopColor: 'rgb(49.803922%,49.803922%,49.803922%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.960937"
            style={{
              stopColor: 'rgb(50.588235%,50.196078%,50.196078%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.964844"
            style={{
              stopColor: 'rgb(50.980392%,50.588235%,50.588235%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.96875"
            style={{
              stopColor: 'rgb(51.372549%,51.372549%,50.980392%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.972656"
            style={{
              stopColor: 'rgb(51.764706%,51.764706%,51.764706%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.976563"
            style={{
              stopColor: 'rgb(52.156863%,52.156863%,52.156863%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.980469"
            style={{
              stopColor: 'rgb(52.54902%,52.54902%,52.54902%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.984375"
            style={{
              stopColor: 'rgb(52.941176%,52.941176%,52.941176%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.988281"
            style={{
              stopColor: 'rgb(53.72549%,53.333333%,53.333333%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.992188"
            style={{
              stopColor: 'rgb(54.117647%,54.117647%,54.117647%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="0.996094"
            style={{
              stopColor: 'rgb(54.509804%,54.509804%,54.509804%)',
              stopOpacity: 1,
            }}
          />
          <stop
            offset="1"
            style={{
              stopColor: 'rgb(54.901961%,54.901961%,54.901961%)',
              stopOpacity: 1,
            }}
          />
        </linearGradient>
      </defs>
      <g id="surface1">
        <g clip-path="url(#clip1)" clip-rule="nonzero">
          <path
            style={{
              stroke: 'none',
              fillRule: 'nonzero',
              fill: 'rgb(29.411765%,28.235294%,27.45098%)',
              fillOpacity: 1,
            }}
            d="M 14.675781 12.960938 C 14.675781 13.429688 14.089844 13.984375 13.59375 13.984375 L 1.035156 13.984375 C 0.539062 13.984375 0 13.472656 0 13.003906 L 0 1.15625 C 0 0.5 0.667969 0.0273438 1.230469 0.0273438 L 13.59375 0 C 14.089844 0 14.675781 0.550781 14.675781 1.019531 "
          />
        </g>
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(30.588235%,34.509804%,35.686275%)',
            fillOpacity: 1,
          }}
          d="M 13.980469 11.675781 C 13.980469 12.410156 13.347656 13.007812 12.570312 13.007812 L 2.457031 13.007812 C 1.675781 13.007812 1.046875 12.410156 1.046875 11.675781 L 1.046875 2.253906 C 1.046875 1.515625 1.675781 0.917969 2.457031 0.917969 L 12.570312 0.917969 C 13.347656 0.917969 13.980469 1.515625 13.980469 2.253906 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(47.058824%,49.411765%,50.196078%)',
            fillOpacity: 1,
          }}
          d="M 13.980469 5.507812 C 13.679688 5.929688 9.546875 6.300781 8.765625 6.300781 L 5.734375 6.300781 C 4.957031 6.300781 1.933594 6.1875 1.046875 5.597656 L 1.046875 2.253906 C 1.046875 1.515625 1.675781 0.917969 2.457031 0.917969 L 12.570312 0.917969 C 13.347656 0.917969 13.980469 1.515625 13.980469 2.253906 "
        />
        <g clip-path="url(#clip2)" clip-rule="nonzero">
          <g clip-path="url(#clip3)" clip-rule="nonzero">
            <path
              style={{
                stroke: 'none',
                fillRule: 'nonzero',
                fill: 'url(#linear0)',
              }}
              d="M 0.316406 13.984375 L 14.992188 13.984375 L 14.992188 0 L 0.316406 0 Z M 0.316406 13.984375 "
            />
          </g>
        </g>
        <g clip-path="url(#clip4)" clip-rule="nonzero">
          <g clip-path="url(#clip5)" clip-rule="nonzero">
            <g clip-path="url(#clip6)" clip-rule="nonzero">
              <path
                style={{
                  stroke: 'none',
                  fillRule: 'nonzero',
                  fill: 'url(#linear1)',
                }}
                d="M 14.246094 0.679688 L 0.800781 0.679688 L 0.800781 13.246094 L 14.246094 13.246094 Z M 14.246094 0.679688 "
              />
            </g>
          </g>
        </g>
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(100%,100%,100%)',
            fillOpacity: 1,
          }}
          d="M 6.03125 9.433594 C 6.007812 9.433594 5.988281 9.433594 5.964844 9.433594 C 5.910156 9.433594 5.773438 9.441406 5.773438 9.539062 C 5.773438 9.597656 5.832031 9.628906 5.878906 9.628906 C 5.976562 9.628906 6.03125 9.566406 6.03125 9.484375 Z M 5.730469 9.1875 C 5.78125 9.15625 5.839844 9.136719 5.910156 9.136719 C 6.066406 9.136719 6.132812 9.214844 6.132812 9.363281 L 6.132812 9.589844 C 6.132812 9.652344 6.132812 9.679688 6.136719 9.695312 L 6.042969 9.695312 L 6.042969 9.625 L 6.039062 9.625 C 6.015625 9.660156 5.972656 9.710938 5.878906 9.710938 C 5.761719 9.710938 5.699219 9.65625 5.699219 9.539062 C 5.699219 9.402344 5.835938 9.359375 5.941406 9.359375 C 5.980469 9.359375 5.992188 9.359375 6.03125 9.359375 C 6.03125 9.265625 5.996094 9.21875 5.894531 9.21875 C 5.835938 9.21875 5.777344 9.238281 5.734375 9.273438 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(100%,100%,100%)',
            fillOpacity: 1,
          }}
          d="M 9.816406 9.4375 C 9.796875 9.4375 9.773438 9.433594 9.753906 9.433594 C 9.699219 9.433594 9.5625 9.441406 9.5625 9.539062 C 9.5625 9.597656 9.617188 9.628906 9.664062 9.628906 C 9.765625 9.628906 9.816406 9.566406 9.816406 9.484375 Z M 9.515625 9.1875 C 9.566406 9.160156 9.628906 9.136719 9.699219 9.136719 C 9.855469 9.136719 9.917969 9.214844 9.917969 9.363281 L 9.917969 9.589844 C 9.917969 9.652344 9.921875 9.679688 9.921875 9.699219 L 9.828125 9.699219 L 9.828125 9.625 C 9.804688 9.660156 9.761719 9.710938 9.667969 9.710938 C 9.550781 9.710938 9.484375 9.660156 9.484375 9.539062 C 9.484375 9.402344 9.625 9.359375 9.730469 9.359375 C 9.769531 9.359375 9.777344 9.359375 9.816406 9.363281 C 9.816406 9.265625 9.785156 9.21875 9.683594 9.21875 C 9.625 9.21875 9.5625 9.242188 9.523438 9.273438 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(100%,100%,100%)',
            fillOpacity: 1,
          }}
          d="M 12.648438 9.4375 C 12.625 9.4375 12.605469 9.433594 12.582031 9.433594 C 12.527344 9.433594 12.390625 9.441406 12.390625 9.539062 C 12.390625 9.597656 12.449219 9.628906 12.496094 9.628906 C 12.59375 9.628906 12.648438 9.566406 12.648438 9.484375 Z M 12.347656 9.1875 C 12.398438 9.160156 12.457031 9.136719 12.527344 9.136719 C 12.683594 9.136719 12.75 9.214844 12.75 9.363281 L 12.75 9.589844 C 12.75 9.652344 12.75 9.679688 12.753906 9.699219 L 12.660156 9.699219 L 12.660156 9.625 L 12.65625 9.625 C 12.632812 9.660156 12.589844 9.710938 12.496094 9.710938 C 12.378906 9.710938 12.316406 9.660156 12.316406 9.539062 C 12.316406 9.402344 12.453125 9.359375 12.558594 9.359375 C 12.597656 9.359375 12.609375 9.359375 12.648438 9.363281 C 12.648438 9.265625 12.613281 9.21875 12.511719 9.21875 C 12.453125 9.21875 12.394531 9.242188 12.351562 9.273438 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(100%,100%,100%)',
            fillOpacity: 1,
          }}
          d="M 3.902344 7.695312 C 4.207031 7.695312 4.425781 7.582031 4.554688 7.421875 C 4.636719 7.320312 4.679688 7.195312 4.679688 7.050781 C 4.679688 6.808594 4.558594 6.644531 4.320312 6.554688 C 4.191406 6.507812 4.023438 6.445312 3.816406 6.445312 L 2.824219 6.445312 L 2.824219 7.695312 Z M 3.734375 6.117188 C 3.945312 6.117188 4.109375 6.089844 4.226562 6.035156 C 4.410156 5.953125 4.546875 5.800781 4.546875 5.585938 C 4.546875 5.367188 4.402344 5.191406 4.207031 5.117188 C 4.097656 5.074219 3.933594 5.050781 3.714844 5.050781 L 2.824219 5.050781 L 2.824219 6.117188 Z M 2.339844 4.699219 L 3.917969 4.699219 C 4.347656 4.699219 4.710938 4.816406 4.894531 5.050781 C 5 5.1875 5.054688 5.347656 5.054688 5.53125 C 5.054688 5.742188 4.914062 5.945312 4.78125 6.082031 C 4.714844 6.152344 4.558594 6.21875 4.429688 6.277344 C 4.617188 6.34375 4.757812 6.417969 4.851562 6.5 C 5.015625 6.644531 5.175781 6.816406 5.175781 7.074219 C 5.175781 7.289062 5.101562 7.484375 4.953125 7.660156 C 4.730469 7.921875 4.375 8.050781 3.890625 8.050781 L 2.339844 8.050781 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(100%,100%,100%)',
            fillOpacity: 1,
          }}
          d="M 6.191406 5.621094 L 6.191406 7.164062 C 6.191406 7.292969 6.214844 7.398438 6.257812 7.476562 C 6.332031 7.628906 6.476562 7.703125 6.691406 7.703125 C 6.992188 7.703125 7.414062 7.5 7.414062 7.359375 C 7.414062 7.167969 7.414062 6.976562 7.414062 6.730469 L 7.414062 5.621094 L 7.894531 5.621094 L 7.894531 8.035156 L 7.4375 8.035156 L 7.441406 7.636719 C 7.386719 7.734375 7.300781 7.816406 7.21875 7.878906 C 7.050781 8.011719 6.847656 8.078125 6.605469 8.078125 C 6.234375 8.078125 5.980469 7.957031 5.84375 7.71875 C 5.773438 7.589844 5.734375 7.417969 5.734375 7.203125 L 5.734375 5.621094 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(100%,100%,100%)',
            fillOpacity: 1,
          }}
          d="M 8.78125 5.589844 L 9.207031 5.589844 L 9.207031 6.023438 C 9.242188 5.9375 9.371094 5.835938 9.507812 5.714844 C 9.644531 5.59375 9.800781 5.53125 9.976562 5.53125 C 9.984375 5.53125 10 5.535156 10.019531 5.535156 C 10.039062 5.535156 10.074219 5.539062 10.121094 5.542969 L 10.121094 5.992188 C 10.09375 5.984375 10.070312 5.984375 10.046875 5.980469 C 10.027344 5.980469 10 5.980469 9.976562 5.980469 C 9.75 5.980469 9.574219 6.046875 9.457031 6.183594 C 9.335938 6.320312 9.269531 6.480469 9.269531 6.660156 L 9.269531 8.050781 L 8.78125 8.050781 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(100%,100%,100%)',
            fillOpacity: 1,
          }}
          d="M 12.195312 7.441406 C 12.078125 7.644531 11.867188 7.75 11.558594 7.75 C 11.277344 7.75 11.070312 7.664062 10.941406 7.488281 C 10.808594 7.316406 10.746094 7.097656 10.746094 6.839844 C 10.746094 6.566406 10.808594 6.335938 10.941406 6.144531 C 11.070312 5.953125 11.277344 5.859375 11.5625 5.859375 C 11.882812 5.859375 12.109375 5.96875 12.242188 6.195312 C 12.324219 6.339844 12.367188 6.523438 12.367188 6.753906 C 12.367188 7.003906 12.308594 7.234375 12.195312 7.441406 M 12.488281 5.8125 C 12.238281 5.605469 11.933594 5.5 11.574219 5.5 C 11.175781 5.5 10.855469 5.621094 10.617188 5.863281 C 10.378906 6.109375 10.261719 6.433594 10.261719 6.847656 C 10.261719 7.230469 10.375 7.535156 10.597656 7.761719 C 10.824219 7.988281 11.128906 8.105469 11.511719 8.105469 C 11.972656 8.105469 12.3125 7.976562 12.53125 7.71875 C 12.75 7.460938 12.859375 7.136719 12.859375 6.742188 C 12.859375 6.332031 12.734375 6.023438 12.488281 5.8125 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(100%,100%,100%)',
            fillOpacity: 1,
          }}
          d="M 12.273438 4.5 L 11.507812 5.308594 L 11.167969 5.308594 L 11.71875 4.5 Z M 12.273438 4.5 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(100%,100%,100%)',
            fillOpacity: 1,
          }}
          d="M 2.050781 9.625 C 2.0625 9.625 2.078125 9.625 2.09375 9.625 C 2.109375 9.621094 2.125 9.617188 2.144531 9.609375 C 2.164062 9.605469 2.183594 9.59375 2.199219 9.582031 C 2.21875 9.570312 2.234375 9.550781 2.25 9.53125 C 2.261719 9.507812 2.273438 9.480469 2.285156 9.449219 C 2.292969 9.417969 2.296875 9.378906 2.296875 9.332031 C 2.296875 9.285156 2.292969 9.246094 2.285156 9.210938 C 2.277344 9.175781 2.261719 9.144531 2.242188 9.121094 C 2.222656 9.09375 2.199219 9.078125 2.167969 9.0625 C 2.136719 9.050781 2.097656 9.042969 2.054688 9.042969 L 1.890625 9.042969 L 1.890625 9.625 Z M 2.042969 8.960938 C 2.15625 8.960938 2.242188 8.988281 2.304688 9.046875 C 2.363281 9.105469 2.394531 9.195312 2.394531 9.316406 C 2.394531 9.378906 2.386719 9.4375 2.375 9.484375 C 2.359375 9.535156 2.339844 9.574219 2.3125 9.609375 C 2.28125 9.640625 2.246094 9.667969 2.203125 9.683594 C 2.15625 9.703125 2.105469 9.710938 2.042969 9.710938 L 1.792969 9.710938 L 1.792969 8.960938 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(100%,100%,100%)',
            fillOpacity: 1,
          }}
          d="M 2.796875 9.367188 C 2.796875 9.296875 2.761719 9.230469 2.671875 9.230469 C 2.585938 9.230469 2.539062 9.289062 2.523438 9.367188 Z M 2.417969 9.429688 C 2.417969 9.273438 2.523438 9.15625 2.671875 9.15625 C 2.8125 9.15625 2.898438 9.25 2.898438 9.398438 C 2.898438 9.410156 2.894531 9.425781 2.894531 9.4375 L 2.523438 9.4375 C 2.523438 9.542969 2.570312 9.632812 2.691406 9.632812 C 2.769531 9.632812 2.820312 9.601562 2.84375 9.589844 L 2.882812 9.65625 C 2.851562 9.675781 2.789062 9.710938 2.6875 9.710938 C 2.507812 9.710938 2.417969 9.589844 2.417969 9.429688 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(100%,100%,100%)',
            fillOpacity: 1,
          }}
          d="M 7.132812 9.367188 C 7.128906 9.296875 7.09375 9.230469 7.003906 9.230469 C 6.917969 9.230469 6.871094 9.289062 6.859375 9.367188 Z M 6.75 9.429688 C 6.75 9.273438 6.855469 9.15625 7.007812 9.15625 C 7.148438 9.15625 7.230469 9.25 7.230469 9.398438 C 7.230469 9.410156 7.230469 9.425781 7.226562 9.4375 L 6.855469 9.4375 C 6.859375 9.542969 6.90625 9.632812 7.023438 9.632812 C 7.101562 9.632812 7.152344 9.601562 7.175781 9.589844 L 7.214844 9.65625 C 7.183594 9.675781 7.125 9.710938 7.019531 9.710938 C 6.839844 9.710938 6.75 9.589844 6.75 9.429688 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(100%,100%,100%)',
            fillOpacity: 1,
          }}
          d="M 11.785156 9.367188 C 11.78125 9.296875 11.75 9.230469 11.65625 9.230469 C 11.574219 9.230469 11.527344 9.289062 11.511719 9.367188 Z M 11.402344 9.429688 C 11.402344 9.273438 11.511719 9.15625 11.660156 9.15625 C 11.800781 9.15625 11.882812 9.25 11.882812 9.398438 C 11.882812 9.410156 11.882812 9.425781 11.882812 9.4375 L 11.507812 9.4375 C 11.511719 9.542969 11.558594 9.632812 11.679688 9.632812 C 11.753906 9.632812 11.804688 9.601562 11.832031 9.589844 L 11.867188 9.65625 C 11.839844 9.675781 11.777344 9.710938 11.675781 9.710938 C 11.496094 9.710938 11.402344 9.589844 11.402344 9.429688 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(100%,100%,100%)',
            fillOpacity: 1,
          }}
          d="M 3.328125 8.953125 L 3.742188 8.953125 L 3.742188 9.042969 L 3.425781 9.042969 L 3.425781 9.269531 L 3.722656 9.269531 L 3.722656 9.355469 L 3.425781 9.355469 L 3.425781 9.628906 L 3.761719 9.628906 L 3.761719 9.703125 L 3.328125 9.703125 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(100%,100%,100%)',
            fillOpacity: 1,
          }}
          d="M 3.863281 9.164062 L 3.964844 9.164062 L 3.964844 9.238281 C 4.015625 9.179688 4.082031 9.148438 4.15625 9.148438 C 4.28125 9.148438 4.332031 9.226562 4.332031 9.320312 L 4.332031 9.703125 L 4.226562 9.703125 L 4.226562 9.339844 C 4.226562 9.273438 4.203125 9.234375 4.128906 9.234375 C 4.0625 9.234375 4.003906 9.277344 3.964844 9.324219 L 3.964844 9.703125 L 3.863281 9.703125 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(100%,100%,100%)',
            fillOpacity: 1,
          }}
          d="M 8.90625 9.164062 L 9.011719 9.164062 L 9.011719 9.238281 C 9.058594 9.179688 9.125 9.148438 9.199219 9.148438 C 9.328125 9.148438 9.375 9.226562 9.375 9.320312 L 9.375 9.703125 L 9.269531 9.703125 L 9.269531 9.339844 C 9.269531 9.273438 9.246094 9.234375 9.171875 9.234375 C 9.109375 9.234375 9.050781 9.277344 9.011719 9.324219 L 9.011719 9.703125 L 8.90625 9.703125 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(100%,100%,100%)',
            fillOpacity: 1,
          }}
          d="M 10.0625 9.164062 L 10.167969 9.164062 L 10.167969 9.238281 C 10.21875 9.179688 10.285156 9.148438 10.359375 9.148438 C 10.484375 9.148438 10.53125 9.226562 10.53125 9.320312 L 10.53125 9.703125 L 10.429688 9.703125 L 10.429688 9.339844 C 10.429688 9.273438 10.402344 9.234375 10.328125 9.234375 C 10.265625 9.234375 10.207031 9.277344 10.167969 9.324219 L 10.167969 9.703125 L 10.0625 9.703125 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(100%,100%,100%)',
            fillOpacity: 1,
          }}
          d="M 4.738281 9.164062 L 4.738281 9.242188 L 4.589844 9.242188 L 4.589844 9.582031 C 4.589844 9.589844 4.589844 9.597656 4.59375 9.605469 C 4.59375 9.613281 4.597656 9.617188 4.601562 9.621094 C 4.605469 9.625 4.613281 9.625 4.621094 9.628906 C 4.628906 9.628906 4.640625 9.628906 4.65625 9.628906 L 4.738281 9.628906 L 4.738281 9.707031 L 4.628906 9.707031 C 4.605469 9.707031 4.585938 9.707031 4.570312 9.703125 C 4.554688 9.699219 4.542969 9.695312 4.53125 9.683594 C 4.523438 9.675781 4.515625 9.664062 4.511719 9.648438 C 4.503906 9.632812 4.503906 9.613281 4.503906 9.589844 L 4.503906 9.242188 L 4.414062 9.242188 L 4.414062 9.164062 L 4.503906 9.164062 L 4.503906 8.949219 L 4.589844 8.949219 L 4.589844 9.164062 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(100%,100%,100%)',
            fillOpacity: 1,
          }}
          d="M 4.847656 9.15625 L 4.945312 9.15625 L 4.945312 9.703125 L 4.847656 9.703125 Z M 4.828125 9 C 4.828125 8.960938 4.859375 8.933594 4.894531 8.933594 C 4.933594 8.933594 4.960938 8.960938 4.960938 9 C 4.960938 9.035156 4.933594 9.0625 4.894531 9.0625 C 4.859375 9.0625 4.828125 9.035156 4.828125 9 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(100%,100%,100%)',
            fillOpacity: 1,
          }}
          d="M 8.652344 9.15625 L 8.75 9.15625 L 8.75 9.703125 L 8.652344 9.703125 Z M 8.636719 9 C 8.636719 8.960938 8.664062 8.933594 8.703125 8.933594 C 8.738281 8.933594 8.765625 8.960938 8.765625 9 C 8.765625 9.035156 8.738281 9.0625 8.703125 9.0625 C 8.664062 9.0625 8.636719 9.035156 8.636719 9 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(100%,100%,100%)',
            fillOpacity: 1,
          }}
          d="M 11.183594 9.15625 L 11.28125 9.15625 L 11.28125 9.703125 L 11.183594 9.703125 Z M 11.164062 9 C 11.164062 8.960938 11.195312 8.933594 11.230469 8.933594 C 11.269531 8.933594 11.296875 8.960938 11.296875 9 C 11.296875 9.035156 11.269531 9.0625 11.230469 9.0625 C 11.195312 9.0625 11.164062 9.035156 11.164062 9 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(100%,100%,100%)',
            fillOpacity: 1,
          }}
          d="M 5.179688 9.507812 C 5.1875 9.53125 5.195312 9.550781 5.210938 9.570312 C 5.222656 9.589844 5.238281 9.605469 5.261719 9.617188 C 5.28125 9.628906 5.304688 9.632812 5.332031 9.632812 C 5.363281 9.632812 5.386719 9.625 5.410156 9.613281 C 5.429688 9.601562 5.445312 9.585938 5.457031 9.566406 C 5.472656 9.546875 5.480469 9.527344 5.488281 9.503906 C 5.492188 9.476562 5.496094 9.453125 5.496094 9.425781 C 5.496094 9.402344 5.492188 9.375 5.484375 9.351562 C 5.480469 9.324219 5.46875 9.304688 5.457031 9.285156 C 5.445312 9.265625 5.425781 9.25 5.40625 9.238281 C 5.382812 9.226562 5.359375 9.222656 5.328125 9.222656 C 5.300781 9.222656 5.273438 9.226562 5.253906 9.238281 C 5.234375 9.25 5.21875 9.265625 5.207031 9.285156 C 5.191406 9.304688 5.183594 9.328125 5.179688 9.355469 C 5.171875 9.378906 5.171875 9.40625 5.171875 9.433594 C 5.171875 9.457031 5.171875 9.480469 5.179688 9.507812 M 5.492188 9.699219 L 5.492188 9.625 C 5.476562 9.65625 5.453125 9.675781 5.421875 9.691406 C 5.390625 9.703125 5.359375 9.710938 5.320312 9.710938 C 5.28125 9.710938 5.246094 9.703125 5.214844 9.6875 C 5.183594 9.671875 5.160156 9.652344 5.140625 9.625 C 5.117188 9.597656 5.105469 9.570312 5.09375 9.535156 C 5.082031 9.5 5.078125 9.464844 5.078125 9.425781 C 5.078125 9.386719 5.082031 9.351562 5.09375 9.316406 C 5.101562 9.28125 5.117188 9.25 5.136719 9.226562 C 5.160156 9.199219 5.183594 9.179688 5.214844 9.164062 C 5.242188 9.148438 5.277344 9.144531 5.320312 9.144531 C 5.332031 9.144531 5.347656 9.144531 5.363281 9.148438 C 5.378906 9.148438 5.394531 9.15625 5.410156 9.160156 C 5.425781 9.167969 5.441406 9.175781 5.453125 9.1875 C 5.46875 9.199219 5.480469 9.210938 5.492188 9.226562 L 5.492188 8.902344 L 5.578125 8.902344 L 5.578125 9.699219 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(100%,100%,100%)',
            fillOpacity: 1,
          }}
          d="M 6.28125 9.507812 C 6.289062 9.53125 6.296875 9.550781 6.3125 9.570312 C 6.324219 9.589844 6.339844 9.605469 6.363281 9.617188 C 6.382812 9.628906 6.40625 9.632812 6.4375 9.632812 C 6.464844 9.632812 6.488281 9.625 6.511719 9.613281 C 6.53125 9.601562 6.546875 9.585938 6.558594 9.566406 C 6.574219 9.546875 6.582031 9.527344 6.589844 9.503906 C 6.59375 9.476562 6.597656 9.453125 6.597656 9.425781 C 6.597656 9.402344 6.59375 9.375 6.589844 9.351562 C 6.582031 9.324219 6.570312 9.304688 6.558594 9.285156 C 6.546875 9.265625 6.527344 9.25 6.507812 9.238281 C 6.484375 9.226562 6.460938 9.222656 6.429688 9.222656 C 6.402344 9.222656 6.375 9.226562 6.355469 9.238281 C 6.335938 9.25 6.320312 9.265625 6.308594 9.285156 C 6.292969 9.304688 6.285156 9.328125 6.28125 9.355469 C 6.273438 9.378906 6.273438 9.40625 6.273438 9.433594 C 6.273438 9.457031 6.273438 9.480469 6.28125 9.507812 M 6.59375 9.699219 L 6.59375 9.625 C 6.578125 9.65625 6.554688 9.675781 6.523438 9.691406 C 6.492188 9.703125 6.460938 9.710938 6.421875 9.710938 C 6.382812 9.710938 6.347656 9.703125 6.316406 9.6875 C 6.285156 9.671875 6.261719 9.652344 6.242188 9.625 C 6.222656 9.597656 6.207031 9.570312 6.195312 9.535156 C 6.183594 9.5 6.179688 9.464844 6.179688 9.425781 C 6.179688 9.386719 6.183594 9.351562 6.195312 9.316406 C 6.203125 9.28125 6.21875 9.25 6.238281 9.226562 C 6.261719 9.199219 6.285156 9.179688 6.316406 9.164062 C 6.347656 9.148438 6.382812 9.144531 6.421875 9.144531 C 6.433594 9.144531 6.449219 9.144531 6.464844 9.148438 C 6.480469 9.148438 6.496094 9.15625 6.511719 9.160156 C 6.527344 9.167969 6.542969 9.175781 6.554688 9.1875 C 6.570312 9.199219 6.582031 9.210938 6.59375 9.226562 L 6.59375 8.902344 L 6.679688 8.902344 L 6.679688 9.699219 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(100%,100%,100%)',
            fillOpacity: 1,
          }}
          d="M 7.28125 9.660156 L 7.320312 9.589844 C 7.339844 9.605469 7.390625 9.632812 7.453125 9.632812 C 7.519531 9.632812 7.5625 9.609375 7.5625 9.5625 C 7.5625 9.515625 7.515625 9.5 7.4375 9.464844 C 7.355469 9.429688 7.292969 9.390625 7.292969 9.304688 C 7.292969 9.21875 7.363281 9.15625 7.472656 9.15625 C 7.5625 9.15625 7.617188 9.191406 7.632812 9.203125 L 7.59375 9.269531 C 7.574219 9.257812 7.53125 9.230469 7.472656 9.230469 C 7.414062 9.230469 7.386719 9.257812 7.386719 9.300781 C 7.386719 9.347656 7.429688 9.363281 7.492188 9.390625 C 7.578125 9.425781 7.65625 9.460938 7.65625 9.550781 C 7.65625 9.648438 7.578125 9.710938 7.457031 9.710938 C 7.375 9.710938 7.316406 9.683594 7.28125 9.660156 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(100%,100%,100%)',
            fillOpacity: 1,
          }}
          d="M 12.855469 9.660156 L 12.894531 9.589844 C 12.914062 9.605469 12.964844 9.632812 13.027344 9.632812 C 13.09375 9.632812 13.132812 9.609375 13.132812 9.5625 C 13.132812 9.515625 13.089844 9.5 13.011719 9.464844 C 12.929688 9.429688 12.867188 9.390625 12.867188 9.304688 C 12.867188 9.21875 12.9375 9.15625 13.046875 9.15625 C 13.136719 9.15625 13.191406 9.191406 13.207031 9.203125 L 13.167969 9.269531 C 13.148438 9.257812 13.105469 9.230469 13.046875 9.230469 C 12.988281 9.230469 12.960938 9.257812 12.960938 9.300781 C 12.960938 9.347656 13.003906 9.363281 13.066406 9.390625 C 13.152344 9.425781 13.230469 9.460938 13.230469 9.550781 C 13.230469 9.648438 13.152344 9.710938 13.03125 9.710938 C 12.949219 9.710938 12.890625 9.683594 12.855469 9.660156 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(100%,100%,100%)',
            fillOpacity: 1,
          }}
          d="M 8.140625 8.941406 L 8.539062 8.941406 L 8.539062 9.027344 L 8.242188 9.027344 L 8.242188 9.28125 L 8.527344 9.28125 L 8.527344 9.363281 L 8.242188 9.363281 L 8.242188 9.703125 L 8.140625 9.703125 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(100%,100%,100%)',
            fillOpacity: 1,
          }}
          d="M 10.945312 9.234375 C 10.921875 9.214844 10.894531 9.203125 10.859375 9.203125 C 10.828125 9.203125 10.800781 9.210938 10.777344 9.222656 C 10.757812 9.234375 10.742188 9.25 10.726562 9.273438 C 10.714844 9.292969 10.707031 9.316406 10.699219 9.34375 C 10.695312 9.367188 10.691406 9.394531 10.691406 9.425781 C 10.691406 9.449219 10.695312 9.476562 10.703125 9.5 C 10.707031 9.523438 10.714844 9.546875 10.730469 9.566406 C 10.742188 9.585938 10.757812 9.601562 10.777344 9.613281 C 10.796875 9.625 10.820312 9.628906 10.847656 9.628906 C 10.890625 9.628906 10.925781 9.617188 10.949219 9.59375 C 10.972656 9.570312 10.988281 9.535156 10.992188 9.492188 L 11.082031 9.492188 C 11.070312 9.5625 11.046875 9.617188 11.007812 9.652344 C 10.96875 9.691406 10.914062 9.710938 10.847656 9.710938 C 10.808594 9.710938 10.773438 9.703125 10.742188 9.691406 C 10.710938 9.675781 10.683594 9.65625 10.664062 9.632812 C 10.644531 9.605469 10.628906 9.574219 10.617188 9.539062 C 10.605469 9.503906 10.601562 9.464844 10.601562 9.425781 C 10.601562 9.382812 10.605469 9.34375 10.617188 9.304688 C 10.625 9.269531 10.640625 9.238281 10.664062 9.210938 C 10.683594 9.183594 10.710938 9.160156 10.742188 9.144531 C 10.773438 9.128906 10.808594 9.121094 10.851562 9.121094 C 10.878906 9.121094 10.910156 9.125 10.933594 9.132812 C 10.960938 9.140625 10.984375 9.152344 11.003906 9.167969 C 11.023438 9.183594 11.039062 9.207031 11.054688 9.230469 C 11.066406 9.253906 11.074219 9.28125 11.078125 9.316406 L 10.988281 9.316406 C 10.980469 9.28125 10.96875 9.253906 10.945312 9.234375 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(100%,100%,100%)',
            fillOpacity: 1,
          }}
          d="M 12.003906 9.160156 L 12.09375 9.160156 L 12.09375 9.253906 C 12.097656 9.234375 12.117188 9.210938 12.144531 9.1875 C 12.171875 9.160156 12.203125 9.144531 12.242188 9.144531 C 12.242188 9.144531 12.246094 9.148438 12.25 9.148438 C 12.253906 9.148438 12.261719 9.148438 12.269531 9.148438 L 12.269531 9.246094 C 12.265625 9.246094 12.257812 9.242188 12.253906 9.242188 C 12.25 9.242188 12.246094 9.242188 12.238281 9.242188 C 12.195312 9.242188 12.160156 9.257812 12.132812 9.289062 C 12.109375 9.316406 12.097656 9.351562 12.097656 9.390625 L 12.097656 9.703125 L 12.003906 9.703125 "
        />
        <path
          style={{
            stroke: 'none',
            fillRule: 'nonzero',
            fill: 'rgb(67.45098%,67.058824%,67.058824%)',
            fillOpacity: 1,
          }}
          d="M 1.632812 9.957031 L 13.5625 9.957031 L 13.5625 9.835938 L 1.632812 9.835938 Z M 1.632812 9.957031 "
        />
      </g>
    </SvgIcon>
  );
};

export default Buro2Icon;
